(function customBundleBuilderMvp() {
  const QUERY_KEY = 'bc_custom_builder_mvp';
  const FALLBACK_QUERY_KEY = 'bc_custom_builder_fallback';
  const SDK_URL = 'https://static.rechargecdn.com/assets/storefront/recharge-client-1.85.4.min.js';
  const BUNDLE_PENDING_ADD_EVENT = 'bc:bundle-cart-flow:pending-add';
  const BUNDLE_ADD_SUCCEEDED_EVENT = 'bc:bundle-cart-flow:add-succeeded';
  const BUNDLE_ADD_FAILED_EVENT = 'bc:bundle-cart-flow:add-failed';
  const BUNDLE_CART_FLOW_READY_EVENT = 'bc:bundle-cart-flow:ready';
  const BUNDLE_CART_FLOW_LOAD_TIMEOUT_MS = 8000;
  const CART_REQUEST_TIMEOUT_MS = 8000;
  const CART_VERIFICATION_REQUEST_TIMEOUT_MS = 2500;
  const BUNDLE_ADD_ANALYTICS_RETRY_MS = 250;
  const BUNDLE_ADD_ANALYTICS_TIMEOUT_MS = 4000;
  const CUSTOM_BUNDLE_DRAFT_SCHEMA_VERSION = 1;
  const CUSTOM_BUNDLE_DRAFT_FEATURE_VERSION = 'custom-mvp-1';
  const CUSTOM_BUNDLE_DRAFT_TTL_MS = 2 * 60 * 60 * 1000;
  const CUSTOM_BUNDLE_DRAFT_CHECKOUT_TTL_MS = 24 * 60 * 60 * 1000;
  const CUSTOM_BUNDLE_DRAFT_QUERY_KEY = 'bc_custom_bundle_draft';
  const FAMILY_PRESET_INTRO_SESSION_KEY = 'bcFamilyBundleIntroSeen:v1';
  const POSTCODE_AUTO_OPEN_QUERY_KEY = 'bc_open_postcode';
  const REWARD_PREVIEW_QUERY_KEY = 'bc_reward_preview';
  const REWARD_PREVIEW_STATE_QUERY_KEY = 'bc_reward_preview_state';
  // A/B fairness rule: keep visual/styling changes shared across these bundle
  // products. Only purchase-model behaviour should diverge between variants.
  const BUNDLE_PRODUCTS = {
    '/products/morning-bundle': {
      externalProductId: '14898247139704',
      externalVariantId: '54993340989816',
      shopifyHandle: 'morning-bundle',
      weeklySellingPlanId: 711808156024,
      purchaseModel: 'mixed',
    },
    '/products/weekend-bundle': {
      externalProductId: '15035600634232',
      externalVariantId: '55586563129720',
      shopifyHandle: 'weekend-bundle',
      weeklySellingPlanId: 712987804024,
      purchaseModel: 'mixed',
    },
  };
  const TARGET_PATHS = new Set(Object.keys(BUNDLE_PRODUCTS));
  const EMBED_MOUNT = document.querySelector('[data-bc-custom-bundle-mount]');
  const IS_EMBEDDED = EMBED_MOUNT instanceof HTMLElement;
  const BUNDLE_PRODUCT = getBundleProductConfig();
  const FIRST_ORDER_OFFER_ENABLED = (() => {
    if (BUNDLE_PRODUCT.shopifyHandle !== 'morning-bundle') return false;
    try {
      const value = String(new URLSearchParams(window.location.search || '').get('bc_first_order_offer') || '')
        .trim()
        .toLowerCase();
      return !['0', 'false', 'off', 'no', 'disabled'].includes(value);
    } catch (error) {
      return true;
    }
  })();
  const trackedBundleAnalyticsIds = new Set();
  const boundProductSelectionControls = new WeakSet();
  const CUSTOM_BUNDLE_DRAFT_STORAGE_KEY = `bcCustomBundleMvpDraft:v${CUSTOM_BUNDLE_DRAFT_SCHEMA_VERSION}:${BUNDLE_PRODUCT.shopifyHandle}`;
  const FAMILY_PRESET_ITEMS = [
    { externalProductId: '8404630470911', externalVariantId: '44869411635455', quantity: 1 },
    { externalProductId: '6755571171492', externalVariantId: '40098153234596', quantity: 1 },
    { externalProductId: '6755570942116', externalVariantId: '40098151563428', quantity: 1 },
    { externalProductId: '7949045825791', externalVariantId: '43777232240895', quantity: 1 },
    { externalProductId: '6755571237028', externalVariantId: '40098153660580', quantity: 1 },
    { externalProductId: '7046949404836', externalVariantId: '55322366476664', quantity: 1 },
    { externalProductId: '7046947438756', externalVariantId: '41709648773375', quantity: 1 },
    { externalProductId: '6755571269796', externalVariantId: '40098153791652', quantity: 1 },
    { externalProductId: '14932578861432', externalVariantId: '55153034789240', quantity: 1 },
    { externalProductId: '7452986245375', externalVariantId: '42071836164351', quantity: 1 },
  ];
  const COUPLES_PRESET_ITEMS = [
    { externalProductId: '8404630470911', externalVariantId: '44869411635455', quantity: 1 },
    { externalProductId: '7002869629092', externalVariantId: '41135087911076', quantity: 1 },
    { externalProductId: '6755570942116', externalVariantId: '40098151563428', quantity: 1 },
    { externalProductId: '7949045825791', externalVariantId: '43777232240895', quantity: 1 },
    { externalProductId: '6755571237028', externalVariantId: '40098153660580', quantity: 1 },
    { externalProductId: '7046949404836', externalVariantId: '55322366476664', quantity: 1 },
    { externalProductId: '7046947438756', externalVariantId: '41709648773375', quantity: 1 },
    { externalProductId: '14932578861432', externalVariantId: '55153034789240', quantity: 1 },
    { externalProductId: '7452986245375', externalVariantId: '42071836164351', quantity: 1 },
  ];
  const HOSTING_PRESET_ITEMS = [
    { externalProductId: '8404630470911', externalVariantId: '44869411635455', quantity: 1 },
    { externalProductId: '6755571171492', externalVariantId: '40098153234596', quantity: 1 },
    { externalProductId: '6755570942116', externalVariantId: '40098151563428', quantity: 1 },
    { externalProductId: '7949045825791', externalVariantId: '43777232240895', quantity: 1 },
    { externalProductId: '6755571237028', externalVariantId: '40098153660580', quantity: 1 },
    { externalProductId: '7046949404836', externalVariantId: '55322366476664', quantity: 1 },
    { externalProductId: '7046947438756', externalVariantId: '41709648773375', quantity: 1 },
    { externalProductId: '14932578861432', externalVariantId: '55153034789240', quantity: 2 },
    { externalProductId: '7452986245375', externalVariantId: '42071836164351', quantity: 2 },
    { externalProductId: '14917779227000', externalVariantId: '55071844041080', quantity: 1 },
    { externalProductId: '7759621161215', externalVariantId: '43196508930303', quantity: 1 },
  ];
  const PREBUILT_PRESETS = {
    'family-bundle': {
      id: 'family-bundle',
      items: FAMILY_PRESET_ITEMS,
      title: 'Your Family Bundle is ready',
      intro: 'We’ve pre-selected our family favourites. Keep it as it is, or add, remove or swap anything you like.',
      status: 'The Family Breakfast Bundle is ready. Change anything you like.',
    },
    'couples-bundle': {
      id: 'couples-bundle',
      items: COUPLES_PRESET_ITEMS,
      title: 'Your Couples Bundle is ready',
      intro: 'We’ve pre-selected a relaxed breakfast for two. Keep it as it is, or add, remove or swap anything you like.',
      status: 'The Couples Breakfast Bundle is ready. Change anything you like.',
    },
    'hosting-bundle': {
      id: 'hosting-bundle',
      items: HOSTING_PRESET_ITEMS,
      title: 'Your Hosting Bundle is ready',
      intro: 'We’ve pre-selected a generous breakfast for sharing. Keep it as it is, or add, remove or swap anything you like.',
      status: 'The Hosting Breakfast Bundle is ready. Change anything you like.',
    },
  };
  const REQUESTED_PREBUILT_PRESET = (() => {
    try {
      const id = String(new URLSearchParams(window.location.search || '').get('preset') || '').trim().toLowerCase();
      return PREBUILT_PRESETS[id] || null;
    } catch (error) {
      return null;
    }
  })();
  const REQUESTED_FAMILY_PRESET = REQUESTED_PREBUILT_PRESET?.id === 'family-bundle';
  const REQUESTED_FAMILY_PRESET_PURCHASE_MODE = (() => {
    try {
      return String(new URLSearchParams(window.location.search || '').get('purchase') || '')
        .trim()
        .toLowerCase() === 'one-time' ? 'onetime' : 'subscription';
    } catch (error) {
      return 'subscription';
    }
  })();
  const CATALOG_FALLBACK_DELAY_MS = 12000;
  const PRODUCT_SOURCE_SYNC_DEBOUNCE_MS = 120;
  const PRODUCT_SOURCE_OBSERVER_MAX_MS = 9000;
  const SDK_READY_TIMEOUT_MS = 8000;
  const MOBILE_CARD_ALIGNMENT_MAX_WIDTH = 480;
  const DEFAULT_COLLECTION_ID = '666799440248';
  const FALLBACK_COLLECTION_IDS_BY_CATEGORY = {
    'Bread & Bagels': '666799440248',
    'Pastries & Sweet Treats': '666592084344',
    Chilled: '666592051576',
    Pantry: '666592117112',
    Savoury: '670084891000',
    Juices: '666844365176',
  };
  const COLLECTION_PRODUCT_SOURCES = [
    { category: 'Bread & Bagels', collectionId: '666799440248', handle: 'bread-bagels' },
    { category: 'Pastries & Sweet Treats', collectionId: '666592084344', handle: 'pastries' },
    { category: 'Chilled', collectionId: '666592051576', handle: 'dairy-eggs' },
    { category: 'Pantry', collectionId: '666592117112', handle: 'pantry' },
    { category: 'Savoury', collectionId: '670084891000', handle: 'savoury' },
    { category: 'Juices', collectionId: '666844365176', handle: 'juices' },
  ];
  const BREAD_BAG_IMAGE_URL = 'https://hled.shop/cdn/shop/files/Butter_Crust_-_147.jpg?v=1763221865&width=200';
  const LOGO_IMAGE_URL = 'https://cdn.shopify.com/s/files/1/0463/6098/5764/files/logo_white.png?v=1714572863';
  const REWARD_PREVIEW_SKIPPED = 'skipped';
  const REWARD_CHOICE_SLOTS = [3000, 4000, 5000];
  const REWARD_PREVIEW_CHOICES = [
    {
      id: 'orzo',
      name: 'Antipasti Orzo Salad',
      short: 'Orzo Salad',
      price: '£7.20',
      productHandle: 'antipasti-orzo-salad',
      variantId: 55518881415544,
      image: 'https://cdn.shopify.com/s/files/1/0463/6098/5764/files/orzos.png?v=1781790019&width=200',
      description: 'Vintage cheddar, sun-dried tomatoes, olives, cornichons and Italian-style dressing.',
    },
    {
      id: 'yoghurt',
      name: 'Greek Yoghurt with Lemon, Blackcurrant & Granola',
      short: 'Yoghurt & Granola',
      price: '£4.95',
      productHandle: 'gfbreakfastpots',
      variantId: 55381728756088,
      image: 'https://cdn.shopify.com/s/files/1/0463/6098/5764/files/8_b49c1f1a-6a26-4343-819e-e7241e866f34.png?v=1781785790&width=200',
      description: 'Greek yoghurt, blackcurrant compote, lemon curd and oat granola.',
    },
    {
      id: 'oats',
      name: 'Dark Chocolate & Orange Overnight Oats',
      short: 'Chocolate Oats',
      price: '£4.95',
      productHandle: 'dark-chocolate-amp-orange-overnight-oats-pots',
      variantId: 55381741470072,
      image: 'https://cdn.shopify.com/s/files/1/0463/6098/5764/files/10_788bee25-ad2c-4f2f-9569-4942bd1e4fbc.png?v=1781785790&width=200',
      description: 'Dark chocolate overnight oats with orange marmalade, mandarins and cacao nibs.',
    },
    {
      id: 'hummus',
      name: 'Velvet Hummus',
      short: 'Velvet Hummus',
      price: '£6.50',
      productHandle: 'velvet-hummus',
      variantId: 55518646043000,
      image: 'https://cdn.shopify.com/s/files/1/0463/6098/5764/files/HUMMUS.png?v=1781795568&width=200',
      description: 'Smooth chickpea and tahini hummus finished with extra virgin olive oil and sumac.',
    },
    {
      id: 'spinach',
      name: 'Spinach, Garlic & Yoghurt',
      short: 'Spinach & Yoghurt',
      price: '£6.50',
      productHandle: 'the-spinach-one',
      variantId: 55518563303800,
      image: 'https://cdn.shopify.com/s/files/1/0463/6098/5764/files/The_spinnach_one_Close_Up.jpg?v=1775034480&width=200',
      description: 'Creamy spinach, garlic and yoghurt dip with a savoury depth and gentle tang.',
    },
  ];
  const REWARD_PREVIEW_CONCEPT = (() => {
    try {
      const value = String(new URLSearchParams(window.location.search || '').get(REWARD_PREVIEW_QUERY_KEY) || '')
        .trim()
        .toLowerCase();
      return ['orzo', 'mystery', 'choice'].includes(value) ? value : 'choice';
    } catch (error) {
      return 'choice';
    }
  })();
  const REWARD_PREVIEW_FORCE_UNLOCKED = (() => {
    try {
      const value = String(new URLSearchParams(window.location.search || '').get(REWARD_PREVIEW_STATE_QUERY_KEY) || '')
        .trim()
        .toLowerCase();
      return REWARD_PREVIEW_CONCEPT !== '' && ['1', 'true', 'on', 'unlocked'].includes(value);
    } catch (error) {
      return false;
    }
  })();

  function getBundleProductConfig() {
    const configuredPath = IS_EMBEDDED ? EMBED_MOUNT.dataset.bcBundleProductPath : '';
    const path = normalizePath(configuredPath || window.location.pathname);
    return BUNDLE_PRODUCTS[path] || BUNDLE_PRODUCTS['/products/morning-bundle'];
  }

  function isSubscriptionOnlyBundle() {
    return BUNDLE_PRODUCT.purchaseModel === 'subscription-only';
  }

  let rechargeSdkWarmupPromise = null;
  let collectionProductsPromise = null;
  let fallbackProductsHydrationPromise = null;
  let cartFlowLoadPromise = null;
  let builderCartSnapshotWarmupPromise = null;
  let latestBuilderCartSnapshot = null;
  let cardRowSyncFrame = 0;
  let productGridRefreshFrame = 0;
  let cartFabTopFrame = 0;
  let cartFabDockState = '';
  let initialBuilderHydrationComplete = !IS_EMBEDDED;
  let renderedProductGridMarkup = '';
  let frequencyOptions = [
    {
      label: 'Every week',
      sellingPlanId: BUNDLE_PRODUCT.weeklySellingPlanId,
    },
  ];
  let productSellingPlanSyncStarted = false;
  const PRODUCT_IMAGES = {
    seededSourdough: 'https://hled.shop/cdn/shop/files/1_fc3733c6-5546-4ad7-93fb-c9ac03c2909c_600x.png?v=1779375416',
    scandinavianRye: 'https://hled.shop/cdn/shop/files/2_51e73817-7afd-4407-a179-afe177f9ad03_600x.png?v=1779375434',
    signatureSourdough: 'https://hled.shop/cdn/shop/files/WEBSITEMISCIMAGESghj_30ef19ad-f4bd-4149-838c-aec7bceef0b3_600x.png?v=1779375417',
    plainBagel: 'https://hled.shop/cdn/shop/files/Butter_Crust_-_28_036cd28b-0b0a-4dbb-b57c-62a68fdaab97_600x.jpg?v=1779375426',
    poppyseedBagel: 'https://hled.shop/cdn/shop/files/Butter_Crust_-_32_600x.jpg?v=1779375427',
    everythingBagel: 'https://hled.shop/cdn/shop/files/9_45af11f7-69f3-443e-9c36-fb15b1870361_600x.png?v=1779375400',
  };

  function installPostcodeParserShim() {
    if (typeof window.parseUkPostcode === 'function') return;

    window.parseUkPostcode = function parseUkPostcode(postcode) {
      const raw = String(postcode || '').trim().toUpperCase();
      const compact = raw.replace(/\s+/g, '');
      const match = compact.match(/^([A-Z]{1,2}\d[A-Z\d]?)(\d[A-Z]{2})$/);
      const normalized = match ? `${match[1]} ${match[2]}` : raw;

      return {
        postcode: normalized,
        normalized,
        outward: match ? match[1] : '',
        outcode: match ? match[1] : '',
        inward: match ? match[2] : '',
        incode: match ? match[2] : '',
        valid: Boolean(match),
      };
    };
  }

  installPostcodeParserShim();
  [250, 1000, 2500, 5000].forEach((delay) => {
    window.setTimeout(installPostcodeParserShim, delay);
  });

  function hasBundleCartFlowScript() {
    return Boolean(document.querySelector('script[src*="bc-bundle-cart-flow.js"]'));
  }

  function isBundleCartFlowReady() {
    return window.BC_BUNDLE_CART_FLOW_READY === true;
  }

  function isNativeDeliveryPreviewRequest() {
    const value = new URLSearchParams(window.location.search || '').get('bc_native_delivery');
    const normalizedValue = String(value || '').trim().toLowerCase();
    if (['0', 'false', 'off', 'no', 'disabled'].includes(normalizedValue)) return false;
    if (['1', 'true', 'on', 'yes'].includes(normalizedValue)) return true;
    return window.__BC_NATIVE_DELIVERY_DEFAULT_ENABLED__ === true;
  }

  function ensureBundleCartFlowScriptLoaded() {
    if (cartFlowLoadPromise) return cartFlowLoadPromise;
    if (isBundleCartFlowReady()) return Promise.resolve();

    const src = String(window.BC_BUNDLE_CART_FLOW_SRC || '').trim();
    if (!src) return Promise.reject(new Error('The cart service was not configured. Please refresh this page.'));

    cartFlowLoadPromise = new Promise((resolve, reject) => {
      let settled = false;
      let script = document.querySelector('script[src*="bc-bundle-cart-flow.js"]');
      let shouldAppendScript = false;

      const cleanup = () => {
        window.clearTimeout(timeoutId);
        document.removeEventListener(BUNDLE_CART_FLOW_READY_EVENT, handleReady);
        script?.removeEventListener('error', handleError);
      };
      const finish = () => {
        if (settled) return;
        settled = true;
        cleanup();
        resolve();
      };
      const fail = (message) => {
        if (settled) return;
        settled = true;
        cleanup();
        if (script?.id === 'bc-bundle-cart-flow-lazy') script.remove();
        reject(new Error(message));
      };
      const handleReady = () => {
        if (isBundleCartFlowReady()) finish();
      };
      const handleError = () => {
        fail('The cart service could not load. Please check your connection and try again.');
      };
      const timeoutId = window.setTimeout(() => {
        fail('The cart service took too long to load. Please refresh this page and try again.');
      }, BUNDLE_CART_FLOW_LOAD_TIMEOUT_MS);

      document.addEventListener(BUNDLE_CART_FLOW_READY_EVENT, handleReady);

      if (!script) {
        script = document.createElement('script');
        script.id = 'bc-bundle-cart-flow-lazy';
        script.type = 'module';
        script.src = src;
        script.fetchPriority = isNativeDeliveryPreviewRequest() ? 'high' : 'low';
        shouldAppendScript = true;
      }

      script.addEventListener('error', handleError, { once: true });
      if (shouldAppendScript) document.head.appendChild(script);
      if (isBundleCartFlowReady()) finish();
    }).finally(() => {
      if (!isBundleCartFlowReady()) {
        cartFlowLoadPromise = null;
      }
    });

    return cartFlowLoadPromise;
  }

  function warmBundleCartFlowScript() {
    void ensureBundleCartFlowScriptLoaded().catch(() => {});
  }

  function warmBuilderCartSnapshot() {
    if (latestBuilderCartSnapshot) return Promise.resolve(latestBuilderCartSnapshot);
    if (builderCartSnapshotWarmupPromise) return builderCartSnapshotWarmupPromise;

    builderCartSnapshotWarmupPromise = fetchCart()
      .catch(() => null)
      .finally(() => {
        builderCartSnapshotWarmupPromise = null;
      });

    return builderCartSnapshotWarmupPromise;
  }

  function variant(label, externalVariantId, oneTimePence, subscriptionPence) {
    return { label, externalVariantId, oneTimePence, subscriptionPence };
  }

  const STATIC_PRODUCTS = [
    {
      label: 'Seeded Sourdough',
      category: 'Bread & Bagels',
      externalProductId: '7843202891837',
      image: PRODUCT_IMAGES.seededSourdough,
      variants: [
        variant('Regular 650g', '43121640833085', 600, 540),
        variant('Large 900g', '43121640865853', 700, 630),
        variant('Regular sliced', '43121640898621', 600, 540),
        variant('Large sliced', '43121640931389', 700, 630),
      ],
    },
    {
      label: 'Scandinavian Rye',
      category: 'Bread & Bagels',
      externalProductId: '7843204726845',
      image: PRODUCT_IMAGES.scandinavianRye,
      variants: [variant('Default Title', '43121645781053', 600, 540)],
    },
    {
      label: 'Signature Sourdough',
      category: 'Bread & Bagels',
      externalProductId: '7843202924605',
      image: PRODUCT_IMAGES.signatureSourdough,
      variants: [
        variant('Regular 650g', '43121640964157', 600, 540),
        variant('Large 900g', '43121640996925', 700, 630),
        variant('Regular sliced', '43121641029693', 600, 540),
        variant('Large sliced', '43121641062461', 700, 630),
      ],
    },
    {
      label: 'Sliced Sourdough',
      category: 'Bread & Bagels',
      externalProductId: '7843201744957',
      image: null,
      subscriptionEligible: false,
      variants: [
        variant('Regular 650g', '43121631920189', 550, 495),
        variant('Large 900g', '43121631952957', 660, 595),
      ],
    },
    {
      label: 'Plain Bagel',
      category: 'Bread & Bagels',
      externalProductId: '7843203874877',
      image: PRODUCT_IMAGES.plainBagel,
      variants: [variant('Default Title', '43121643028541', 200, 180)],
    },
    {
      label: 'Poppyseed Bagel',
      category: 'Bread & Bagels',
      externalProductId: '7843203907645',
      image: PRODUCT_IMAGES.poppyseedBagel,
      variants: [variant('Default Title', '43121643814973', 200, 180)],
    },
    {
      label: 'Everything Bagel',
      category: 'Bread & Bagels',
      externalProductId: '7843201712189',
      image: PRODUCT_IMAGES.everythingBagel,
      variants: [variant('Default Title', '43121631887421', 200, 180)],
    },
    {
      label: 'Cinnamon Raisin Bagel',
      category: 'Bread & Bagels',
      externalProductId: '7843203842109',
      image: null,
      subscriptionEligible: false,
      variants: [variant('Default Title', '43121642995773', 200, 180)],
    },
    {
      label: 'Two Plain Croissants',
      category: 'Pastries & Treats',
      externalProductId: '7843202007101',
      image: null,
      variants: [variant('Default Title', '43121632247869', 600, 540)],
    },
    {
      label: 'Two Pain Au Chocolat',
      category: 'Pastries & Treats',
      externalProductId: '7843201974333',
      image: null,
      variants: [variant('Default Title', '43121632215101', 650, 585)],
    },
    {
      label: 'Two Classic Pastries',
      category: 'Pastries & Treats',
      externalProductId: '7843204202557',
      image: null,
      variants: [variant('Default Title', '43121644765245', 650, 585)],
    },
    {
      label: 'Two Savoury Pastries',
      category: 'Pastries & Treats',
      externalProductId: '7843202662461',
      image: null,
      variants: [variant('Default Title', '43121640538173', 700, 630)],
    },
    {
      label: 'Four Morning Treats',
      category: 'Pastries & Treats',
      externalProductId: '7843204399165',
      image: null,
      variants: [variant('Default Title', '43121645027389', 1300, 1170)],
    },
    {
      label: 'Four St. JOHN Doughnuts',
      category: 'Pastries & Treats',
      externalProductId: '7843201253437',
      image: null,
      variants: [
        variant('Jam', '43121631199293', 1650, 1485),
        variant('Custard', '43121631232061', 1650, 1485),
        variant('Mixed', '43121631264829', 1650, 1485),
      ],
    },
    {
      label: 'Six Choc Chip Cookies',
      category: 'Pastries & Treats',
      externalProductId: '7843202498621',
      image: null,
      variants: [variant('Default Title', '43121639948349', 950, 855)],
    },
    {
      label: 'St JOHN Hot Cross Buns',
      category: 'Pastries & Treats',
      externalProductId: '7843202105405',
      image: null,
      subscriptionEligible: false,
      variants: [
        variant('Box of four', '43121632411709', 1328, 1195),
        variant('Box of eight', '43121632444477', 2217, 1995),
      ],
    },
    {
      label: 'Cultured Butter 250g',
      category: 'Dairy & Breakfast',
      externalProductId: '7843204497469',
      image: null,
      variants: [variant('Default Title', '43121645486141', 500, 450)],
    },
    {
      label: 'Greek Yoghurt 500g',
      category: 'Dairy & Breakfast',
      externalProductId: '7843204169789',
      image: null,
      variants: [variant('Default Title', '43121644732477', 450, 405)],
    },
    {
      label: 'Greek Yoghurt with Lemon, Blackcurrant & Granola',
      category: 'Dairy & Breakfast',
      externalProductId: '7843201318973',
      image: null,
      variants: [variant('Default Title', '43121631363133', 550, 495)],
    },
    {
      label: 'Milk 1L',
      category: 'Dairy & Breakfast',
      externalProductId: '7843204137021',
      image: null,
      variants: [
        variant('Whole', '43121644666941', 350, 315),
        variant('Semi-skimmed', '43121644699709', 350, 315),
      ],
    },
    {
      label: 'Six Large Farm Eggs',
      category: 'Dairy & Breakfast',
      externalProductId: '7843203285053',
      image: null,
      variants: [variant('Default Title', '43121641586749', 405, 365)],
    },
    {
      label: 'St. JOHN Granola',
      category: 'Dairy & Breakfast',
      externalProductId: '7843204464701',
      image: null,
      variants: [variant('Default Title', '43121645453373', 950, 855)],
    },
    {
      label: 'Dark Chocolate & Orange Overnight Oats',
      category: 'Dairy & Breakfast',
      externalProductId: '7843201286205',
      image: null,
      variants: [variant('Default Title', '43121631297597', 550, 495)],
    },
    {
      label: 'Organic Preserves 125g',
      category: 'Dairy & Breakfast',
      externalProductId: '7843204333629',
      image: null,
      variants: [variant('Default Title', '43121644961853', 450, 405)],
    },
    {
      label: 'The Estate Double Cream',
      category: 'Dairy & Breakfast',
      externalProductId: '7843201646653',
      image: null,
      subscriptionEligible: false,
      variants: [variant('Default Title', '43121631821885', 439, 395)],
    },
    {
      label: 'Oak Smoked Salmon',
      category: 'Dairy & Breakfast',
      externalProductId: '7843203350589',
      image: null,
      variants: [
        variant('100g', '43121641947197', 750, 675),
        variant('200g', '43121641979965', 1450, 1305),
      ],
    },
    {
      label: 'Monmouth Coffee 250g',
      category: 'Dairy & Breakfast',
      externalProductId: '7843204431933',
      image: null,
      variants: [
        variant('Our Pick / Coarse', '43121645060157', 1300, 1170),
        variant('Our Pick / Medium', '43121645092925', 1300, 1170),
        variant('Our Pick / Fine', '43121645125693', 1300, 1170),
        variant('Our Pick / Wholebean', '43121645158461', 1300, 1170),
        variant('Dark Roast / Coarse', '43121645191229', 1300, 1170),
        variant('Dark Roast / Medium', '43121645223997', 1300, 1170),
        variant('Dark Roast / Fine', '43121645256765', 1300, 1170),
        variant('Dark Roast / Wholebean', '43121645289533', 1300, 1170),
        variant('Espresso Roast / Coarse', '43121645322301', 1300, 1170),
        variant('Espresso Roast / Medium', '43121645355069', 1300, 1170),
        variant('Espresso Roast / Fine', '43121645387837', 1300, 1170),
        variant('Espresso Roast / Wholebean', '43121645420605', 1300, 1170),
      ],
    },
    {
      label: 'Daily Dose Immunity Shot 60ml',
      category: 'Juices & Drinks',
      externalProductId: '7843202400317',
      image: null,
      variants: [variant('Default Title', '43121632804925', 350, 315)],
    },
    {
      label: "Daily Dose O'Fresco Juice 300ml",
      category: 'Juices & Drinks',
      externalProductId: '7843201777725',
      image: null,
      variants: [variant('Default Title', '43121631985725', 450, 405)],
    },
    {
      label: 'Daily Dose Pomm Juice 300ml',
      category: 'Juices & Drinks',
      externalProductId: '7843201810493',
      image: null,
      variants: [variant('Default Title', '43121632018493', 450, 405)],
    },
    {
      label: 'Townsend Farm Apple Juice 750ml',
      category: 'Juices & Drinks',
      externalProductId: '7843204366397',
      image: null,
      variants: [variant('Default Title', '43121644994621', 550, 495)],
    },
    {
      label: 'Baba Ganoush',
      category: 'Savoury',
      externalProductId: '7881550561341',
      image: null,
      subscriptionEligible: false,
      variants: [variant('Default Title', '43219775651901', 650, 585)],
    },
    {
      label: 'The Smokey One',
      category: 'Savoury',
      externalProductId: '7843201155133',
      image: null,
      variants: [variant('Default Title', '43121630347325', 650, 585)],
    },
    {
      label: 'Velvet Hummus',
      category: 'Savoury',
      externalProductId: '15017502245240',
      image: null,
      variants: [variant('Default Title', '55518646043000', 650, 585)],
    },
    {
      label: 'Spinach, Garlic & Yoghurt',
      category: 'Savoury',
      externalProductId: '15017497657720',
      image: null,
      variants: [variant('Default Title', '55518563303800', 650, 585)],
    },
    {
      label: 'The Beetroot One',
      category: 'Savoury',
      externalProductId: '7843201220669',
      image: null,
      subscriptionEligible: false,
      variants: [variant('Default Title', '43121631166525', 650, 585)],
    },
  ];
  const STATIC_PRODUCT_BY_ID = new Map();
  const STATIC_VARIANT_BY_ID = new Map();
  STATIC_PRODUCTS.forEach((product) => {
    STATIC_PRODUCT_BY_ID.set(String(product.externalProductId), product);
    product.variants.forEach((item) => {
      STATIC_VARIANT_BY_ID.set(String(item.externalVariantId), item);
    });
  });
  let PRODUCTS = [];
  let currentProductSourceSignature = productSourceSignature(PRODUCTS);
  let collectionProductSourceStarted = false;
  let hasCollectionProductSource = false;
  let sourceFallbackTimer = null;
  let productSourceSyncTimer = 0;

  function cloneProducts(products) {
    return products.map((product) => ({
      ...product,
      variants: product.variants.map((item) => ({ ...item })),
    }));
  }

  function productSourceSignature(products) {
    return JSON.stringify(products.map((product) => ({
      category: product.category,
      collectionId: product.collectionId || DEFAULT_COLLECTION_ID,
      externalProductId: product.externalProductId,
      image: product.image || '',
      label: product.label,
      secondaryImage: product.secondaryImage || '',
      sourceTitle: product.sourceTitle || '',
      subscriptionEligible: product.subscriptionEligible !== false,
      variants: product.variants.map((item) => ({
        externalVariantId: item.externalVariantId,
        label: item.label,
        oneTimePence: item.oneTimePence,
        subscriptionPence: item.subscriptionPence,
      })),
    })));
  }

  function normalizePath(path) {
    return String(path || '').replace(/\/+$/, '') || '/';
  }

  function isEnabled() {
    if (!['hled.shop', 'hled.shop', 'butterandcrust.myshopify.com'].includes(window.location.hostname)) return false;
    const params = new URLSearchParams(window.location.search || '');
    const value = String(params.get(QUERY_KEY) || '').trim().toLowerCase();
    const disabled = ['0', 'false', 'off', 'no', 'disabled'].includes(value);
    return !disabled && (IS_EMBEDDED || TARGET_PATHS.has(normalizePath(window.location.pathname)));
  }

  if (!isEnabled()) return;

  function isFallbackCatalogueAllowed() {
    const params = new URLSearchParams(window.location.search || '');
    const value = String(params.get(FALLBACK_QUERY_KEY) || '').trim().toLowerCase();
    return ['1', 'true', 'on', 'yes'].includes(value);
  }

  function shouldAutoOpenPostcodeChecker() {
    const params = new URLSearchParams(window.location.search || '');
    const value = String(params.get(POSTCODE_AUTO_OPEN_QUERY_KEY) || '').trim().toLowerCase();
    return ['1', 'true', 'on', 'yes'].includes(value);
  }

  const state = {
    busy: false,
    quantities: PRODUCTS.map(() => 0),
    variantIndexes: PRODUCTS.map(() => 0),
    purchaseMode: 'subscription',
    frequencyIndex: 0,
    catalogStatus: 'loading',
    mobileSummaryOpen: false,
    sheetOpen: false,
    rewardsInfoOpen: false,
    rewardPreviewChoices: { 3000: '', 4000: '', 5000: '' },
    giftPickerDraftChoice: '',
    giftPickerDraftChoices: [],
    giftPickerMultiSlot: false,
    giftPickerSlot: 0,
    giftPickerOpen: false,
    giftPickerTriggeredByAdd: false,
    giftPickerContinueTarget: '',
    oneTimeGiftWarningOpen: false,
    giftPickerRequiredOnSubscriptionReturn: false,
    cartOpen: false,
    cartEmptyStateOpen: false,
    statusMessage: '',
    statusKind: 'info',
  };
  let customBundleDraftRestorePromise = null;
  let customBundleDraftRestoreCompleted = false;
  let customBundleDraftUserInteracted = false;
  let customBundleDraftLastSignature = '';
  let customBundleDraftPendingSellingPlanId = 0;
  let customBundleDraftPendingFrequencyLabel = '';
  let familyPresetRequestHandled = false;
  let familyPresetIntroShown = false;
  let giftPickerReturnFocusElement = null;
  let giftPickerReturnFocusSelector = '';

  function getActivePurchaseMode() {
    return isSubscriptionOnlyBundle() ? 'subscription' : state.purchaseMode;
  }

  function enforcePurchaseModel() {
    if (isSubscriptionOnlyBundle()) {
      state.purchaseMode = 'subscription';
    }
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function publishBundleFunnelEvent(name, payload = {}) {
    const eventName = String(name || '').trim();
    if (!eventName) return;

    const detail = {
      home_version: 'native-v1',
      product_handle: BUNDLE_PRODUCT.shopifyHandle,
      ...payload,
    };

    document.dispatchEvent(new CustomEvent(eventName, {
      bubbles: true,
      detail,
    }));

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...detail });

    try {
      if (window.Shopify?.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(`butter_crust:${eventName}`, detail);
      }
    } catch (error) {
    }
  }

  function formatMoney(pence) {
    return `£${(Math.max(0, Number(pence) || 0) / 100).toFixed(2)}`;
  }

  function getVariant(product, productIndex) {
    const index = Math.max(0, Number(state.variantIndexes[productIndex]) || 0);
    return product.variants[index] || product.variants[0];
  }

  function getVariantPricePence(variant, mode) {
    if (!variant) return 0;
    return mode === 'subscription' ? variant.subscriptionPence : variant.oneTimePence;
  }

  function isMobileViewport() {
    return window.matchMedia && window.matchMedia('(max-width: 900px)').matches;
  }

  function getUnitPricePence(variant) {
    return getVariantPricePence(variant, getActivePurchaseMode());
  }

  function isSubscriptionEligible(product) {
    return product && product.subscriptionEligible !== false;
  }

  function isProductAvailableForCurrentMode(product) {
    return getActivePurchaseMode() !== 'subscription' || isSubscriptionEligible(product);
  }

  function getUnavailableSubscriptionSelections() {
    if (getActivePurchaseMode() !== 'subscription') return [];
    return PRODUCTS.reduce((items, product, index) => {
      const quantity = Math.max(0, Number(state.quantities[index]) || 0);
      if (quantity && !isSubscriptionEligible(product)) {
        items.push({ label: product.label, index, quantity });
      }
      return items;
    }, []);
  }

  function removeUnavailableSubscriptionSelections() {
    const removed = getUnavailableSubscriptionSelections();
    removed.forEach((item) => {
      state.quantities[item.index] = 0;
    });
    return removed;
  }

  function formatProductList(items) {
    const labels = items.map((item) => item.label);
    if (labels.length <= 1) return labels[0] || '';
    if (labels.length === 2) return `${labels[0]} and ${labels[1]}`;
    return `${labels.slice(0, -1).join(', ')}, and ${labels[labels.length - 1]}`;
  }

  function getSubtotalPence() {
    return readSelections().reduce((total, item) => total + (item.unitPricePence * item.quantity), 0);
  }

  function getModeSubtotalPence(mode) {
    return PRODUCTS.reduce((total, product, index) => {
      const quantity = Math.max(0, Number(state.quantities[index]) || 0);
      if (!quantity) return total;
      const variant = getVariant(product, index);
      const price = getVariantPricePence(variant, mode);
      return total + (price * quantity);
    }, 0);
  }

  function getItemCount() {
    return readSelections().reduce((total, item) => total + item.quantity, 0);
  }

  function getFrequencyOption() {
    const index = Math.max(0, Number(state.frequencyIndex) || 0);
    return frequencyOptions[index] || frequencyOptions[0];
  }

  function normalizeFrequencyLabel(label) {
    return String(label || '')
      .replace(/\s+/g, ' ')
      .replace(/:\s*save\s*\d+%/i, '')
      .trim();
  }

  function getSheetFrequencyLabel(label) {
    const normalized = normalizeFrequencyLabel(label);
    const everyWeeks = normalized.match(/^Every\s+(\d+)\s+weeks?$/i);
    if (everyWeeks) return `${everyWeeks[1]} weeks`;
    if (/^Every\s+(1\s+)?week$/i.test(normalized)) return '1 week';
    return normalized.replace(/^Every\s+/i, '');
  }

  function normalizeFrequencyDedupeKey(label) {
    return normalizeFrequencyLabel(label)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function getFrequencyCadenceKey(label) {
    const normalized = normalizeFrequencyLabel(label);
    const lower = normalized.toLowerCase();
    const explicitWeek = lower.match(/\b(?:every|delivered\s+every)\s+(\d+)\s+weeks?\b/);
    if (explicitWeek) return `week-${Number(explicitWeek[1])}`;
    if (/\bweekly\b|\bevery\s+week\b/.test(lower)) return 'week-1';
    if (/\bfortnight(?:ly)?\b/.test(lower)) return 'week-2';

    const explicitDay = lower.match(/\b(?:every|delivered\s+every)\s+(\d+)\s+days?\b/);
    if (explicitDay) return `day-${Number(explicitDay[1])}`;

    const explicitMonth = lower.match(/\b(?:every|delivered\s+every)\s+(\d+)\s+months?\b/);
    if (explicitMonth) return `month-${Number(explicitMonth[1])}`;

    return normalizeFrequencyDedupeKey(normalized);
  }

  function getCanonicalFrequencyLabel(label) {
    const key = getFrequencyCadenceKey(label);
    const weekMatch = key.match(/^week-(\d+)$/);
    if (weekMatch) {
      const count = Number(weekMatch[1]);
      if (count === 1) return 'Every week';
      if (count > 1) return `Every ${count} weeks`;
    }

    return normalizeFrequencyLabel(label);
  }

  function getFrequencySortValue(option) {
    const key = getFrequencyCadenceKey(option && option.label);
    const weekMatch = key.match(/^week-(\d+)$/);
    if (weekMatch) return Number(weekMatch[1]);
    const dayMatch = key.match(/^day-(\d+)$/);
    if (dayMatch) return 100 + Number(dayMatch[1]);
    const monthMatch = key.match(/^month-(\d+)$/);
    if (monthMatch) return 200 + Number(monthMatch[1]);
    return 999;
  }

  function sanitizeFrequencyOptions(options) {
    const seenIds = new Set();
    const seenCadences = new Set();

    return (options || [])
      .map((option) => ({
        label: getCanonicalFrequencyLabel(option && option.label),
        sellingPlanId: Number(option && option.sellingPlanId),
      }))
      .filter((option) => {
        if (!option.label || !Number.isFinite(option.sellingPlanId) || option.sellingPlanId <= 0) return false;
        const cadenceKey = getFrequencyCadenceKey(option.label);
        if (seenIds.has(option.sellingPlanId) || seenCadences.has(cadenceKey)) return false;
        seenIds.add(option.sellingPlanId);
        seenCadences.add(cadenceKey);
        return true;
      })
      .sort((a, b) => getFrequencySortValue(a) - getFrequencySortValue(b));
  }

  function labelFromOrderFrequencyUnit(value) {
    const normalized = String(value || '').trim().toLowerCase();
    const match = normalized.match(/^(\d+)\s*-\s*(day|week|month)s?$/);
    if (!match) return '';

    const count = Number(match[1]);
    const unit = match[2];
    if (!Number.isFinite(count) || count <= 0) return '';
    if (unit === 'week' && count === 1) return 'Every week';
    return `Every ${count} ${unit}${count === 1 ? '' : 's'}`;
  }

  function labelFromSellingPlan(plan, group) {
    const planOptions = Array.isArray(plan && plan.options) ? plan.options : [];
    const frequencyOption = planOptions.find((option) => /Order Frequency and Unit/i.test(option && option.name));
    const fromFrequencyOption = labelFromOrderFrequencyUnit(frequencyOption && frequencyOption.value);
    if (fromFrequencyOption) return fromFrequencyOption;

    const rawLabel = normalizeFrequencyLabel((plan && plan.name) || (group && group.name) || '');
    const deliveryMatch = rawLabel.match(/Delivery\s+every\s+(\d+)\s+(day|week|month)s?\.?$/i);
    if (deliveryMatch) {
      const count = Number(deliveryMatch[1]);
      const unit = deliveryMatch[2].toLowerCase();
      if (Number.isFinite(count) && count > 0) {
        if (unit === 'week' && count === 1) return 'Every week';
        return `Every ${count} ${unit}${count === 1 ? '' : 's'}`;
      }
    }

    const everyMatch = rawLabel.match(/Every\s+(\d+)\s+(day|week|month)s?\.?$/i);
    if (everyMatch) {
      const count = Number(everyMatch[1]);
      const unit = everyMatch[2].toLowerCase();
      if (Number.isFinite(count) && count > 0) {
        if (unit === 'week' && count === 1) return 'Every week';
        return `Every ${count} ${unit}${count === 1 ? '' : 's'}`;
      }
    }

    if (/^Every\s+(1\s+)?week$/i.test(rawLabel)) return 'Every week';
    return rawLabel;
  }

  function normalizeProductKey(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getProductStateKey(product) {
    return String(product && product.externalProductId ? product.externalProductId : normalizeProductKey(product && product.label));
  }

  function getCategoryId(category) {
    return `bc-mvp-section-${normalizeProductKey(category).replace(/\s+/g, '-') || 'products'}`;
  }

  function getVisibleCategories() {
    const categories = [];
    PRODUCTS.forEach((product) => {
      if (!isProductAvailableForCurrentMode(product)) return;
      if (!categories.includes(product.category)) categories.push(product.category);
    });
    return categories;
  }

  function parseMoneyPence(value) {
    const match = String(value || '').replace(/,/g, '').match(/([0-9]+(?:\.[0-9]{1,2})?)/);
    if (!match) return 0;
    return Math.round(Number(match[1]) * 100);
  }

  function readRechargeCardPrices(card) {
    const prices = ((card && card.textContent) || '').match(/£\s*[0-9]+(?:\.[0-9]{1,2})?/g) || [];
    const oneTimePence = parseMoneyPence(prices[0]);
    const subscriptionPence = parseMoneyPence(prices.length > 1 ? prices[prices.length - 1] : prices[0]);
    return {
      oneTimePence: oneTimePence || subscriptionPence || 0,
      subscriptionPence: subscriptionPence || oneTimePence || 0,
    };
  }

  function normalizeRechargeVariantLabel(label) {
    const cleaned = normalizeFrequencyLabel(label)
      .replace(/\(([^)]+)\)/g, '$1')
      .replace(/\s+/g, ' ')
      .trim();
    return cleaned || 'Default Title';
  }

  function readRechargeCollectionProducts() {
    const sections = document.querySelectorAll(
      '#recharge-bundles [id^="recharge-bundle-collection-"][aria-label], #bundling-app [id^="recharge-bundle-collection-"][aria-label]'
    );
    const products = [];
    const seen = new Set();

    sections.forEach((section) => {
      const collectionId = String(section.id || '').replace(/^recharge-bundle-collection-/, '').trim();
      const category = normalizeFrequencyLabel(section.getAttribute('aria-label') || '');
      if (!collectionId || !category) return;

      section.querySelectorAll('.recharge-bundle-product-item').forEach((card) => {
        const externalProductId = String(card.getAttribute('data-recharge-product-id') || '').trim();
        const defaultVariantId = String(card.getAttribute('data-recharge-variant-id') || '').trim();
        const imageButton = card.querySelector('button.recharge-bundle-product-image, button[aria-label]');
        const imageNodes = Array.from(card.querySelectorAll('button.recharge-bundle-product-image img, img'));
        const image = imageNodes[0];
        const secondaryImage = imageNodes
          .slice(1)
          .map((node) => node.currentSrc || node.src || '')
          .find(Boolean);
        const title = normalizeFrequencyLabel(
          (imageButton && imageButton.getAttribute('aria-label')) ||
          (image && image.getAttribute('alt')) ||
          ''
        );
        if (!externalProductId || !defaultVariantId || !title) return;

        const sourceKey = `${collectionId}:${externalProductId}`;
        if (seen.has(sourceKey)) return;
        seen.add(sourceKey);

        const cardPrices = readRechargeCardPrices(card);
        const staticProduct = STATIC_PRODUCT_BY_ID.get(externalProductId);
        const optionNodes = Array.from(card.querySelectorAll('select option[value]'))
          .filter((option) => String(option.value || '').trim());
        const rawVariants = optionNodes.length
          ? optionNodes.map((option) => ({
            label: normalizeRechargeVariantLabel(option.textContent || option.label),
            externalVariantId: String(option.value || '').trim(),
          }))
          : [{
            label: 'Default Title',
            externalVariantId: defaultVariantId,
          }];

        const variants = rawVariants
          .filter((item) => item.externalVariantId)
          .map((item) => {
            const staticVariant = STATIC_VARIANT_BY_ID.get(item.externalVariantId);
            const oneTimePence = cardPrices.oneTimePence || (staticVariant && staticVariant.oneTimePence) || 0;
            const subscriptionPence = cardPrices.subscriptionPence || (staticVariant && staticVariant.subscriptionPence) || oneTimePence;
            return {
              label: item.label,
              externalVariantId: item.externalVariantId,
              oneTimePence,
              subscriptionPence,
            };
          });
        if (!variants.length) return;

        products.push({
          label: title,
          sourceTitle: title,
          category,
          collectionId,
          externalProductId,
          image: image ? (image.currentSrc || image.src || '') : (staticProduct && staticProduct.image) || null,
          secondaryImage: secondaryImage || (staticProduct && staticProduct.secondaryImage) || '',
          variants,
          subscriptionEligible: true,
          hasNativeDetails: true,
        });
      });
    });

    return products;
  }

  function applyProductSource(panel, nextProducts, catalogStatus) {
    if (!Array.isArray(nextProducts) || !nextProducts.length) return false;

    const nextSignature = productSourceSignature(nextProducts);
    const nextStatus = catalogStatus || 'ready';
    const statusChanged = state.catalogStatus !== nextStatus;
    if (nextSignature === currentProductSourceSignature && !statusChanged) return false;

    if (sourceFallbackTimer && nextStatus === 'ready') {
      window.clearTimeout(sourceFallbackTimer);
      sourceFallbackTimer = null;
    }

    const previousState = new Map(PRODUCTS.map((product, index) => {
      const variant = getVariant(product, index);
      return [getProductStateKey(product), {
        quantity: Math.max(0, Number(state.quantities[index]) || 0),
        externalVariantId: variant && variant.externalVariantId,
      }];
    }));

    PRODUCTS = cloneProducts(nextProducts);
    state.quantities = PRODUCTS.map((product) => {
      const previous = previousState.get(getProductStateKey(product));
      return previous ? previous.quantity : 0;
    });
    state.variantIndexes = PRODUCTS.map((product) => {
      const previous = previousState.get(getProductStateKey(product));
      if (!previous || !previous.externalVariantId) return 0;
      const index = product.variants.findIndex((item) => item.externalVariantId === previous.externalVariantId);
      return index >= 0 ? index : 0;
    });
    currentProductSourceSignature = productSourceSignature(PRODUCTS);
    state.catalogStatus = nextStatus;
    if (
      nextStatus === 'ready' &&
      state.statusKind === 'error' &&
      /products are still loading/i.test(state.statusMessage || '')
    ) {
      state.statusMessage = '';
      state.statusKind = 'info';
    }
    if (panel) renderState(panel);
    if (panel) {
      void requestCustomBundleDraftRestore(panel).finally(() => completeInitialBuilderHydration(panel));
    }
    return true;
  }

  function getFallbackCollectionId(product) {
    const category = product && product.category;
    return (category && FALLBACK_COLLECTION_IDS_BY_CATEGORY[category]) || DEFAULT_COLLECTION_ID;
  }

  function getFallbackCategory(product) {
    const category = product && product.category;
    const titleKey = normalizeProductKey(product && product.label);

    if (category === 'Pastries & Treats') return 'Pastries & Sweet Treats';
    if (category === 'Juices & Drinks') return 'Juices';
    if (category === 'Dairy & Breakfast') {
      if ([
        'monmouth coffee 250g',
        'organic preserves 125g',
        'six large farm eggs',
        'st john granola',
      ].includes(titleKey)) {
        return 'Pantry';
      }
      return 'Chilled';
    }

    return category || 'Bread & Bagels';
  }

  function getProductImageIdentity(value) {
    const raw = String(value || '').trim();
    if (!raw) return '';

    try {
      const url = new URL(raw, window.location.origin);
      url.searchParams.delete('width');
      return url.toString();
    } catch (error) {
      return raw.replace(/([?&])width=\d+/i, '');
    }
  }

  function getShopifyProductImages(product) {
    const images = [];
    const seen = new Set();
    const addImage = (value) => {
      const src = typeof value === 'string' ? value : value && value.src;
      const cleanSrc = String(src || '').trim();
      const identity = getProductImageIdentity(cleanSrc);
      if (!cleanSrc || !identity || seen.has(identity)) return;
      seen.add(identity);
      images.push(cleanSrc);
    };

    addImage(product && product.image);
    (Array.isArray(product && product.images) ? product.images : []).forEach(addImage);
    return images;
  }

  function getShopifyProductImage(product) {
    return getShopifyProductImages(product)[0] || '';
  }

  function getShopifyProductSecondaryImage(product) {
    return getShopifyProductImages(product)[1] || '';
  }

  function isShopifyImageUrl(value) {
    return /cdn\.shopify\.com|\/cdn\/shop\//i.test(String(value || ''));
  }

  function getSizedProductImageUrl(value, width) {
    const raw = String(value || '').trim();
    if (!raw || !isShopifyImageUrl(raw)) return raw;

    try {
      const url = new URL(raw, window.location.origin);
      url.searchParams.set('width', String(width));
      return url.toString();
    } catch (error) {
      if (/[?&]width=\d+/i.test(raw)) {
        return raw.replace(/([?&])width=\d+/i, `$1width=${width}`);
      }
      return `${raw}${raw.includes('?') ? '&' : '?'}width=${width}`;
    }
  }

  function renderProductImageMarkup(product, displayTitle, index) {
    const image = product && product.image;
    if (!image) {
      return `<div class="bc-custom-bundle-mvp__image-placeholder" aria-label="${escapeHtml(displayTitle)} image pending"><span>Butter &amp; Crust</span></div>`;
    }

    const eagerCount = 4;
    const eager = Number.isFinite(Number(index)) && Number(index) < eagerCount;
    const renderImage = (value, className, isEager, isDecorative, forceLowPriority = false) => {
      const src = getSizedProductImageUrl(value, 360);
      const srcset = [240, 360, 480, 640]
        .map((width) => `${getSizedProductImageUrl(value, width)} ${width}w`)
        .join(', ');
      const decoding = !isDecorative && isEager ? 'sync' : 'async';
      return `<img class="${className}" src="${escapeHtml(src)}" srcset="${escapeHtml(srcset)}" sizes="(max-width: 700px) 46vw, (max-width: 1100px) 22vw, 190px" width="320" height="320" loading="${isEager ? 'eager' : 'lazy'}" decoding="${decoding}" fetchpriority="${!forceLowPriority && isEager ? 'high' : 'low'}" alt="${isDecorative ? '' : escapeHtml(displayTitle)}"${isDecorative ? ' aria-hidden="true"' : ''}>`;
    };
    const primaryMarkup = renderImage(image, 'bc-custom-bundle-mvp__image-primary', eager, false);
    const secondaryImage = !isMobileViewport() &&
      product &&
      product.secondaryImage &&
      getProductImageIdentity(product.secondaryImage) !== getProductImageIdentity(image)
      ? product.secondaryImage
      : '';

    if (!secondaryImage) return primaryMarkup;

    return `${primaryMarkup}${renderImage(secondaryImage, 'bc-custom-bundle-mvp__image-secondary', false, true, true)}`;
  }

  function renderProductDetailsImageMarkup(product, displayTitle) {
    const image = product && product.image;
    if (!image) {
      return `<div class="bc-custom-bundle-mvp__image-placeholder" aria-label="${escapeHtml(displayTitle)} image pending"><span>Butter &amp; Crust</span></div>`;
    }

    const src = getSizedProductImageUrl(image, 640);
    const srcset = [480, 640, 960]
      .map((width) => `${getSizedProductImageUrl(image, width)} ${width}w`)
      .join(', ');
    return `<img src="${escapeHtml(src)}" srcset="${escapeHtml(srcset)}" sizes="(max-width: 700px) 82vw, 440px" width="640" height="640" loading="lazy" decoding="async" fetchpriority="low" alt="${escapeHtml(displayTitle)}">`;
  }

  function getShopifyVariantLabel(variantData) {
    const title = normalizeFrequencyLabel(
      (variantData && (variantData.public_title || variantData.title || variantData.name)) || ''
    );
    return title && title !== 'Default Title' ? title : 'Default Title';
  }

  function stripHtmlToText(html) {
    const raw = String(html || '').trim();
    if (!raw) return '';
    const element = document.createElement('div');
    element.innerHTML = raw;
    return normalizeFrequencyLabel(element.textContent || element.innerText || '');
  }

  function sanitizeProductDescriptionHtml(html) {
    const raw = String(html || '').trim();
    if (!raw) return '';

    const template = document.createElement('template');
    template.innerHTML = raw;
    template.content.querySelectorAll('script, style, iframe, object, embed, form, input, button, select, textarea').forEach((node) => node.remove());
    template.content.querySelectorAll('*').forEach((node) => {
      Array.from(node.attributes).forEach((attribute) => {
        const name = attribute.name.toLowerCase();
        const value = String(attribute.value || '');
        if (name.startsWith('on') || name === 'style' || ((name === 'href' || name === 'src') && /^\s*javascript:/i.test(value))) {
          node.removeAttribute(attribute.name);
        }
      });
    });
    return template.innerHTML.trim();
  }

  function mapCollectionProduct(source, shopifyProduct) {
    const shopifyVariants = Array.isArray(shopifyProduct && shopifyProduct.variants) ? shopifyProduct.variants : [];
    if (!source || !shopifyProduct || !shopifyProduct.id || !shopifyProduct.title || !shopifyVariants.length) return null;

    const variants = shopifyVariants
      .filter((variantData) => variantData && variantData.id && variantData.available !== false)
      .map((variantData) => {
        const oneTimePence = parseMoneyPence(variantData.price);
        if (!oneTimePence) return null;
        return {
          label: normalizeRechargeVariantLabel(getShopifyVariantLabel(variantData)),
          externalVariantId: String(variantData.id),
          oneTimePence,
          subscriptionPence: Math.round(oneTimePence * 0.9),
        };
      })
      .filter(Boolean);

    if (!variants.length) return null;

    return {
      label: normalizeFrequencyLabel(shopifyProduct.title),
      sourceTitle: normalizeFrequencyLabel(shopifyProduct.title),
      category: source.category,
      collectionId: source.collectionId,
      externalProductId: String(shopifyProduct.id),
      image: getShopifyProductImage(shopifyProduct),
      secondaryImage: getShopifyProductSecondaryImage(shopifyProduct),
      description: stripHtmlToText(shopifyProduct.body_html),
      descriptionHtml: sanitizeProductDescriptionHtml(shopifyProduct.body_html),
      variants,
      subscriptionEligible: true,
      hasNativeDetails: false,
    };
  }

  function buildCollectionProducts(responses) {
    const products = [];
    const seen = new Set();

    responses.forEach(({ source, data }) => {
      const shopifyProducts = Array.isArray(data && data.products) ? data.products : [];
      shopifyProducts.forEach((shopifyProduct) => {
        const product = mapCollectionProduct(source, shopifyProduct);
        if (!product) return;
        const key = `${product.collectionId}:${product.externalProductId}`;
        if (seen.has(key)) return;
        seen.add(key);
        products.push(product);
      });
    });

    return products;
  }

  function fetchCollectionProducts() {
    if (!collectionProductsPromise) {
      const collectionRequests = COLLECTION_PRODUCT_SOURCES.map((source) => (
        window.fetch(`/collections/${encodeURIComponent(source.handle)}/products.json?limit=250`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        })
          .then((response) => {
            if (!response || !response.ok) {
              throw new Error(`Collection product source failed for ${source.handle}: ${response ? response.status : 'network'}`);
            }
            return response.json();
          })
          .then((data) => ({ source, data }))
      ));
      collectionProductsPromise = Promise.allSettled(collectionRequests)
        .then((results) => {
          const successfulResponses = [];
          const failedCollections = [];

          results.forEach((result, index) => {
            if (result.status === 'fulfilled') {
              successfulResponses.push(result.value);
              return;
            }
            failedCollections.push(COLLECTION_PRODUCT_SOURCES[index].handle);
          });

          if (failedCollections.length) {
            console.warn(`[B&C bundle] Could not read Shopify bundle collections: ${failedCollections.join(', ')}`);
          }

          return buildCollectionProducts(successfulResponses);
        })
        .catch((error) => {
          console.warn('[B&C bundle] Could not read Shopify bundle collections', error);
          return [];
        });
    }

    return collectionProductsPromise;
  }

  async function syncCollectionProductSource(panel) {
    collectionProductSourceStarted = true;
    const collectionProducts = await fetchCollectionProducts();
    if (!collectionProducts.length) return false;
    const applied = applyProductSource(panel, collectionProducts, 'ready');
    hasCollectionProductSource = true;
    return applied;
  }

  function getFallbackVariantDiscountRatio(variantData) {
    const oneTime = Number(variantData && variantData.oneTimePence) || 0;
    const subscription = Number(variantData && variantData.subscriptionPence) || 0;
    if (oneTime > 0 && subscription > 0 && subscription <= oneTime) {
      return subscription / oneTime;
    }
    return 0.9;
  }

  function hydrateFallbackProduct(staticProduct, shopifyProduct) {
    const shopifyVariants = Array.isArray(shopifyProduct && shopifyProduct.variants) ? shopifyProduct.variants : [];
    if (!shopifyProduct || !shopifyProduct.id || !shopifyVariants.length) return null;
    const fallbackCategory = getFallbackCategory(staticProduct);

    const hydratedVariants = (staticProduct.variants || [])
      .map((staticVariant, index) => {
        const staticKey = normalizeProductKey(staticVariant && staticVariant.label);
        let shopifyVariant = shopifyVariants.find((candidate) => (
          normalizeProductKey(getShopifyVariantLabel(candidate)) === staticKey
        ));

        if (!shopifyVariant && shopifyVariants.length === 1) {
          shopifyVariant = shopifyVariants[0];
        }

        if (!shopifyVariant && shopifyVariants[index]) {
          shopifyVariant = shopifyVariants[index];
        }

        if (!shopifyVariant || !shopifyVariant.id) return null;

        const oneTimePence = parseMoneyPence(shopifyVariant.price) || Number(staticVariant && staticVariant.oneTimePence) || 0;
        const subscriptionPence = Math.round(oneTimePence * getFallbackVariantDiscountRatio(staticVariant));
        return {
          label: getShopifyVariantLabel(shopifyVariant),
          externalVariantId: String(shopifyVariant.id),
          oneTimePence,
          subscriptionPence: subscriptionPence || oneTimePence,
        };
      })
      .filter(Boolean);

    if (!hydratedVariants.length) return null;

    return {
      ...staticProduct,
      category: fallbackCategory,
      label: normalizeFrequencyLabel(shopifyProduct.title || staticProduct.label),
      sourceTitle: normalizeFrequencyLabel(shopifyProduct.title || staticProduct.sourceTitle || staticProduct.label),
      externalProductId: String(shopifyProduct.id),
      collectionId: getFallbackCollectionId({ ...staticProduct, category: fallbackCategory }),
      image: getShopifyProductImage(shopifyProduct) || staticProduct.image,
      secondaryImage: getShopifyProductSecondaryImage(shopifyProduct) || staticProduct.secondaryImage || '',
      variants: hydratedVariants,
      subscriptionEligible: staticProduct.subscriptionEligible !== false,
      hasNativeDetails: false,
    };
  }

  function buildHydratedFallbackProducts(productsJson) {
    const shopifyProducts = Array.isArray(productsJson && productsJson.products) ? productsJson.products : [];
    if (!shopifyProducts.length) return [];

    const productByTitle = new Map();
    shopifyProducts.forEach((product) => {
      const key = normalizeProductKey(product && product.title);
      if (key && !productByTitle.has(key)) productByTitle.set(key, product);
    });

    return STATIC_PRODUCTS
      .map((staticProduct) => hydrateFallbackProduct(staticProduct, productByTitle.get(normalizeProductKey(staticProduct.label))))
      .filter(Boolean);
  }

  function fetchHydratedFallbackProducts() {
    if (!fallbackProductsHydrationPromise) {
      fallbackProductsHydrationPromise = window.fetch('/collections/all/products.json?limit=250', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      })
        .then((response) => {
          if (!response || !response.ok) {
            throw new Error(`Fallback product source failed: ${response ? response.status : 'network'}`);
          }
          return response.json();
        })
        .then(buildHydratedFallbackProducts)
        .catch((error) => {
          console.warn('[B&C bundle] Could not hydrate fallback products from Shopify', error);
          return [];
        });
    }

    return fallbackProductsHydrationPromise;
  }

  async function applySafeProductSourceFallback(panel) {
    if (!isFallbackCatalogueAllowed()) {
      state.catalogStatus = 'waiting';
      state.statusMessage = 'Bundle products are still loading. Please refresh if this does not clear.';
      state.statusKind = 'error';
      renderState(panel);
      return;
    }

    const fallbackProducts = await fetchHydratedFallbackProducts();
    if (PRODUCTS.length || state.catalogStatus === 'ready') return;

    if (fallbackProducts.length && applyProductSource(panel, fallbackProducts, 'fallback')) {
      setStatus(panel, 'Bundle products are still loading from ReCharge. Showing the live Shopify fallback catalogue for testing.', 'info');
      return;
    }

    state.catalogStatus = 'waiting';
    setStatus(panel, 'Bundle products are still loading. Please refresh if this does not clear.', 'error');
  }

  function scheduleProductSourceFallback(panel) {
    if (sourceFallbackTimer) return;
    sourceFallbackTimer = window.setTimeout(() => {
      sourceFallbackTimer = null;
      if (PRODUCTS.length || state.catalogStatus === 'ready') return;
      void applySafeProductSourceFallback(panel);
    }, CATALOG_FALLBACK_DELAY_MS);
  }

  function readRechargeProductCardData() {
    const source = new Map();
    const cards = document.querySelectorAll(
      '#recharge-bundles .recharge-bundle-product-item, #bundling-app .recharge-bundle-product-item'
    );

    cards.forEach((card) => {
      const imageButton = card.querySelector('button.recharge-bundle-product-image, button[aria-label]');
      const images = Array.from(card.querySelectorAll('img'));
      const image = images[0];
      const secondaryImage = images
        .slice(1)
        .map((node) => node.currentSrc || node.src || '')
        .find(Boolean);
      const title = normalizeFrequencyLabel(
        (imageButton && imageButton.getAttribute('aria-label')) ||
        (image && image.getAttribute('alt')) ||
        ''
      );
      const key = normalizeProductKey(title);
      if (!key || source.has(key)) return;

      source.set(key, {
        title,
        image: image ? (image.currentSrc || image.src || '') : '',
        secondaryImage: secondaryImage || '',
      });
    });

    return source;
  }

  function syncProductDisplayData(panel) {
    const dynamicProducts = collectionProductSourceStarted || hasCollectionProductSource
      ? []
      : readRechargeCollectionProducts();
    if (dynamicProducts.length) {
      return applyProductSource(panel, dynamicProducts, 'ready');
    }

    const source = readRechargeProductCardData();
    if (!source.size) return false;

    let changed = false;
    let visualChanged = false;
    PRODUCTS.forEach((product) => {
      const sourceData = source.get(normalizeProductKey(product.label));
      if (!sourceData) return;

      if (sourceData.title && product.sourceTitle !== sourceData.title) {
        product.sourceTitle = sourceData.title;
        changed = true;
        visualChanged = true;
      }
      const shouldAdoptSourceImage = !hasCollectionProductSource || !product.image;
      if (shouldAdoptSourceImage && sourceData.image && product.image !== sourceData.image) {
        product.image = sourceData.image;
        changed = true;
        visualChanged = true;
      }
      if (
        shouldAdoptSourceImage &&
        sourceData.secondaryImage &&
        product.secondaryImage !== sourceData.secondaryImage &&
        getProductImageIdentity(sourceData.secondaryImage) !== getProductImageIdentity(product.image)
      ) {
        product.secondaryImage = sourceData.secondaryImage;
        changed = true;
        visualChanged = true;
      }
      if (!product.subscriptionEligible) {
        product.subscriptionEligible = true;
        changed = true;
        visualChanged = true;
      }
      if (!product.hasNativeDetails) {
        product.hasNativeDetails = true;
        changed = true;
      }
    });

    if (visualChanged) renderState(panel);
    return changed;
  }

  function readNativeFrequencyOptions() {
    const options = [];
    const seen = new Set();
    document.querySelectorAll('#recharge-bundles option, #bundling-app option').forEach((option) => {
      const sellingPlanId = Number(option.value);
      const label = getCanonicalFrequencyLabel(option.textContent || option.label);
      if (!Number.isFinite(sellingPlanId) || sellingPlanId <= 0) return;
      if (!/\bevery\b|weekly|fortnight/i.test(label)) return;
      if (seen.has(sellingPlanId)) return;
      seen.add(sellingPlanId);
      options.push({ label, sellingPlanId });
    });
    return sanitizeFrequencyOptions(options);
  }

  function readProductJsonFrequencyOptions(product) {
    const options = [];
    const seenIds = new Set();
    const seenLabels = new Set();
    const groups = Array.isArray(product && product.selling_plan_groups) ? product.selling_plan_groups : [];

    groups.forEach((group) => {
      const plans = Array.isArray(group && group.selling_plans) ? group.selling_plans : [];
      plans.forEach((plan) => {
        const sellingPlanId = Number(plan && plan.id);
        if (!Number.isFinite(sellingPlanId) || sellingPlanId <= 0) return;
        if (seenIds.has(sellingPlanId)) return;

        const label = getCanonicalFrequencyLabel(labelFromSellingPlan(plan, group));
        const labelKey = getFrequencyCadenceKey(label);
        if (!label || !/\bevery\b/i.test(label) || seenLabels.has(labelKey)) return;

        seenIds.add(sellingPlanId);
        seenLabels.add(labelKey);
        options.push({ label, sellingPlanId });
      });
    });

    return sanitizeFrequencyOptions(options);
  }

  function frequencyOptionsSignature(options) {
    return JSON.stringify((options || []).map((item) => ({
      label: item.label,
      sellingPlanId: item.sellingPlanId,
    })));
  }

  function syncNativeFrequencyOptions(panel) {
    const nativeOptions = readNativeFrequencyOptions();
    if (!nativeOptions.length) return;
    syncFrequencyOptions(panel, nativeOptions);
  }

  function syncFrequencyOptions(panel, nextOptions) {
    const sanitizedOptions = sanitizeFrequencyOptions(nextOptions);
    if (!sanitizedOptions.length) return;
    if (frequencyOptionsSignature(sanitizedOptions) === frequencyOptionsSignature(frequencyOptions)) return;

    const previousSellingPlanId = getFrequencyOption().sellingPlanId;
    frequencyOptions = sanitizedOptions;
    const selectedIndex = frequencyOptions.findIndex((item) => item.sellingPlanId === previousSellingPlanId);
    state.frequencyIndex = selectedIndex >= 0 ? selectedIndex : 0;
    applyPendingCustomBundleDraftFrequency();
    renderState(panel);
  }

  async function syncProductJsonFrequencyOptions(panel) {
    if (productSellingPlanSyncStarted) return;
    productSellingPlanSyncStarted = true;

    try {
      const response = await window.fetch(`/products/${encodeURIComponent(BUNDLE_PRODUCT.shopifyHandle)}.js`, {
        credentials: 'same-origin',
      });
      if (!response || !response.ok) return;

      const product = await response.json();
      const productOptions = readProductJsonFrequencyOptions(product);
      syncFrequencyOptions(panel, productOptions);
    } catch (error) {
      console.warn('[B&C bundle] Could not read bundle selling plans from product JSON', error);
    }
  }

  function requestProductDisplaySync(panel) {
    if (panel && panel.__bcMvpProductSourceObserverClosed) return;
    if (productSourceSyncTimer) return;
    productSourceSyncTimer = window.setTimeout(() => {
      productSourceSyncTimer = 0;
      syncProductDisplayData(panel);
    }, PRODUCT_SOURCE_SYNC_DEBOUNCE_MS);
  }

  function disconnectProductSourceObserver(panel) {
    if (!panel) return;
    if (panel.__bcMvpProductSourceObserverTimer) {
      window.clearTimeout(panel.__bcMvpProductSourceObserverTimer);
      panel.__bcMvpProductSourceObserverTimer = 0;
    }
    if (panel.__bcMvpProductSourceObserver) {
      panel.__bcMvpProductSourceObserver.disconnect();
      panel.__bcMvpProductSourceObserver = null;
    }
    panel.__bcMvpProductSourceObserverClosed = true;
  }

  function scheduleProductSourceObserverDisconnect(panel) {
    if (!panel || panel.__bcMvpProductSourceObserverTimer) return;
    panel.__bcMvpProductSourceObserverTimer = window.setTimeout(() => {
      disconnectProductSourceObserver(panel);
    }, PRODUCT_SOURCE_OBSERVER_MAX_MS);
  }

  function setStatus(panel, message, kind) {
    state.statusMessage = String(message || '');
    state.statusKind = kind || 'info';
    const status = panel.querySelector('[data-bc-mvp-status]');
    if (!status) return;
    status.textContent = state.statusMessage;
    status.dataset.bcMvpStatus = state.statusKind;
  }

  function setBusy(panel, busy) {
    state.busy = busy;
    panel.classList.toggle('is-busy', busy);
    panel.querySelectorAll('button, input, select').forEach((control) => {
      if (busy) {
        control.dataset.bcMvpWasDisabled = control.disabled ? 'true' : 'false';
        control.disabled = true;
        return;
      }

      if (!Object.prototype.hasOwnProperty.call(control.dataset, 'bcMvpWasDisabled')) {
        return;
      }

      control.disabled = control.dataset.bcMvpWasDisabled === 'true';
      delete control.dataset.bcMvpWasDisabled;
    });
  }

  function readSelections() {
    return PRODUCTS.reduce((items, product, index) => {
      const quantity = Math.max(0, Number(state.quantities[index]) || 0);
      if (!quantity) return items;
      if (!isProductAvailableForCurrentMode(product)) return items;
      const variant = getVariant(product, index);
      items.push({
        index,
        label: product.label,
        variantLabel: variant.label,
        collectionId: product.collectionId || DEFAULT_COLLECTION_ID,
        externalProductId: product.externalProductId,
        externalVariantId: variant.externalVariantId,
        quantity,
        unitPricePence: getUnitPricePence(variant),
      });
      return items;
    }, []);
  }

  function buildRechargeBundle() {
    const selections = readSelections().map((item) => ({
      collectionId: item.collectionId,
      externalProductId: item.externalProductId,
      externalVariantId: item.externalVariantId,
      quantity: item.quantity,
      ...(getActivePurchaseMode() === 'subscription' ? { sellingPlan: getFrequencyOption().sellingPlanId } : {}),
    }));
    return {
      externalProductId: BUNDLE_PRODUCT.externalProductId,
      externalVariantId: BUNDLE_PRODUCT.externalVariantId,
      selections,
    };
  }

  function buildBoxContents() {
    return readSelections().map((item) => {
      const variantText = item.variantLabel && item.variantLabel !== 'Default Title' ? ` (${item.variantLabel})` : '';
      return `${item.label}${variantText} x ${item.quantity}`;
    }).join(', ');
  }

  function isCustomBundleDraftPersistenceEnabled() {
    const params = new URLSearchParams(window.location.search || '');
    const value = String(params.get(CUSTOM_BUNDLE_DRAFT_QUERY_KEY) || '').trim().toLowerCase();
    if (['0', 'false', 'off', 'no', 'disabled'].includes(value)) return false;
    if (window.BC_CUSTOM_BUNDLE_MVP_PERSISTENCE?.enabled === false) return false;
    return true;
  }

  function getCustomBundleDraftStorage(storageName) {
    try {
      return window[storageName] || null;
    } catch (error) {
      return null;
    }
  }

  function hasSeenFamilyPresetIntro() {
    try {
      const storageKey = REQUESTED_PREBUILT_PRESET?.id === 'family-bundle'
        ? FAMILY_PRESET_INTRO_SESSION_KEY
        : `bcPrebuiltBundleIntroSeen:v1:${REQUESTED_PREBUILT_PRESET?.id || 'none'}`;
      return window.sessionStorage.getItem(storageKey) === 'true';
    } catch (error) {
      return false;
    }
  }

  function showFamilyPresetIntro(panel) {
    if (!REQUESTED_PREBUILT_PRESET || familyPresetIntroShown || hasSeenFamilyPresetIntro()) return;

    const dialog = document.createElement('dialog');
    dialog.className = 'bc-custom-bundle-mvp__preset-intro';
    dialog.dataset.bcFamilyPresetIntro = 'true';
    dialog.setAttribute('aria-labelledby', 'bc-family-preset-intro-title');
    dialog.setAttribute('aria-describedby', 'bc-family-preset-intro-copy');
    dialog.innerHTML = `
      <div class="bc-custom-bundle-mvp__preset-intro-content">
        <button type="button" class="bc-custom-bundle-mvp__preset-intro-close" data-bc-family-preset-intro-close aria-label="Close">×</button>
        <h2 id="bc-family-preset-intro-title">${REQUESTED_PREBUILT_PRESET.title}</h2>
        <p id="bc-family-preset-intro-copy">${REQUESTED_PREBUILT_PRESET.intro}</p>
        <button type="button" class="bc-custom-bundle-mvp__preset-intro-cta" data-bc-family-preset-intro-close>
          <span>Shop now</span><span aria-hidden="true">&gt;</span>
        </button>
      </div>
    `;

    const closeDialog = () => {
      if (dialog.open && typeof dialog.close === 'function') dialog.close();
      else dialog.remove();
    };
    dialog.addEventListener('click', (event) => {
      const closeControl = event.target instanceof Element
        ? event.target.closest('[data-bc-family-preset-intro-close]')
        : null;
      if (event.target === dialog || closeControl) closeDialog();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('bc-family-preset-intro-open');
      dialog.remove();
      const nextControl = Array.from(panel.querySelectorAll('[data-bc-mvp-scroll-category], [data-bc-mvp-product-info]'))
        .find((control) => control instanceof HTMLElement && control.offsetParent !== null);
      if (nextControl) window.requestAnimationFrame(() => nextControl.focus({ preventScroll: true }));
    }, { once: true });

    familyPresetIntroShown = true;
    try {
      const storageKey = REQUESTED_PREBUILT_PRESET.id === 'family-bundle'
        ? FAMILY_PRESET_INTRO_SESSION_KEY
        : `bcPrebuiltBundleIntroSeen:v1:${REQUESTED_PREBUILT_PRESET.id}`;
      window.sessionStorage.setItem(storageKey, 'true');
    } catch (error) {
    }
    document.body.appendChild(dialog);
    document.documentElement.classList.add('bc-family-preset-intro-open');
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    dialog.querySelector('.bc-custom-bundle-mvp__preset-intro-cta')?.focus();
  }

  function normalizeCustomBundleDraftId(value) {
    return String(value == null ? '' : value).trim();
  }

  function isCustomBundleDraftEnvelope(draft) {
    return Boolean(
      draft &&
        typeof draft === 'object' &&
        Number(draft.schemaVersion) === CUSTOM_BUNDLE_DRAFT_SCHEMA_VERSION &&
        draft.productHandle === BUNDLE_PRODUCT.shopifyHandle &&
        Array.isArray(draft.items)
    );
  }

  function isCustomBundleDraftCompatible(draft) {
    if (!isCustomBundleDraftEnvelope(draft)) return false;
    const expiresAt = Number(draft.expiresAt) || 0;
    if (expiresAt && expiresAt <= Date.now()) return false;
    return draft.items.some((item) => Number(item && item.quantity) > 0);
  }

  function readCustomBundleDraftFromStorage(storage) {
    try {
      const rawDraft = storage && storage.getItem(CUSTOM_BUNDLE_DRAFT_STORAGE_KEY);
      if (!rawDraft) return null;
      const parsedDraft = JSON.parse(rawDraft);
      return isCustomBundleDraftEnvelope(parsedDraft) ? parsedDraft : null;
    } catch (error) {
      return null;
    }
  }

  function clearCustomBundleDraft() {
    customBundleDraftLastSignature = '';
    ['sessionStorage', 'localStorage'].forEach((storageName) => {
      const storage = getCustomBundleDraftStorage(storageName);
      try {
        storage && storage.removeItem(CUSTOM_BUNDLE_DRAFT_STORAGE_KEY);
      } catch (error) {
        // Ignore storage failures.
      }
    });
  }

  function readStoredCustomBundleDraft() {
    const sessionDraft = readCustomBundleDraftFromStorage(getCustomBundleDraftStorage('sessionStorage'));
    if (sessionDraft) {
      if (isCustomBundleDraftCompatible(sessionDraft)) return sessionDraft;
      clearCustomBundleDraft();
      return null;
    }

    const localDraft = readCustomBundleDraftFromStorage(getCustomBundleDraftStorage('localStorage'));
    if (localDraft) {
      if (isCustomBundleDraftCompatible(localDraft)) return localDraft;
      clearCustomBundleDraft();
    }

    return null;
  }

  function buildCustomBundleDraftSignature(draft) {
    if (!draft) return '';
    return JSON.stringify({
      productHandle: draft.productHandle,
      purchaseMode: draft.purchaseMode,
      sellingPlanId: Number(draft.frequency && draft.frequency.sellingPlanId) || 0,
      rewardChoices: draft.rewardChoices || {},
      items: (draft.items || []).map((item) => ({
        product: normalizeCustomBundleDraftId(item && item.externalProductId),
        variant: normalizeCustomBundleDraftId(item && item.externalVariantId),
        quantity: Math.max(0, Number(item && item.quantity) || 0),
      })),
    });
  }

  function persistCustomBundleDraft(draft) {
    if (!isCustomBundleDraftCompatible(draft)) return false;

    const serializedDraft = JSON.stringify(draft);
    let persisted = false;

    ['sessionStorage', 'localStorage'].forEach((storageName) => {
      const storage = getCustomBundleDraftStorage(storageName);
      try {
        if (storage) {
          storage.setItem(CUSTOM_BUNDLE_DRAFT_STORAGE_KEY, serializedDraft);
          persisted = true;
        }
      } catch (error) {
        // Ignore storage failures.
      }
    });

    return persisted;
  }

  function buildCustomBundleDraft(source = 'unknown', { ttlMs = null } = {}) {
    const selections = readSelections();
    if (!selections.length) return null;

    const now = Date.now();
    const activeMode = getActivePurchaseMode();
    const frequency = activeMode === 'subscription' ? getFrequencyOption() : null;
    const selectedTtlMs = Number.isFinite(ttlMs) && ttlMs > 0
      ? ttlMs
      : CUSTOM_BUNDLE_DRAFT_TTL_MS;

    return {
      schemaVersion: CUSTOM_BUNDLE_DRAFT_SCHEMA_VERSION,
      featureVersion: CUSTOM_BUNDLE_DRAFT_FEATURE_VERSION,
      source,
      createdAt: now,
      updatedAt: now,
      expiresAt: now + selectedTtlMs,
      productHandle: BUNDLE_PRODUCT.shopifyHandle,
      path: normalizePath(window.location.pathname),
      purchaseMode: activeMode,
      frequency: frequency ? {
        sellingPlanId: Number(frequency.sellingPlanId) || 0,
        label: normalizeFrequencyLabel(frequency.label),
      } : null,
      rewardChoices: {
        3000: state.rewardPreviewChoices[3000] || '',
        4000: state.rewardPreviewChoices[4000] || '',
        5000: state.rewardPreviewChoices[5000] || '',
      },
      items: selections.map((item) => ({
        externalProductId: normalizeCustomBundleDraftId(item.externalProductId),
        externalVariantId: normalizeCustomBundleDraftId(item.externalVariantId),
        quantity: Math.max(0, Number(item.quantity) || 0),
      })),
    };
  }

  function shouldClearCustomBundleDraftOnEmptyCapture(source) {
    return /^(selection|variant|purchase-mode|frequency|sheet-frequency|sheet-plan)/.test(String(source || ''));
  }

  function captureAndPersistCustomBundleDraft(source = 'unknown', { force = false, ttlMs = null } = {}) {
    if (!isCustomBundleDraftPersistenceEnabled()) return null;

    const draft = buildCustomBundleDraft(source, { ttlMs });
    if (!draft) {
      if (shouldClearCustomBundleDraftOnEmptyCapture(source)) {
        clearCustomBundleDraft();
      }
      return null;
    }

    const signature = buildCustomBundleDraftSignature(draft);
    if (!force && signature === customBundleDraftLastSignature) return draft;

    customBundleDraftLastSignature = signature;
    persistCustomBundleDraft(draft);
    return draft;
  }

  function isTruthyCartProperty(value) {
    if (value === true || value === 1) return true;
    return ['1', 'true', 'yes', 'on'].includes(String(value || '').trim().toLowerCase());
  }

  function isCustomBundleMvpCartLine(item) {
    const properties = item && item.properties ? item.properties : {};
    return Boolean(
      properties._rc_bundle &&
        properties._rc_bundle_parent === BUNDLE_PRODUCT.shopifyHandle &&
        isTruthyCartProperty(properties._bc_custom_builder_mvp)
    );
  }

  function getNewestCustomBundleMvpCartGroup(cart) {
    const groups = new Map();
    const orderedGroupIds = [];

    (Array.isArray(cart && cart.items) ? cart.items : []).forEach((item) => {
      if (!isCustomBundleMvpCartLine(item)) return;
      const bundleId = normalizeCustomBundleDraftId(item.properties && item.properties._rc_bundle);
      if (!bundleId) return;
      if (!groups.has(bundleId)) {
        groups.set(bundleId, []);
        orderedGroupIds.push(bundleId);
      }
      groups.get(bundleId).push(item);
    });

    return groups.get(orderedGroupIds[0]) || [];
  }

  function getCartLineSellingPlanId(item) {
    const properties = item && item.properties ? item.properties : {};
    const allocation = item && item.selling_plan_allocation;
    const sellingPlan = allocation && allocation.selling_plan;
    const candidates = [
      sellingPlan && sellingPlan.id,
      item && item.selling_plan_id,
      item && typeof item.selling_plan === 'object' ? item.selling_plan.id : item && item.selling_plan,
      properties.selling_plan,
      properties._selling_plan,
    ];

    for (const candidate of candidates) {
      const raw = String(candidate == null ? '' : candidate).trim();
      if (/^\d+$/.test(raw)) return Number(raw);
    }

    return 0;
  }

  function getCartLineSellingPlanLabel(item) {
    const allocation = item && item.selling_plan_allocation;
    const sellingPlan = allocation && allocation.selling_plan;
    if (sellingPlan && sellingPlan.name) return normalizeFrequencyLabel(sellingPlan.name);
    if (item && typeof item.selling_plan === 'object' && item.selling_plan.name) {
      return normalizeFrequencyLabel(item.selling_plan.name);
    }
    if (typeof (item && item.selling_plan) === 'string') return normalizeFrequencyLabel(item.selling_plan);
    return '';
  }

  function isSubscriptionCartLine(item) {
    return Boolean(
      (item && item.selling_plan_allocation) ||
        getCartLineSellingPlanId(item) ||
        getCartLineSellingPlanLabel(item)
    );
  }

  function findCustomBundleProductMatch(item) {
    const externalProductId = normalizeCustomBundleDraftId(item && item.externalProductId);
    const externalVariantId = normalizeCustomBundleDraftId(item && item.externalVariantId);

    for (let productIndex = 0; productIndex < PRODUCTS.length; productIndex += 1) {
      const product = PRODUCTS[productIndex];
      const productMatches = !externalProductId ||
        normalizeCustomBundleDraftId(product.externalProductId) === externalProductId;
      const variantIndex = (product.variants || []).findIndex((variantData) => (
        normalizeCustomBundleDraftId(variantData.externalVariantId) === externalVariantId
      ));

      if (productMatches && variantIndex >= 0) {
        return { productIndex, variantIndex };
      }
    }

    if (externalVariantId) {
      for (let productIndex = 0; productIndex < PRODUCTS.length; productIndex += 1) {
        const product = PRODUCTS[productIndex];
        const variantIndex = (product.variants || []).findIndex((variantData) => (
          normalizeCustomBundleDraftId(variantData.externalVariantId) === externalVariantId
        ));
        if (variantIndex >= 0) return { productIndex, variantIndex };
      }
    }

    if (externalProductId) {
      const productIndex = PRODUCTS.findIndex((product) => (
        normalizeCustomBundleDraftId(product.externalProductId) === externalProductId
      ));
      if (productIndex >= 0) return { productIndex, variantIndex: 0 };
    }

    return null;
  }

  function buildCustomBundleDraftFromCart(cart) {
    const groupLines = getNewestCustomBundleMvpCartGroup(cart);
    if (!groupLines.length) return null;

    const itemsByKey = new Map();
    let sellingPlanId = 0;
    let frequencyLabel = '';
    let hasSubscription = false;
    const rewardChoices = { 3000: '', 4000: '', 5000: '' };

    groupLines.forEach((line) => {
      if (!sellingPlanId) sellingPlanId = getCartLineSellingPlanId(line);
      if (!frequencyLabel) frequencyLabel = getCartLineSellingPlanLabel(line);
      if (isSubscriptionCartLine(line)) hasSubscription = true;
      if (!rewardChoices[3000]) {
        rewardChoices[3000] = String(line?.properties?._bc_reward_skipped_3000 || '').trim() === 'true'
          ? REWARD_PREVIEW_SKIPPED
          : String(line?.properties?._bc_reward_choice_3000 || '').trim();
      }
      if (!rewardChoices[4000]) {
        rewardChoices[4000] = String(line?.properties?._bc_reward_skipped_4000 || '').trim() === 'true'
          ? REWARD_PREVIEW_SKIPPED
          : String(
            line?.properties?._bc_reward_choice_4000 || line?.properties?._bc_final_reward_choice || ''
          ).trim();
      }
      if (!rewardChoices[5000]) {
        rewardChoices[5000] = String(line?.properties?._bc_reward_skipped_5000 || '').trim() === 'true'
          ? REWARD_PREVIEW_SKIPPED
          : String(line?.properties?._bc_reward_choice_5000 || '').trim();
      }

      const draftItem = {
        externalProductId: normalizeCustomBundleDraftId(line && line.product_id),
        externalVariantId: normalizeCustomBundleDraftId((line && line.variant_id) || (line && line.id)),
        quantity: Math.max(0, Number(line && line.quantity) || 0),
      };
      if (!draftItem.quantity || !draftItem.externalVariantId) return;

      const match = findCustomBundleProductMatch(draftItem);
      if (!match) return;

      const product = PRODUCTS[match.productIndex];
      const variantData = product && product.variants && product.variants[match.variantIndex];
      if (!product || !variantData) return;

      const key = `${product.externalProductId}:${variantData.externalVariantId}`;
      const previous = itemsByKey.get(key);
      itemsByKey.set(key, {
        externalProductId: normalizeCustomBundleDraftId(product.externalProductId),
        externalVariantId: normalizeCustomBundleDraftId(variantData.externalVariantId),
        quantity: (previous ? previous.quantity : 0) + draftItem.quantity,
      });
    });

    const items = Array.from(itemsByKey.values()).filter((item) => item.quantity > 0);
    if (!items.length) return null;

    const now = Date.now();
    return {
      schemaVersion: CUSTOM_BUNDLE_DRAFT_SCHEMA_VERSION,
      featureVersion: CUSTOM_BUNDLE_DRAFT_FEATURE_VERSION,
      source: 'cart',
      createdAt: now,
      updatedAt: now,
      expiresAt: now + CUSTOM_BUNDLE_DRAFT_CHECKOUT_TTL_MS,
      productHandle: BUNDLE_PRODUCT.shopifyHandle,
      path: normalizePath(window.location.pathname),
      purchaseMode: isSubscriptionOnlyBundle() || hasSubscription ? 'subscription' : 'onetime',
      frequency: hasSubscription ? {
        sellingPlanId,
        label: frequencyLabel,
      } : null,
      rewardChoices,
      items,
    };
  }

  function findFrequencyOptionIndex({ sellingPlanId = 0, label = '' } = {}) {
    const normalizedSellingPlanId = Number(sellingPlanId) || 0;
    if (normalizedSellingPlanId) {
      const index = frequencyOptions.findIndex((option) => (
        Number(option && option.sellingPlanId) === normalizedSellingPlanId
      ));
      if (index >= 0) return index;
    }

    const normalizedLabel = normalizeFrequencyLabel(label);
    if (normalizedLabel) {
      const cadenceKey = getFrequencyCadenceKey(normalizedLabel);
      const index = frequencyOptions.findIndex((option) => (
        getFrequencyCadenceKey(option && option.label) === cadenceKey
      ));
      if (index >= 0) return index;
    }

    return -1;
  }

  function applyCustomBundleDraftFrequency(frequency) {
    const sellingPlanId = Number(frequency && frequency.sellingPlanId) || 0;
    const label = normalizeFrequencyLabel(frequency && frequency.label);
    const index = findFrequencyOptionIndex({ sellingPlanId, label });

    if (index >= 0) {
      state.frequencyIndex = index;
      customBundleDraftPendingSellingPlanId = 0;
      customBundleDraftPendingFrequencyLabel = '';
      return true;
    }

    customBundleDraftPendingSellingPlanId = sellingPlanId;
    customBundleDraftPendingFrequencyLabel = label;
    return false;
  }

  function applyPendingCustomBundleDraftFrequency() {
    if (!customBundleDraftPendingSellingPlanId && !customBundleDraftPendingFrequencyLabel) return false;
    const index = findFrequencyOptionIndex({
      sellingPlanId: customBundleDraftPendingSellingPlanId,
      label: customBundleDraftPendingFrequencyLabel,
    });

    if (index < 0) return false;

    state.frequencyIndex = index;
    customBundleDraftPendingSellingPlanId = 0;
    customBundleDraftPendingFrequencyLabel = '';
    return true;
  }

  function applyCustomBundleDraft(panel, draft, source) {
    if (!panel || !isCustomBundleDraftCompatible(draft) || !PRODUCTS.length) return false;
    if (customBundleDraftUserInteracted && source !== 'manual') return false;

    const nextQuantities = PRODUCTS.map(() => 0);
    const nextVariantIndexes = PRODUCTS.map(() => 0);
    const nextPurchaseMode = draft.purchaseMode === 'onetime' && !isSubscriptionOnlyBundle()
      ? 'onetime'
      : 'subscription';
    let restoredCount = 0;

    draft.items.forEach((item) => {
      const quantity = Math.max(0, Number(item && item.quantity) || 0);
      if (!quantity) return;

      const match = findCustomBundleProductMatch(item);
      if (!match) return;
      if (nextPurchaseMode === 'subscription' && !isSubscriptionEligible(PRODUCTS[match.productIndex])) return;

      nextQuantities[match.productIndex] += quantity;
      nextVariantIndexes[match.productIndex] = match.variantIndex;
      restoredCount += quantity;
    });

    if (!restoredCount) return false;

    state.purchaseMode = nextPurchaseMode;
    state.quantities = nextQuantities;
    state.variantIndexes = nextVariantIndexes;
    REWARD_CHOICE_SLOTS.forEach((slot) => {
      const choiceId = String(draft.rewardChoices?.[slot] || '').trim();
      state.rewardPreviewChoices[slot] = choiceId === REWARD_PREVIEW_SKIPPED
        ? REWARD_PREVIEW_SKIPPED
        : REWARD_PREVIEW_CHOICES.some((choice) => choice.id === choiceId)
        ? choiceId
        : '';
    });
    const restoredChoices = new Set();
    REWARD_CHOICE_SLOTS.forEach((slot) => {
      const choiceId = state.rewardPreviewChoices[slot];
      if (!isRewardChoiceId(choiceId)) return;
      if (restoredChoices.has(choiceId)) state.rewardPreviewChoices[slot] = '';
      else restoredChoices.add(choiceId);
    });
    if (state.purchaseMode === 'subscription') {
      applyCustomBundleDraftFrequency(draft.frequency);
      removeUnavailableSubscriptionSelections();
    } else {
      customBundleDraftPendingSellingPlanId = 0;
      customBundleDraftPendingFrequencyLabel = '';
    }
    state.sheetOpen = false;
    state.rewardsInfoOpen = false;
    state.cartOpen = false;
    state.statusMessage = '';
    state.statusKind = 'info';

    captureAndPersistCustomBundleDraft(`restore-${source || 'draft'}`, {
      force: true,
      ttlMs: source === 'cart' ? CUSTOM_BUNDLE_DRAFT_CHECKOUT_TTL_MS : CUSTOM_BUNDLE_DRAFT_TTL_MS,
    });
    renderState(panel);
    return true;
  }

  function applyFamilyPreset(panel) {
    const preset = REQUESTED_PREBUILT_PRESET;
    if (!panel || !preset || state.catalogStatus !== 'ready' || !PRODUCTS.length) return false;

    const nextQuantities = PRODUCTS.map(() => 0);
    const nextVariantIndexes = PRODUCTS.map(() => 0);
    for (const item of preset.items) {
      const match = findCustomBundleProductMatch(item);
      if (!match || (
        REQUESTED_FAMILY_PRESET_PURCHASE_MODE === 'subscription' &&
        !isSubscriptionEligible(PRODUCTS[match.productIndex])
      )) {
        panel.dataset.bcMvpPresetStatus = 'rejected';
        panel.dataset.bcMvpPresetId = preset.id;
        state.statusMessage = 'That starting breakfast is temporarily unavailable. Your existing cart has not been changed.';
        state.statusKind = 'error';
        renderState(panel);
        return false;
      }
      nextQuantities[match.productIndex] += item.quantity;
      nextVariantIndexes[match.productIndex] = match.variantIndex;
    }

    state.purchaseMode = REQUESTED_FAMILY_PRESET_PURCHASE_MODE;
    state.frequencyIndex = 0;
    state.quantities = nextQuantities;
    state.variantIndexes = nextVariantIndexes;
    REWARD_CHOICE_SLOTS.forEach((slot) => {
      state.rewardPreviewChoices[slot] = '';
    });
    state.sheetOpen = false;
    state.rewardsInfoOpen = false;
    state.cartOpen = false;
    state.statusMessage = preset.status;
    state.statusKind = 'info';
    customBundleDraftUserInteracted = true;
    customBundleDraftRestoreCompleted = true;
    panel.dataset.bcMvpPresetStatus = 'applied';
    panel.dataset.bcMvpPresetId = preset.id;
    captureAndPersistCustomBundleDraft(`${preset.id}-preset`, { force: true });
    renderState(panel);
    try {
      const url = new URL(window.location.href);
      url.searchParams.delete('preset');
      window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
    } catch (error) {
    }
    window.requestAnimationFrame(() => showFamilyPresetIntro(panel));
    warmBundleCartFlowScript();
    publishBundleFunnelEvent('bc_bundle_preset_applied', {
      preset_id: preset.id,
      item_count: getItemCount(),
      subtotal_pence: getSubtotalPence(),
      purchase_mode: getActivePurchaseMode(),
    });
    return true;
  }

  async function readCartBackedCustomBundleDraft() {
    try {
      const cart = await fetchCartWithRetry();
      return buildCustomBundleDraftFromCart(cart);
    } catch (error) {
      console.warn('[B&C bundle] Could not restore bundle draft from cart.', error);
      return null;
    }
  }

  function requestCustomBundleDraftRestore(panel, { force = false } = {}) {
    if (!panel || !PRODUCTS.length) return Promise.resolve(false);
    if (REQUESTED_PREBUILT_PRESET && !familyPresetRequestHandled) {
      if (state.catalogStatus !== 'ready') return Promise.resolve(false);
      familyPresetRequestHandled = true;
      return Promise.resolve(applyFamilyPreset(panel));
    }
    if (!isCustomBundleDraftPersistenceEnabled()) return Promise.resolve(false);
    if (!force && customBundleDraftRestoreCompleted) return Promise.resolve(false);
    if (customBundleDraftRestorePromise) return customBundleDraftRestorePromise;

    customBundleDraftRestorePromise = (async () => {
      if (customBundleDraftUserInteracted || getItemCount() > 0) {
        customBundleDraftRestoreCompleted = true;
        return false;
      }

      const storedDraft = readStoredCustomBundleDraft();
      const restoredStoredDraft = !customBundleDraftUserInteracted &&
        applyCustomBundleDraft(panel, storedDraft, 'storage');
      const cartDraft = await readCartBackedCustomBundleDraft();
      if (!customBundleDraftUserInteracted && cartDraft) {
        const cartMatchesStored = restoredStoredDraft &&
          buildCustomBundleDraftSignature(cartDraft) === buildCustomBundleDraftSignature(storedDraft);
        if (!cartMatchesStored) applyCustomBundleDraft(panel, cartDraft, 'cart');
        customBundleDraftRestoreCompleted = true;
        return true;
      }

      if (restoredStoredDraft) {
        customBundleDraftRestoreCompleted = true;
        return true;
      }

      customBundleDraftRestoreCompleted = true;
      return false;
    })().finally(() => {
      customBundleDraftRestorePromise = null;
    });

    return customBundleDraftRestorePromise;
  }

  function rememberCustomBundleDraftInteraction(source, { ttlMs = null, force = false } = {}) {
    customBundleDraftUserInteracted = true;
    customBundleDraftRestoreCompleted = true;
    completeInitialBuilderHydration(document.querySelector('[data-bc-custom-bundle-mvp]'));
    if (/frequency|purchase-mode|sheet-plan/.test(String(source || ''))) {
      customBundleDraftPendingSellingPlanId = 0;
      customBundleDraftPendingFrequencyLabel = '';
    }
    captureAndPersistCustomBundleDraft(source, { ttlMs, force });
  }

  function isCustomBundleHistoryRestoreNavigation() {
    try {
      const navigation = window.performance &&
        window.performance.getEntriesByType &&
        window.performance.getEntriesByType('navigation')[0];
      return navigation && navigation.type === 'back_forward';
    } catch (error) {
      return false;
    }
  }

  function installCustomBundleDraftLifecycleHandlers(panel) {
    if (!panel || panel.__bcMvpDraftLifecycleBound) return;
    panel.__bcMvpDraftLifecycleBound = true;

    window.addEventListener('pagehide', () => {
      captureAndPersistCustomBundleDraft('pagehide', {
        force: true,
        ttlMs: CUSTOM_BUNDLE_DRAFT_CHECKOUT_TTL_MS,
      });
    }, { capture: true });

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState !== 'hidden') return;
      captureAndPersistCustomBundleDraft('visibility-hidden', {
        force: true,
        ttlMs: CUSTOM_BUNDLE_DRAFT_CHECKOUT_TTL_MS,
      });
    });

    window.addEventListener('pageshow', (event) => {
      if (!event.persisted && !isCustomBundleHistoryRestoreNavigation()) return;
      customBundleDraftRestoreCompleted = false;
      void requestCustomBundleDraftRestore(panel, { force: true });
    }, { passive: true });

    window.bcCustomBundleMvpDraftStatus = function bcCustomBundleMvpDraftStatus() {
      return {
        enabled: isCustomBundleDraftPersistenceEnabled(),
        productHandle: BUNDLE_PRODUCT.shopifyHandle,
        storageKey: CUSTOM_BUNDLE_DRAFT_STORAGE_KEY,
        itemCount: getItemCount(),
        restoreCompleted: customBundleDraftRestoreCompleted,
        pendingSellingPlanId: customBundleDraftPendingSellingPlanId || null,
        pendingFrequencyLabel: customBundleDraftPendingFrequencyLabel || null,
        storedDraft: readStoredCustomBundleDraft(),
      };
    };
  }

  function getFinalRewardPresentation() {
    if (REWARD_PREVIEW_CONCEPT === 'orzo') {
      return {
        short: 'Orzo Salad',
        name: 'an Antipasti Orzo Salad',
        detailName: 'Antipasti Orzo Salad',
        price: '£7.20',
        image: REWARD_PREVIEW_CHOICES.find((choice) => choice.id === 'orzo').image,
        description: REWARD_PREVIEW_CHOICES.find((choice) => choice.id === 'orzo').description,
        icon: 'gift',
      };
    }
    if (REWARD_PREVIEW_CONCEPT === 'mystery') {
      return {
        short: 'Mystery Gift',
        name: 'a Mystery Gift worth £7.20',
        detailName: 'Mystery Gift',
        price: '£7.20',
        image: '',
        description: 'A surprise gift worth £7.20, added free when your subscription bundle qualifies.',
        icon: 'mystery',
      };
    }
    if (REWARD_PREVIEW_CONCEPT === 'choice') {
      return {
        short: 'Choose Your Gift',
        name: 'your choice of free gift',
        detailName: 'Choose Your Gift',
        price: 'Up to £7.20',
        image: '',
        description: 'Choose from three gifts for your subscription order.',
        icon: 'mystery',
      };
    }
    return {
      short: 'Cotton Bread Bag',
      name: 'a Cotton Bread Bag',
      detailName: 'Cotton Bread Bag',
      price: '£12.95',
      image: BREAD_BAG_IMAGE_URL,
      description: '100% cotton bread bag.',
      icon: 'bag',
    };
  }

  function getRewardDisplaySubtotalPence() {
    const subtotal = getSubtotalPence();
    return REWARD_PREVIEW_FORCE_UNLOCKED ? Math.max(5000, subtotal) : subtotal;
  }

  function getEligibleRewardChoiceSlots() {
    if (REWARD_PREVIEW_CONCEPT !== 'choice' || getActivePurchaseMode() !== 'subscription') return [];
    const subtotal = getRewardDisplaySubtotalPence();
    return REWARD_CHOICE_SLOTS.filter((slot) => subtotal >= slot);
  }

  function clearIneligibleRewardChoiceState() {
    const eligibleSlots = new Set(getEligibleRewardChoiceSlots());
    let changed = false;

    REWARD_CHOICE_SLOTS.forEach((slot) => {
      if (!eligibleSlots.has(slot) && state.rewardPreviewChoices[slot]) {
        state.rewardPreviewChoices[slot] = '';
        changed = true;
      }
    });

    return changed;
  }

  function getMissingRewardChoiceSlot() {
    const eligibleSlots = getEligibleRewardChoiceSlots();
    const selectedChoices = new Set();
    for (const slot of eligibleSlots) {
      const choiceId = state.rewardPreviewChoices[slot];
      if (!choiceId || (isRewardChoiceId(choiceId) && selectedChoices.has(choiceId))) return slot;
      if (isRewardChoiceId(choiceId)) selectedChoices.add(choiceId);
    }
    return 0;
  }

  function isRewardChoiceId(value) {
    return REWARD_PREVIEW_CHOICES.some((choice) => choice.id === value);
  }

  function isRewardChoiceSkipped(value) {
    return value === REWARD_PREVIEW_SKIPPED;
  }

  function isRewardChoiceUsedInOtherSlot(choiceId, slot) {
    return REWARD_CHOICE_SLOTS.some((candidateSlot) => (
      candidateSlot !== Number(slot) && state.rewardPreviewChoices[candidateSlot] === choiceId
    ));
  }

  function shouldPromptForRewardChoice() {
    return getMissingRewardChoiceSlot();
  }

  function promptForRewardChoiceBeforeAdd(panel, continueTarget) {
    const eligibleSlots = getEligibleRewardChoiceSlots();
    if (!eligibleSlots.length) return false;
    openGiftPicker(panel, eligibleSlots[0], true, continueTarget);
    return true;
  }

  function hasSelectedRewardGift() {
    return getSelectedRewardGiftCount() > 0;
  }

  function getSelectedRewardGiftCount() {
    return REWARD_CHOICE_SLOTS.filter((slot) => isRewardChoiceId(state.rewardPreviewChoices[slot])).length;
  }

  function scheduleGiftPickerFocus(panel) {
    if (!state.giftPickerOpen) return;

    window.requestAnimationFrame(() => {
      if (!state.giftPickerOpen) return;
      const dialog = panel.querySelector('.bc-custom-bundle-mvp__gift-picker-card[role="dialog"]');
      const target = dialog?.querySelector(
        '[data-bc-mvp-gift-picker-choice][aria-checked="true"]:not(:disabled), ' +
        '[data-bc-mvp-gift-picker-choice]:not(:disabled), ' +
        '[data-bc-mvp-gift-picker-close]'
      );
      target?.focus();
    });
  }

  function getGiftPickerReturnFocusSelector(element) {
    if (!element?.getAttribute) return '';
    const rewardSlot = element.getAttribute('data-bc-mvp-gift-picker-open');
    if (rewardSlot) return `[data-bc-mvp-gift-picker-open="${rewardSlot}"]`;
    if (element.hasAttribute('data-bc-mvp-add')) return '[data-bc-mvp-add]';
    if (element.hasAttribute('data-bc-mvp-sheet-confirm')) return '[data-bc-mvp-add]';
    return '';
  }

  function restoreGiftPickerFocus(panel) {
    const returnFocus = giftPickerReturnFocusElement;
    const returnFocusSelector = giftPickerReturnFocusSelector;
    giftPickerReturnFocusElement = null;
    giftPickerReturnFocusSelector = '';

    window.requestAnimationFrame(() => {
      const selectorTarget = returnFocusSelector
        ? Array.from(panel.querySelectorAll(returnFocusSelector)).find((element) => element.getClientRects().length > 0)
        : null;
      const focusTarget = returnFocus?.isConnected ? returnFocus : selectorTarget;
      focusTarget?.focus();
    });
  }

  function closeGiftPicker(panel, { restoreFocus = true } = {}) {
    state.giftPickerDraftChoice = state.rewardPreviewChoices[state.giftPickerSlot] || '';
    state.giftPickerDraftChoices = [];
    state.giftPickerMultiSlot = false;
    state.giftPickerOpen = false;
    state.giftPickerSlot = 0;
    state.giftPickerTriggeredByAdd = false;
    state.giftPickerContinueTarget = '';
    renderState(panel);
    if (restoreFocus) restoreGiftPickerFocus(panel);
  }

  function openGiftPicker(panel, slot, triggeredByAdd, continueTarget = '') {
    const eligibleSlots = getEligibleRewardChoiceSlots();
    const rewardSlot = Number(slot) || getMissingRewardChoiceSlot() || eligibleSlots[0];
    if (!REWARD_CHOICE_SLOTS.includes(rewardSlot)) return;
    const useMultiSlotPicker = eligibleSlots.length > 1;
    state.sheetOpen = false;
    state.rewardsInfoOpen = false;
    state.giftPickerMultiSlot = useMultiSlotPicker;
    state.giftPickerDraftChoices = useMultiSlotPicker
      ? eligibleSlots.reduce((choices, eligibleSlot) => {
        const choiceId = state.rewardPreviewChoices[eligibleSlot];
        if (isRewardChoiceId(choiceId) && !choices.includes(choiceId)) choices.push(choiceId);
        return choices;
      }, [])
      : [];
    state.giftPickerSlot = useMultiSlotPicker ? 0 : rewardSlot;
    const savedChoice = useMultiSlotPicker ? '' : state.rewardPreviewChoices[rewardSlot] || '';
    state.giftPickerDraftChoice = isRewardChoiceId(savedChoice) && !isRewardChoiceUsedInOtherSlot(savedChoice, rewardSlot)
      ? savedChoice
      : '';
    state.giftPickerTriggeredByAdd = Boolean(triggeredByAdd);
    state.giftPickerContinueTarget = triggeredByAdd ? continueTarget : '';
    if (!giftPickerReturnFocusElement && typeof document.activeElement?.focus === 'function') {
      giftPickerReturnFocusElement = document.activeElement;
      giftPickerReturnFocusSelector = getGiftPickerReturnFocusSelector(document.activeElement);
    }
    state.giftPickerOpen = true;
    renderState(panel);
  }

  function continueAfterGiftPicker(panel, shouldContinue, continueTarget = '') {
    if (!shouldContinue) {
      restoreGiftPickerFocus(panel);
      return;
    }

    giftPickerReturnFocusElement = null;
    giftPickerReturnFocusSelector = '';
    if (continueTarget === 'cart') {
      addBundleToCart(panel);
      return;
    }
    if (isMobileViewport()) {
      state.oneTimeGiftWarningOpen = false;
      state.sheetOpen = true;
      renderState(panel);
      return;
    }

    addBundleToCart(panel);
  }

  function focusGiftLossWarning(panel) {
    window.requestAnimationFrame(() => {
      panel.querySelector('[data-bc-mvp-gift-loss-heading]')?.focus();
    });
  }

  function focusOneTimePlanOption(panel) {
    window.requestAnimationFrame(() => {
      panel.querySelector('[data-bc-mvp-sheet-plan="onetime"]')?.focus();
    });
  }

  function getRewardTiers() {
    const finalReward = getFinalRewardPresentation();
    return [
      { atPence: 2500, short: '99p shipping', name: '99p shipping', gift: false },
      {
        atPence: 3000,
        short: 'Choose Your Gift',
        name: 'your first free gift',
        gift: true,
      },
      { atPence: 4000, short: finalReward.short, name: finalReward.name, gift: true },
      { atPence: 5000, short: 'Choose Another', name: 'your third free gift', gift: true },
    ];
  }

  function isTierAttainable(tier) {
    return getActivePurchaseMode() === 'subscription' || !tier.gift;
  }

  function formatThreshold(pence) {
    return `£${Math.round((Number(pence) || 0) / 100)}`;
  }

  function getRewardProgress() {
    const subtotal = getSubtotalPence();
    const tiers = getRewardTiers();
    let active = null;
    let segmentStart = 0;
    for (let i = 0; i < tiers.length; i += 1) {
      const tier = tiers[i];
      if (isTierAttainable(tier) && subtotal < tier.atPence) {
        active = tier;
        segmentStart = (i > 0 && subtotal >= tiers[i - 1].atPence) ? tiers[i - 1].atPence : 0;
        break;
      }
    }

    let fillPct;
    let nudge;
    let complete = false;
    if (active) {
      const span = Math.max(1, active.atPence - segmentStart);
      fillPct = Math.max(0, Math.min(100, ((subtotal - segmentStart) / span) * 100));
      nudge = `${formatMoney(active.atPence - subtotal)} to ${active.short}`;
    } else if (getActivePurchaseMode() === 'subscription') {
      fillPct = 100;
      nudge = 'All gifts unlocked';
      complete = true;
    } else {
      fillPct = 100;
      nudge = 'Subscribe for 3 free gifts';
      complete = true;
    }

    return { tiers, active, fillPct, nudge, complete, subtotal };
  }

  function injectStyles() {
    if (document.getElementById('bc-custom-bundle-mvp-style')) return;
    const style = document.createElement('style');
    style.id = 'bc-custom-bundle-mvp-style';
    style.textContent = `
      html.bc-custom-bundle-mvp-active #recharge-bundles,
      html.bc-custom-bundle-mvp-active #bundling-app {
        display: block !important;
        visibility: hidden !important;
        height: 0 !important;
        min-height: 0 !important;
        overflow: hidden !important;
        margin: 0 !important;
        padding: 0 !important;
        border: 0 !important;
        pointer-events: none !important;
      }

      html.bc-custom-bundle-mvp-active .bc-delivery-bar,
      html.bc-custom-bundle-mvp-active .bc-bundle-header,
      html.bc-custom-bundle-mvp-active .bc-bundle-header-shell,
      html.bc-custom-bundle-mvp-active [data-bc-page-postcode-banner],
      html.bc-custom-bundle-mvp-active .bc-page-postcode-banner,
      html.bc-custom-bundle-mvp-active bc-page-postcode-banner {
        display: none !important;
      }

      #bc-dc-success .bc-dc__success-msg::before {
        content: '🎉 ';
      }

      .bc-custom-bundle-mvp {
        --bc-mvp-ink: #101010;
        --bc-mvp-muted: #6d665f;
        --bc-mvp-soft: #f8f6f2;
        --bc-mvp-wash: #f2eee8;
        --bc-mvp-border: #d9d1c8;
        --bc-mvp-green: #2f7d4a;
        --bc-mvp-sand: #f3eeea;
        --bc-mvp-faint: #8a8178;
        box-sizing: border-box;
        width: min(1280px, calc(100% - 48px));
        margin: 0 auto 64px;
        color: var(--bc-mvp-ink);
	        font-family: "Lora", serif !important;
	      }

      .bc-custom-bundle-mvp--embedded {
        margin-bottom: 72px;
      }

      .bc-custom-bundle-mvp--embedded .bc-custom-bundle-mvp__postcode-bar {
        display: none !important;
      }

	      .bc-custom-bundle-mvp * {
	        box-sizing: border-box;
	        font-family: "Lora", serif !important;
	        letter-spacing: 0 !important;
	      }

      .bc-custom-bundle-mvp button,
      .bc-custom-bundle-mvp input,
      .bc-custom-bundle-mvp select {
        font-family: "Lora", serif !important;
      }

	      .bc-custom-bundle-mvp h1,
	      .bc-custom-bundle-mvp h2,
	      .bc-custom-bundle-mvp h3,
	      .bc-custom-bundle-mvp p {
	        margin: 0;
	        text-transform: none !important;
	      }

      .bc-custom-bundle-mvp__postcode-bar {
        width: 100vw;
        margin-left: calc(50% - 50vw);
        background: #111;
        color: #fff;
      }

      .bc-custom-bundle-mvp__postcode-inner {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 24px;
        width: min(1280px, calc(100% - 48px));
        min-height: 66px;
        margin: 0 auto;
      }

      .bc-custom-bundle-mvp__postcode-logo {
        width: 86px;
        height: auto;
        display: block;
      }

      .bc-custom-bundle-mvp__postcode-button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        min-height: 42px;
        padding: 0 22px;
        border: 0;
        border-radius: 999px;
        background: #fff;
        color: var(--bc-mvp-ink);
        cursor: pointer;
        font-size: 15px;
        line-height: 1;
        font-weight: 700;
      }

      .bc-custom-bundle-mvp__postcode-button svg {
        width: 19px;
        height: 19px;
        flex: 0 0 auto;
      }

      .bc-custom-bundle-mvp__desktop-intro {
        display: none;
      }

      .bc-custom-bundle-mvp__desktop-intro h1 {
        margin: 0;
        color: var(--bc-mvp-ink);
        font-size: clamp(20px, 1.45vw, 25px);
        font-weight: 700;
        line-height: 1.08;
        letter-spacing: 0 !important;
        text-align: center;
        text-transform: uppercase !important;
      }

      .bc-custom-bundle-mvp__desktop-intro--embedded {
        display: block;
        width: min(1080px, calc(100% - 40px));
        max-width: 1080px;
        margin: 0 auto 36px;
        text-align: center;
      }

      .bc-custom-bundle-mvp__desktop-intro--embedded h2 {
        width: 100%;
        margin: 0;
        font-size: clamp(37px, 9vw, 42px);
        font-weight: 400;
        line-height: 0.96;
        text-transform: none !important;
        text-wrap: balance;
      }

      .bc-custom-bundle-mvp__desktop-postcode {
        display: grid;
        grid-template-columns: auto minmax(0, 1fr) auto;
        align-items: center;
        gap: 8px;
        width: min(420px, 100%);
        min-height: 42px;
        margin: 11px auto 0;
        padding: 0 12px;
        border: 1px solid #dedede;
        border-radius: 9px;
        background: #fff;
        color: var(--bc-mvp-ink);
        cursor: pointer;
        text-align: left;
      }

      .bc-custom-bundle-mvp__desktop-postcode svg {
        width: 18px;
        height: 18px;
        color: #9d9d9d;
      }

      .bc-custom-bundle-mvp__desktop-postcode-placeholder {
        color: #9d9d9d;
        font-size: 14px;
        font-weight: 400;
        line-height: 1;
      }

      .bc-custom-bundle-mvp__desktop-postcode-action {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 68px;
        min-height: 28px;
        padding: 0 13px;
        border-radius: 999px;
        background: var(--bc-mvp-ink);
        color: #fff;
        font-size: 13px;
        font-weight: 700;
        line-height: 1;
      }

      .bc-custom-bundle-mvp__layout {
        display: grid;
        grid-template-columns: minmax(0, 1fr) minmax(320px, 360px);
        gap: 28px;
        align-items: start;
      }

      .bc-custom-bundle-mvp [data-bc-mvp-summary-wrap] {
        position: sticky;
        top: 18px;
        min-width: 0;
        align-self: start;
      }

      .bc-custom-bundle-mvp__summary {
        position: static;
        display: block;
        overflow: hidden;
        border: 1px solid var(--bc-mvp-border);
        border-radius: 8px;
        background: #fff;
      }

      .bc-custom-bundle-mvp__summary-panel {
        border: 0;
        border-radius: 0;
        background: #fff;
      }

      .bc-custom-bundle-mvp__variant {
        min-height: 38px;
        width: 100%;
        padding: 7px 32px 7px 11px;
        border: 1px solid var(--bc-mvp-ink);
        border-radius: 4px;
        background: #fff;
        color: var(--bc-mvp-ink);
      }

      .bc-custom-bundle-mvp__variant {
        appearance: none;
        -webkit-appearance: none;
        min-height: 42px;
        padding: 8px 54px 8px 20px;
        background-color: #fff;
        background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 6L8 10L12 6' fill='none' stroke='%23101010' stroke-width='1.7' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 18px center;
        background-size: 16px 16px;
        text-align: left;
        text-align-last: left;
        line-height: 1.25;
      }

      .bc-custom-bundle-mvp__product-section + .bc-custom-bundle-mvp__product-section {
        margin-top: 42px;
      }

      .bc-custom-bundle-mvp__product-section {
        scroll-margin-top: 24px;
      }

      .bc-custom-bundle-mvp__category-nav {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin: 0 0 22px;
      }

      .bc-custom-bundle-mvp__category-nav button {
        min-height: 34px;
        padding: 0 13px;
        border: 1px solid var(--bc-mvp-border);
        border-radius: 999px;
        background: #fff;
        color: var(--bc-mvp-muted);
        cursor: pointer;
        font-size: 13px;
        line-height: 1;
        font-weight: 700;
      }

      .bc-custom-bundle-mvp__category-nav button:focus-visible {
        outline: 2px solid var(--bc-mvp-ink);
        outline-offset: 2px;
      }

      @media (min-width: 769px) {
        .bc-custom-bundle-mvp__category-nav {
          display: none;
        }
      }

      .bc-custom-bundle-mvp__loading {
        display: grid;
        gap: 14px;
        min-height: 200px;
        padding: 34px 16px;
        align-content: center;
        justify-items: center;
        text-align: center;
      }

      .bc-custom-bundle-mvp__spinner {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        border: 2px solid var(--bc-mvp-border);
        border-top-color: var(--bc-mvp-ink);
        animation: bc-custom-bundle-mvp-spin 0.8s linear infinite;
      }

      @keyframes bc-custom-bundle-mvp-spin {
        to { transform: rotate(360deg); }
      }

      @media (prefers-reduced-motion: reduce) {
        .bc-custom-bundle-mvp__spinner {
          animation-duration: 2.4s;
        }
      }

      .bc-custom-bundle-mvp__loading-text {
        color: var(--bc-mvp-muted);
        font-size: 14px;
        line-height: 1.3;
        letter-spacing: 0.02em;
      }

      .bc-custom-bundle-mvp__section-head {
        margin-bottom: 16px;
      }

      .bc-custom-bundle-mvp__section-head h2 {
        font-size: clamp(24px, 1.9vw, 28px);
        line-height: 1.08;
        font-weight: 600;
        text-transform: none !important;
      }

      .bc-custom-bundle-mvp__section-head p {
        color: var(--bc-mvp-muted);
        font-size: 15px;
        line-height: 1.35;
      }

      .bc-custom-bundle-mvp__grid {
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 28px 18px;
      }

      .bc-custom-bundle-mvp__card {
        min-width: 0;
      }

      .bc-custom-bundle-mvp__card.is-selected .bc-custom-bundle-mvp__image {
        outline: 2px solid var(--bc-mvp-ink);
        outline-offset: -2px;
      }

      .bc-custom-bundle-mvp__image {
        position: relative;
        aspect-ratio: 1 / 1;
        overflow: hidden;
        border-radius: 4px;
        background: var(--bc-mvp-wash);
      }

      .bc-custom-bundle-mvp__image-button {
        position: relative;
        display: block;
        width: 100%;
        height: 100%;
        padding: 0;
        overflow: hidden;
        border: 0;
        background: var(--bc-mvp-wash);
        cursor: pointer;
        text-align: inherit;
      }

      .bc-custom-bundle-mvp__image-button img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
      }

      .bc-custom-bundle-mvp__image-primary {
        opacity: 1;
        transition: opacity 160ms ease;
      }

      .bc-custom-bundle-mvp__image-secondary {
        position: absolute;
        inset: 0;
        opacity: 0;
        transition: opacity 160ms ease;
      }

      @media (hover: hover) and (pointer: fine) {
        .bc-custom-bundle-mvp__image-button:hover .bc-custom-bundle-mvp__image-primary,
        .bc-custom-bundle-mvp__image-button:focus-visible .bc-custom-bundle-mvp__image-primary {
          opacity: 0;
        }

        .bc-custom-bundle-mvp__image-button:hover .bc-custom-bundle-mvp__image-secondary,
        .bc-custom-bundle-mvp__image-button:focus-visible .bc-custom-bundle-mvp__image-secondary {
          opacity: 1;
        }
      }

      @media (prefers-reduced-motion: reduce) {
        .bc-custom-bundle-mvp__image-primary,
        .bc-custom-bundle-mvp__image-secondary {
          transition: none;
        }
      }

      .bc-custom-bundle-mvp__image-placeholder {
        display: grid;
        place-items: center;
        width: 100%;
        height: 100%;
        padding: 18px;
        background: var(--bc-mvp-wash);
        color: var(--bc-mvp-muted);
        text-align: center;
        font-size: 14px;
        line-height: 1.25;
      }

      .bc-custom-bundle-mvp__info {
        position: absolute;
        top: 8px;
        right: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 19px;
        height: 19px;
        padding: 0 0 1px;
        border: 1px solid rgba(16, 16, 16, 0.38);
        border-radius: 50%;
        background: transparent;
        color: var(--bc-mvp-ink);
        cursor: pointer;
        font-weight: 500;
        font-style: italic;
        font-size: 11px;
        line-height: 1;
      }

      .bc-custom-bundle-mvp__selected-badge {
        position: absolute;
        left: 10px;
        top: 10px;
        display: grid;
        place-items: center;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        background: var(--bc-mvp-ink);
        color: #fff;
        font-size: 14px;
        line-height: 1;
        font-weight: 700;
      }

      .bc-custom-bundle-mvp__card h2 {
        margin-top: 9px;
        margin-bottom: 3px;
        font-size: clamp(15px, 1vw, 16px);
        line-height: 1.16;
        font-weight: 500;
        text-transform: none !important;
      }

      .bc-custom-bundle-mvp__variant-wrap {
        margin-top: 10px;
      }

      .bc-custom-bundle-mvp__variant-wrap.is-empty {
        display: none;
      }

      .bc-custom-bundle-mvp__variant {
        color: var(--bc-mvp-muted);
        font-size: 14px;
        text-align: left;
        text-align-last: left;
      }

      .bc-custom-bundle-mvp__variant[aria-hidden='true'] {
        display: flex;
        align-items: center;
        border-color: transparent;
        background: transparent;
        padding-left: 0;
      }

      .bc-custom-bundle-mvp__details-backdrop {
        position: fixed;
        inset: 0;
        z-index: 2147483000;
        display: grid;
        place-items: center;
        padding: 20px;
        background: rgba(16, 16, 16, 0.42);
      }

      html.bc-family-preset-intro-open {
        overflow: hidden;
      }

      .bc-custom-bundle-mvp__preset-intro {
        width: min(500px, calc(100% - 32px));
        max-width: 500px;
        margin: auto;
        padding: 0;
        overflow: visible;
        border: 2px solid #101010;
        border-radius: 8px;
        background: #f7f3ee;
        color: #101010;
        font-family: "Lora", serif;
      }

      .bc-custom-bundle-mvp__preset-intro::backdrop {
        background: rgba(16, 16, 16, 0.48);
      }

      .bc-custom-bundle-mvp__preset-intro-content {
        position: relative;
        padding: 42px 38px 36px;
      }

      .bc-custom-bundle-mvp__preset-intro-close {
        position: absolute;
        top: 10px;
        right: 10px;
        display: grid;
        place-items: center;
        width: 44px;
        height: 44px;
        padding: 0;
        border: 0;
        background: transparent;
        color: #101010;
        font: 400 30px/1 Arial, sans-serif;
        cursor: pointer;
      }

      .bc-custom-bundle-mvp__preset-intro h2 {
        margin: 0;
        padding-right: 28px;
        font: 400 30px/1.08 "Lora", serif;
        letter-spacing: 0;
        text-transform: none;
      }

      .bc-custom-bundle-mvp__preset-intro p {
        margin: 18px 0 0;
        color: #625b54;
        font: 400 16px/1.5 Arial, sans-serif;
        letter-spacing: 0;
      }

      .bc-custom-bundle-mvp__preset-intro-cta {
        display: grid;
        grid-template-columns: 1fr auto 1fr;
        align-items: center;
        width: 100%;
        min-height: 54px;
        margin-top: 28px;
        padding: 0 20px;
        border: 1px solid #101010;
        border-radius: 999px;
        background: #101010;
        color: #fff;
        font: 500 17px/1 "Lora", serif;
        cursor: pointer;
      }

      .bc-custom-bundle-mvp__preset-intro-cta span:first-child {
        grid-column: 2;
      }

      .bc-custom-bundle-mvp__preset-intro-cta span:last-child {
        grid-column: 3;
        justify-self: end;
      }

      .bc-custom-bundle-mvp__preset-intro-close:focus-visible,
      .bc-custom-bundle-mvp__preset-intro-cta:focus-visible {
        outline: 2px solid #101010;
        outline-offset: 3px;
      }

      .bc-custom-bundle-mvp__details {
        position: relative;
        width: min(460px, 100%);
        max-height: min(760px, calc(100vh - 40px));
        overflow: auto;
        border: 2px solid var(--bc-mvp-ink);
        border-radius: 8px;
        background: #fff;
      }

      .bc-custom-bundle-mvp__details-media {
        aspect-ratio: 1 / 1;
        background: var(--bc-mvp-wash);
      }

      .bc-custom-bundle-mvp__details-media img,
      .bc-custom-bundle-mvp__details-media .bc-custom-bundle-mvp__image-placeholder {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }

      .bc-custom-bundle-mvp__details-body {
        padding: 20px;
      }

      .bc-custom-bundle-mvp__details-title-row {
        display: grid;
        grid-template-columns: minmax(0, 1fr) 34px;
        gap: 16px;
        align-items: start;
      }

      .bc-custom-bundle-mvp__details h2 {
        margin: 0;
        font-size: 28px;
        line-height: 1.05;
      }

      .bc-custom-bundle-mvp__details-close {
        display: grid;
        place-items: center;
        width: 34px;
        height: 34px;
        border: 1px solid var(--bc-mvp-border);
        border-radius: 50%;
        background: #fff;
        cursor: pointer;
        color: var(--bc-mvp-ink);
        font-size: 24px;
        line-height: 1;
      }

      .bc-custom-bundle-mvp__details-copy {
        margin-top: 10px;
        color: var(--bc-mvp-muted);
        font-size: 15px;
        line-height: 1.45;
      }

      .bc-custom-bundle-mvp__details-copy :where(p, ul, ol) {
        margin: 0 0 10px;
      }

      .bc-custom-bundle-mvp__details-copy :where(p, ul, ol):last-child {
        margin-bottom: 0;
      }

      .bc-custom-bundle-mvp__details-copy :where(ul, ol) {
        padding-left: 20px;
      }

      .bc-custom-bundle-mvp__price {
        display: flex;
        align-items: baseline;
        gap: 6px;
        margin-top: 0;
        color: var(--bc-mvp-ink);
        font-size: 13px;
      }

      .bc-custom-bundle-mvp__card-control {
        height: 44px;
        min-height: 44px;
        margin-top: 9px;
        box-sizing: border-box;
      }

      .bc-custom-bundle-mvp__add {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        border: 0;
        border-radius: 999px;
        background: var(--bc-mvp-ink);
        color: #fff;
        cursor: pointer;
        font-size: 14px;
        font-weight: 600;
        line-height: 1;
      }

      .bc-custom-bundle-mvp__qty {
        display: grid;
        grid-template-columns: 42px minmax(42px, 1fr) 42px;
        align-items: center;
        border: 1px solid var(--bc-mvp-ink);
        border-radius: 999px;
        background: #fff;
      }

      .bc-custom-bundle-mvp__qty button {
        display: grid;
        place-items: center;
        height: 100%;
        min-height: 0;
        border: 0;
        background: transparent;
        color: var(--bc-mvp-ink);
        cursor: pointer;
        font-size: 22px;
        line-height: 1;
        font-weight: 700;
      }

      .bc-custom-bundle-mvp__qty-value {
        text-align: center;
        font-size: 16px;
      }

      .bc-custom-bundle-mvp__summary-panel {
        padding: 18px;
      }

      .bc-custom-bundle-mvp__mobile-summary-toggle {
        display: none;
      }

      .bc-custom-bundle-mvp__summary-panel h2 {
        font-size: 24px;
        line-height: 1;
      }

      .bc-custom-bundle-mvp__selected-list {
        display: grid;
        gap: 10px;
        margin-top: 14px;
      }

      .bc-custom-bundle-mvp__selected {
        display: grid;
        grid-template-columns: minmax(0, 1fr) auto;
        gap: 10px;
        align-items: start;
        color: var(--bc-mvp-muted);
        font-size: 14px;
        line-height: 1.25;
      }

      .bc-custom-bundle-mvp__selected strong {
        display: block;
        color: var(--bc-mvp-ink);
        font-size: 15px;
        line-height: 1.2;
        font-weight: 500;
      }

      .bc-custom-bundle-mvp__selected-meta {
        display: grid;
        gap: 4px;
        justify-items: end;
        text-align: right;
      }

      .bc-custom-bundle-mvp__selected-meta button {
        padding: 0;
        border: 0;
        background: transparent;
        color: var(--bc-mvp-muted);
        cursor: pointer;
        font-size: 12px;
        line-height: 1.2;
        text-decoration: underline;
      }

      .bc-custom-bundle-mvp__empty {
        margin-top: 14px;
        color: var(--bc-mvp-muted);
        font-size: 15px;
        line-height: 1.35;
      }

      .bc-custom-bundle-mvp__summary-row {
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        gap: 12px;
        margin-top: 14px;
        padding-top: 14px;
        border-top: 1px solid var(--bc-mvp-border);
      }

      .bc-custom-bundle-mvp__summary-total {
        font-size: 22px;
        font-weight: 600;
      }

      .bc-custom-bundle-mvp__cta {
        width: 100%;
        min-height: 52px;
        margin-top: 14px;
        border: 0;
        border-radius: 999px;
        background: var(--bc-mvp-ink);
        color: #fff;
        cursor: pointer;
        font-size: 17px;
        font-weight: 600;
      }

      .bc-custom-bundle-mvp__cta-label--mobile {
        display: none;
      }

	      .bc-custom-bundle-mvp__status {
        min-height: 0;
        margin-top: 10px;
        color: var(--bc-mvp-muted);
	        font-size: 13px;
	        line-height: 1.35;
	        font-weight: 600;
	      }

      .bc-custom-bundle-mvp__status:empty {
        display: none;
      }

      .bc-custom-bundle-mvp__status[data-bc-mvp-status='error'] {
        color: #9f1d1d;
      }

      .bc-custom-bundle-mvp__status[data-bc-mvp-status='success'] {
        color: var(--bc-mvp-green);
      }

      .bc-custom-bundle-mvp__debug {
        display: none;
      }

      .bc-custom-bundle-mvp__cta:disabled,
      .bc-custom-bundle-mvp button:disabled,
      .bc-custom-bundle-mvp select:disabled {
        opacity: 0.48;
        cursor: not-allowed;
      }

      .bc-custom-bundle-mvp.is-busy .bc-custom-bundle-mvp__cta:disabled,
      .bc-custom-bundle-mvp.is-busy button:disabled,
      .bc-custom-bundle-mvp.is-busy select:disabled {
        cursor: wait;
      }

      .bc-custom-bundle-mvp.is-busy .bc-custom-bundle-mvp__image-button:disabled {
        opacity: 1;
      }

      @media (max-width: 1180px) {
        .bc-custom-bundle-mvp__grid {
          grid-template-columns: repeat(3, minmax(0, 1fr));
        }
      }

      @media (min-width: 901px) {
        .bc-custom-bundle-mvp__desktop-intro--embedded h2 {
          font-size: 50px;
          white-space: nowrap;
        }

        html.bc-custom-bundle-mvp-active [data-bc-page-postcode-banner],
        html.bc-custom-bundle-mvp-active .bc-page-postcode-banner,
        html.bc-custom-bundle-mvp-active bc-page-postcode-banner,
        .bc-custom-bundle-mvp__postcode-bar {
          display: none !important;
        }

        html.bc-custom-bundle-mvp-active:not(.bc-custom-bundle-mvp-embedded) #header-group,
        html.bc-custom-bundle-mvp-active:not(.bc-custom-bundle-mvp-embedded) header-component,
        html.bc-custom-bundle-mvp-active:not(.bc-custom-bundle-mvp-embedded) .header-section,
        html.bc-custom-bundle-mvp-active:not(.bc-custom-bundle-mvp-embedded) .shopify-section-group-header-group {
          position: static !important;
          top: auto !important;
          inset-block-start: auto !important;
          transform: none !important;
          translate: none !important;
          animation: none !important;
        }
      }

      @media (max-width: 900px) {
        html.bc-custom-bundle-mvp-active:not(.bc-custom-bundle-mvp-embedded) #header-group,
        html.bc-custom-bundle-mvp-active:not(.bc-custom-bundle-mvp-embedded) header-component,
        html.bc-custom-bundle-mvp-active:not(.bc-custom-bundle-mvp-embedded) .header-section,
        html.bc-custom-bundle-mvp-active:not(.bc-custom-bundle-mvp-embedded) .shopify-section-group-header-group {
          display: none !important;
          height: 0 !important;
          min-height: 0 !important;
          margin: 0 !important;
          padding: 0 !important;
          overflow: hidden !important;
          pointer-events: none !important;
        }

        html.bc-custom-bundle-mvp-active:not(.bc-custom-bundle-mvp-embedded) body {
          --header-height: 0px !important;
          --header-group-height: 0px !important;
          --top-row-height: 0px !important;
          padding-bottom: calc(106px + var(--bc-mvp-bottom-offset, 0px));
        }

        .bc-custom-bundle-mvp {
          width: min(100%, 640px);
          margin-top: 0;
          margin-bottom: 128px;
        }

        html.bc-custom-bundle-mvp-embedded body {
          padding-bottom: 0 !important;
        }

        .bc-custom-bundle-mvp--embedded {
          margin-bottom: 0;
          padding-bottom: calc(190px + env(safe-area-inset-bottom));
        }

        .bc-custom-bundle-mvp__postcode-inner {
          width: calc(100% - 32px);
          min-height: 58px;
          gap: 14px;
        }

        .bc-custom-bundle-mvp__postcode-logo {
          width: 62px;
        }

        .bc-custom-bundle-mvp__postcode-button {
          min-height: 40px;
          padding: 0 18px;
          font-size: 15px;
          white-space: nowrap;
        }

        html.bc-custom-bundle-mvp-active [data-bc-page-postcode-banner],
        html.bc-custom-bundle-mvp-active .bc-page-postcode-banner,
        html.bc-custom-bundle-mvp-active bc-page-postcode-banner {
          display: none !important;
        }

        .bc-custom-bundle-mvp__layout {
          display: flex;
          flex-direction: column;
          align-items: stretch;
          gap: 0;
        }

        .bc-custom-bundle-mvp__loading {
          min-height: min(620px, calc(100dvh - 160px));
          padding-top: 48px;
          padding-bottom: 48px;
        }

        .bc-custom-bundle-mvp [data-bc-mvp-summary-wrap] {
          position: static;
          top: auto;
          order: -1;
          width: 100%;
          align-self: stretch;
        }

        .bc-custom-bundle-mvp__summary {
          position: static;
          display: block;
          width: 100%;
          overflow: visible;
          border: 0;
          border-radius: 0;
          background: #fff;
        }

        .bc-custom-bundle-mvp__summary-panel {
          position: fixed;
          left: 0;
          right: 0;
          bottom: var(--bc-mvp-bottom-offset, 0px);
          z-index: 40;
          max-height: calc(100dvh - 96px);
          padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
          border-width: 1px 0 0;
          border-radius: 0;
          overflow: hidden;
          background: rgba(255, 255, 255, 0.98);
        }

        .bc-custom-bundle-mvp--embedded .bc-custom-bundle-mvp__summary-panel {
          visibility: hidden;
          opacity: 0;
          pointer-events: none;
          transform: translateY(100%);
          transition: opacity 140ms ease, transform 140ms ease, visibility 0s linear 140ms;
        }

        .bc-custom-bundle-mvp--embedded.is-mobile-surface-active .bc-custom-bundle-mvp__summary-panel {
          visibility: visible;
          opacity: 1;
          pointer-events: auto;
          transform: translateY(0);
          transition-delay: 0s;
        }

        .bc-custom-bundle-mvp__summary-panel.is-open {
          overflow: auto;
        }

        .bc-custom-bundle-mvp__mobile-summary-toggle {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          width: min(520px, 100%);
          min-height: 38px;
          margin: 0 auto 10px;
          padding: 0;
          border: 0;
          background: transparent;
          color: var(--bc-mvp-ink);
          cursor: pointer;
          font-size: 16px;
          line-height: 1.1;
          font-weight: 700;
        }

        .bc-custom-bundle-mvp__summary-panel.is-empty .bc-custom-bundle-mvp__mobile-summary-toggle {
          display: none;
        }

        .bc-custom-bundle-mvp__mobile-summary-toggle::after {
          content: "";
          width: 10px;
          height: 10px;
          border-top: 2px solid currentColor;
          border-left: 2px solid currentColor;
          transform: rotate(45deg);
        }

        .bc-custom-bundle-mvp__summary-panel.is-open .bc-custom-bundle-mvp__mobile-summary-toggle::after {
          transform: rotate(225deg);
        }

        .bc-custom-bundle-mvp__mobile-summary-count {
          margin-left: auto;
          color: var(--bc-mvp-muted);
          font-size: 13px;
          font-weight: 600;
        }

        .bc-custom-bundle-mvp__summary-panel h2,
        .bc-custom-bundle-mvp__selected-list,
        .bc-custom-bundle-mvp__empty,
        .bc-custom-bundle-mvp__summary-row {
          display: none;
        }

        .bc-custom-bundle-mvp__summary-panel.is-open h2 {
          display: block;
          max-width: 520px;
          margin: 2px auto 0;
          font-size: 22px;
        }

        .bc-custom-bundle-mvp__summary-panel.is-open .bc-custom-bundle-mvp__selected-list,
        .bc-custom-bundle-mvp__summary-panel.is-open .bc-custom-bundle-mvp__empty {
          display: grid;
          max-width: 520px;
          max-height: 34dvh;
          margin-right: auto;
          margin-left: auto;
          overflow: auto;
        }

        .bc-custom-bundle-mvp__summary-panel.is-open .bc-custom-bundle-mvp__summary-row {
          display: flex;
          max-width: 520px;
          margin-right: auto;
          margin-left: auto;
        }

        .bc-custom-bundle-mvp__cta {
          display: block;
          max-width: 520px;
          min-height: 56px;
          margin: 0 auto;
          font-size: 17px;
        }

        .bc-custom-bundle-mvp__summary-panel.is-open .bc-custom-bundle-mvp__cta {
          margin-top: 14px;
        }

        .bc-custom-bundle-mvp__status {
          max-width: 520px;
          margin: 8px auto 0;
          text-align: center;
        }

	        .bc-custom-bundle-mvp:not(.bc-custom-bundle-mvp--embedded) .bc-custom-bundle-mvp__catalog {
            width: 100%;
            max-width: 100%;
	          padding: 18px 16px 0;
            overflow-x: hidden;
	        }

        .bc-custom-bundle-mvp__category-nav {
          display: none;
        }

        .bc-custom-bundle-mvp__category-nav button {
          flex: 0 0 auto;
          min-height: 32px;
          font-size: 12px;
        }

        .bc-custom-bundle-mvp__section-head {
          display: block;
          margin: 4px 0 14px;
          text-align: left;
        }

        .bc-custom-bundle-mvp__product-section {
          max-width: 100%;
          scroll-margin-top: 58px;
        }

	        .bc-custom-bundle-mvp__section-head h2 {
	          font-size: 21px;
	          line-height: 1.1;
	        }

        .bc-custom-bundle-mvp__section-head p {
          display: none;
        }

	        .bc-custom-bundle-mvp__grid {
            grid-template-columns: repeat(2, minmax(0, 1fr));
	          gap: 26px 16px;
	        }
	      }

	      @media (max-width: 480px) {
	        .bc-custom-bundle-mvp__grid {
	          gap: 26px 14px;
	        }

        .bc-custom-bundle-mvp__card {
          --bc-mvp-title-row-height: 22px;
          --bc-mvp-variant-row-height: 0px;
          --bc-mvp-variant-row-gap: 0px;
          display: flex;
          flex-direction: column;
        }

        .bc-custom-bundle-mvp__card:has(.bc-custom-bundle-mvp__variant) {
          --bc-mvp-variant-row-height: 40px;
          --bc-mvp-variant-row-gap: 5px;
        }

        .bc-custom-bundle-mvp__image {
          aspect-ratio: 1 / 1;
        }

        .bc-custom-bundle-mvp__card h2 {
          display: flex;
          align-items: flex-start;
          justify-content: center;
          min-height: var(--bc-mvp-title-row-height, 0px);
          margin-top: 7px;
          margin-bottom: 0;
          text-align: center;
          font-size: 15px;
          line-height: 1.16;
          font-weight: 500;
        }

        .bc-custom-bundle-mvp__variant-wrap {
          min-height: var(--bc-mvp-variant-row-height, 0px);
          margin-top: var(--bc-mvp-variant-row-gap, 0px);
        }

        .bc-custom-bundle-mvp__variant-wrap.is-empty {
          display: block;
          pointer-events: none;
        }

        .bc-custom-bundle-mvp__variant {
          min-height: 40px;
          padding: 7px 44px 7px 14px;
          background-position: right 14px center;
          font-size: 14px;
          line-height: 1.3;
        }

        .bc-custom-bundle-mvp__card-control {
          margin-top: 6px;
        }

        .bc-custom-bundle-mvp__add,
        .bc-custom-bundle-mvp__qty {
          font-size: 14px;
        }
      }

      @media (max-width: 360px) {
      }

      .bc-custom-bundle-mvp__rewards {
        position: relative;
        max-width: 520px;
        margin: 2px auto 14px;
      }

      .bc-custom-bundle-mvp__del-title {
        display: block;
        max-width: 410px;
        margin: 0 auto;
        padding: 0 34px;
        color: var(--bc-mvp-ink);
        font-size: 20px;
        font-weight: 600;
        line-height: 1.16;
        text-align: center;
      }

      .bc-custom-bundle-mvp__del-info {
        position: absolute;
        top: -3px;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 26px;
        height: 26px;
        padding: 0 0 1px;
        border: 1px solid rgba(16, 16, 16, 0.28);
        border-radius: 50%;
        background: #fff;
        color: var(--bc-mvp-ink);
        font-size: 13px;
        font-style: italic;
        line-height: 1;
        cursor: pointer;
      }

      .bc-custom-bundle-mvp__del-track {
        position: relative;
        height: 80px;
        margin-top: 12px;
      }

      .bc-custom-bundle-mvp__del-line {
        position: absolute;
        left: 0;
        right: 0;
        top: 23px;
        height: 5px;
        border-radius: 999px;
        background: var(--bc-mvp-border);
      }

      .bc-custom-bundle-mvp__del-fill {
        display: block;
        height: 100%;
        border-radius: 999px;
        background: var(--bc-mvp-ink);
        transition: width 0.3s ease;
      }

      .bc-custom-bundle-mvp__del-mark {
        appearance: none;
        padding: 0;
        position: absolute;
        top: 25px;
        z-index: 2;
        display: flex;
        align-items: center;
        justify-content: center;
        transform: translate(-50%, -50%);
        width: 46px;
        height: 46px;
        border-radius: 50%;
        background: #fff;
        border: 2px solid var(--bc-mvp-border);
        color: var(--bc-mvp-faint);
        cursor: pointer;
      }

      .bc-custom-bundle-mvp__del-mark.is-reached {
        background: var(--bc-mvp-ink);
        border-color: var(--bc-mvp-ink);
        color: #fff;
      }

      .bc-custom-bundle-mvp__del-mark.is-locked {
        background: rgba(255, 255, 255, 0.72);
        border-color: rgba(16, 16, 16, 0.16);
        color: rgba(16, 16, 16, 0.34);
      }

      .bc-custom-bundle-mvp__del-mark.is-locked .bc-custom-bundle-mvp__del-icon {
        opacity: 0.58;
      }

      .bc-custom-bundle-mvp__del-lock {
        position: absolute;
        top: -4px;
        right: -4px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 16px;
        height: 16px;
        border: 1px solid #fff;
        border-radius: 50%;
        background: var(--bc-mvp-ink);
        color: #fff;
      }

      .bc-custom-bundle-mvp__del-lock svg {
        display: block;
        width: 9px;
        height: 9px;
      }

      .bc-custom-bundle-mvp__del-icon {
        width: 26px;
        height: 20px;
        color: currentColor;
        fill: currentColor;
        stroke: none;
      }

      .bc-custom-bundle-mvp__del-icon--wide {
        width: 31px;
        height: 18px;
      }

      .bc-custom-bundle-mvp__del-icon--cakes {
        width: 27px;
        height: 22px;
      }

      .bc-custom-bundle-mvp__del-icon--mystery {
        width: 30px;
        height: 25px;
        display: block;
        background: currentColor;
        -webkit-mask: var(--bc-mystery-gift-icon) center / contain no-repeat;
        mask: var(--bc-mystery-gift-icon) center / contain no-repeat;
      }

      .bc-custom-bundle-mvp__del-label {
        position: absolute;
        top: 53px;
        transform: translateX(-50%);
        width: min(74px, 18%);
        text-align: center;
        color: var(--bc-mvp-faint);
        font-size: 9.2px;
        line-height: 1.12;
      }

      .bc-custom-bundle-mvp__del-label strong {
        display: block;
        color: var(--bc-mvp-ink);
        font-size: 16px;
        font-weight: 600;
        line-height: 1;
        margin-bottom: 5px;
      }

      .bc-custom-bundle-mvp__del-label > span {
        display: block;
      }

      .bc-custom-bundle-mvp__del-label.is-locked {
        color: rgba(86, 78, 70, 0.48);
      }

      .bc-custom-bundle-mvp__del-label.is-locked strong {
        color: rgba(16, 16, 16, 0.42);
      }

      @media (max-width: 480px) {
        .bc-custom-bundle-mvp__rewards {
          max-width: 100%;
          margin-bottom: 12px;
        }

        .bc-custom-bundle-mvp__del-title {
          max-width: none;
          margin: 0;
          padding: 0 34px 0 0;
          font-size: clamp(13.5px, 3.7vw, 14.5px);
          line-height: 1.15;
          text-align: left;
          white-space: nowrap;
        }

        .bc-custom-bundle-mvp__del-info {
          top: -2px;
          width: 24px;
          height: 24px;
          font-size: 12px;
        }

        .bc-custom-bundle-mvp__del-track {
          height: 74px;
          margin-top: 11px;
        }

        .bc-custom-bundle-mvp__del-line {
          top: 21px;
          height: 4px;
        }

        .bc-custom-bundle-mvp__del-mark {
          top: 23px;
          width: 40px;
          height: 40px;
        }

        .bc-custom-bundle-mvp__del-lock {
          top: -3px;
          right: -3px;
          width: 14px;
          height: 14px;
        }

        .bc-custom-bundle-mvp__del-lock svg {
          width: 8px;
          height: 8px;
        }

        .bc-custom-bundle-mvp__del-icon {
          width: 22px;
          height: 18px;
        }

        .bc-custom-bundle-mvp__del-icon--wide {
          width: 27px;
          height: 16px;
        }

        .bc-custom-bundle-mvp__del-icon--cakes {
          width: 24px;
          height: 20px;
        }

        .bc-custom-bundle-mvp__del-icon--mystery {
          width: 27px;
          height: 23px;
        }

        .bc-custom-bundle-mvp__del-label {
          top: 48px;
          width: min(64px, 18%);
          font-size: 9.4px;
          line-height: 1.12;
        }

        .bc-custom-bundle-mvp__del-label strong {
          font-size: 14px;
          margin-bottom: 4px;
        }
      }

      @media (max-width: 360px) {
        .bc-custom-bundle-mvp__del-title {
          font-size: 14px;
        }

        .bc-custom-bundle-mvp__del-mark {
          width: 36px;
          height: 36px;
        }

        .bc-custom-bundle-mvp__del-icon {
          width: 20px;
          height: 16px;
        }

        .bc-custom-bundle-mvp__del-icon--wide {
          width: 25px;
          height: 15px;
        }

        .bc-custom-bundle-mvp__del-icon--cakes {
          width: 22px;
          height: 18px;
        }

        .bc-custom-bundle-mvp__del-icon--mystery {
          width: 25px;
          height: 21px;
        }

        .bc-custom-bundle-mvp__del-label {
          width: min(58px, 18%);
          font-size: 9px;
        }
      }

      .bc-custom-bundle-mvp__card {
        text-align: center;
      }

      .bc-custom-bundle-mvp__price {
        justify-content: center;
      }

      .bc-custom-bundle-mvp__savings-row {
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        gap: 12px;
        margin-top: 12px;
        padding-top: 12px;
        border-top: 1px solid var(--bc-mvp-border);
        color: var(--bc-mvp-ink);
      }

      .bc-custom-bundle-mvp__savings-row--first-order {
        align-items: flex-start;
        justify-content: flex-end;
      }

      .bc-custom-bundle-mvp__savings-label,
      .bc-custom-bundle-mvp__savings-prices {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        min-width: 0;
      }

      .bc-custom-bundle-mvp__savings-label {
        font-size: 15px;
        font-weight: 600;
      }

      .bc-custom-bundle-mvp__savings-pill {
        border-radius: 999px;
        background: var(--bc-mvp-ink);
        color: #fff;
        padding: 5px 11px;
        font-size: 13px;
        font-weight: 600;
        white-space: nowrap;
      }

      .bc-custom-bundle-mvp__savings-prices {
        flex: 0 0 auto;
        font-size: 15px;
      }

      .bc-custom-bundle-mvp__savings-prices--first-order {
        display: grid;
        justify-items: end;
        gap: 3px;
      }

      .bc-custom-bundle-mvp__savings-price-main {
        display: inline-flex;
        align-items: baseline;
        gap: 8px;
        white-space: nowrap;
      }

      .bc-custom-bundle-mvp__savings-price-next {
        color: #8a8178;
        font-size: 12px;
        font-weight: 400;
        white-space: nowrap;
      }

      .bc-custom-bundle-mvp__savings-prices s {
        color: #8a8178;
        font-size: 13px;
        font-weight: 400;
      }

      .bc-custom-bundle-mvp__savings-prices strong {
        font-weight: 600;
      }

      .bc-custom-bundle-mvp__variant {
        color: var(--bc-mvp-ink);
        text-align: left;
        text-align-last: left;
      }

      .bc-custom-bundle-mvp__add {
        border: 1px solid var(--bc-mvp-ink);
        background: #fff;
        color: var(--bc-mvp-ink);
        font-weight: 500;
      }

      .bc-custom-bundle-mvp__card h2 {
        margin-top: 14px;
        margin-bottom: 4px;
      }

      @media (max-width: 480px) {
        .bc-custom-bundle-mvp__card h2 {
          margin-bottom: 1px;
        }
      }

      .bc-custom-bundle-mvp__section-head {
        margin-bottom: 14px;
        text-align: left;
      }

      .bc-custom-bundle-mvp__section-head h2 {
        font-size: 19px;
        font-weight: 600;
        color: var(--bc-mvp-ink);
      }

      .bc-custom-bundle-mvp__summary-panel {
        background: var(--bc-mvp-sand);
        text-align: center;
      }

      .bc-custom-bundle-mvp__desktop-items,
      .bc-custom-bundle-mvp__desktop-plan {
        display: none;
      }

      .bc-custom-bundle-mvp__desktop-items {
        margin: 16px 0 0;
        padding-top: 14px;
        border-top: 1px solid var(--bc-mvp-border);
        text-align: left;
      }

      .bc-custom-bundle-mvp__summary-panel .bc-custom-bundle-mvp__desktop-items-title {
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        gap: 12px;
        margin: 0 0 4px;
        color: var(--bc-mvp-ink);
        font-size: 20px;
        font-weight: 600;
        line-height: 1.08;
      }

      .bc-custom-bundle-mvp__desktop-items-title h2 {
        margin: 0;
        color: inherit;
        font: inherit;
      }

      .bc-custom-bundle-mvp__desktop-items-count {
        color: var(--bc-mvp-muted);
        font-size: 12px;
        font-weight: 500;
        white-space: nowrap;
      }

      .bc-custom-bundle-mvp__desktop-items-actions {
        display: inline-flex;
        align-items: baseline;
        justify-content: flex-end;
        gap: 10px;
        white-space: nowrap;
      }

      .bc-custom-bundle-mvp__cart-clear--desktop {
        position: static;
        flex: 0 0 auto;
        padding: 2px 0;
        border: 0;
        border-bottom: 1px solid currentColor;
        border-radius: 0;
        background: transparent;
        box-shadow: none;
        color: #9b4236;
        font: inherit;
        font-size: 12.5px;
        line-height: 1.2;
        cursor: pointer;
      }

      .bc-custom-bundle-mvp__desktop-plan {
        margin: 14px 0 0;
        padding-top: 14px;
        border-top: 1px solid var(--bc-mvp-border);
        text-align: left;
      }

      .bc-custom-bundle-mvp__desktop-plan-options {
        display: grid;
        gap: 10px;
      }

      .bc-custom-bundle-mvp__desktop-subscription {
        display: grid;
        gap: 0;
      }

      .bc-custom-bundle-mvp__desktop-subscription.is-active,
      .bc-custom-bundle-mvp__desktop-subscription.is-expanded {
        --bc-mvp-desktop-plan-row-rail: 32px;
        --bc-mvp-desktop-plan-content-x: 18px;
        gap: 7px;
        padding: 15px var(--bc-mvp-desktop-plan-content-x) 16px;
        border: 1px solid var(--bc-mvp-ink);
        border-radius: 18px;
        background: #fff;
        overflow: hidden;
      }

      .bc-custom-bundle-mvp__desktop-subscription.is-active {
        border: 1px solid var(--bc-mvp-ink);
        outline: 1px solid var(--bc-mvp-ink);
        outline-offset: -2px;
      }

      .bc-custom-bundle-mvp__desktop-subscription.is-expanded:not(.is-active) {
        border: 1px solid var(--bc-mvp-border);
        outline: 0;
      }

      .bc-custom-bundle-mvp__desktop-subscription.is-expanded:not(.is-active) .bc-custom-bundle-mvp__desktop-plan-option,
      .bc-custom-bundle-mvp__desktop-subscription.is-expanded:not(.is-active) .bc-custom-bundle-mvp__desktop-benefits {
        color: var(--bc-mvp-muted);
      }

      .bc-custom-bundle-mvp__desktop-subscription.is-expanded:not(.is-active) .bc-custom-bundle-mvp__desktop-benefits li::before {
        color: var(--bc-mvp-muted);
      }

      .bc-custom-bundle-mvp__desktop-plan-option {
        display: grid;
        grid-template-columns: auto minmax(0, 1fr) auto;
        align-items: center;
        gap: 8px;
        min-height: 42px;
        width: 100%;
        padding: 8px 11px;
        border: 1px solid var(--bc-mvp-border);
        border-radius: 999px;
        background: #fff;
        color: var(--bc-mvp-muted);
        cursor: pointer;
        font-size: 14px;
        font-weight: 500;
        line-height: 1.1;
        text-align: left;
      }

      .bc-custom-bundle-mvp__desktop-plan-option.is-active {
        border-color: var(--bc-mvp-ink);
        color: var(--bc-mvp-ink);
        outline: 1px solid var(--bc-mvp-ink);
        outline-offset: -2px;
      }

      .bc-custom-bundle-mvp__desktop-subscription.is-active .bc-custom-bundle-mvp__desktop-plan-option,
      .bc-custom-bundle-mvp__desktop-subscription.is-expanded .bc-custom-bundle-mvp__desktop-plan-option {
        grid-template-columns: 18px minmax(0, 1fr) auto;
        column-gap: 14px;
        min-height: 30px;
        padding: 0;
        border-color: transparent;
        border-radius: 0;
        outline: 0;
        color: var(--bc-mvp-ink);
      }

      .bc-custom-bundle-mvp__desktop-plan-radio {
        position: relative;
        width: 15px;
        height: 15px;
        border: 1px solid currentColor;
        border-radius: 50%;
        background: #fff;
      }

      .bc-custom-bundle-mvp__desktop-plan-option.is-active .bc-custom-bundle-mvp__desktop-plan-radio::after {
        content: "";
        position: absolute;
        inset: 3px;
        border-radius: inherit;
        background: currentColor;
      }

      .bc-custom-bundle-mvp__desktop-plan-copy {
        display: grid;
        align-content: center;
        gap: 3px;
        min-width: 0;
      }

      .bc-custom-bundle-mvp__desktop-plan-option--onetime {
        grid-template-columns: 17px minmax(0, 1fr);
        align-items: center;
        column-gap: 13px;
        min-height: 54px;
        padding: 8px 15px;
      }

      .bc-custom-bundle-mvp__desktop-plan-option--onetime .bc-custom-bundle-mvp__desktop-plan-radio {
        align-self: center;
      }

      .bc-custom-bundle-mvp__desktop-plan-option--onetime .bc-custom-bundle-mvp__desktop-plan-copy {
        min-height: 34px;
      }

      .bc-custom-bundle-mvp__desktop-plan-sub {
        color: var(--bc-mvp-muted);
        font-size: 11.5px;
        font-weight: 400;
        line-height: 1.2;
      }

      .bc-custom-bundle-mvp__discount-notice {
        display: flex;
        align-items: center;
        gap: 7px;
        box-sizing: border-box;
        width: 100%;
        max-width: none;
        min-width: 0;
        padding: 6px 8px;
        border: 1px solid #c7d9cc;
        border-radius: 6px;
        background: #eef5f0;
        color: #365d43;
        font-size: 12.5px;
        font-weight: 400;
        line-height: 1.3;
        animation: bc-custom-bundle-mvp-discount-notice-in 140ms ease-out;
      }

      .bc-custom-bundle-mvp__discount-notice--desktop {
        display: grid;
        grid-template-columns: 17px minmax(0, 1fr);
        align-items: center;
        justify-self: stretch;
        column-gap: 13px;
        margin: -2px 0 0;
        padding: 9px 15px;
      }

      .bc-custom-bundle-mvp__discount-notice-icon {
        display: inline-grid;
        place-items: center;
        flex: 0 0 15px;
        width: 15px;
        height: 15px;
        border: 1px solid #70917a;
        border-radius: 50%;
        color: var(--bc-mvp-green);
        font-family: Arial, sans-serif;
        font-size: 10px;
        font-style: normal;
        font-weight: 600;
        line-height: 1;
        margin-top: 0;
      }

      @keyframes bc-custom-bundle-mvp-discount-notice-in {
        from { opacity: 0; }
        to { opacity: 1; }
      }

      .bc-custom-bundle-mvp__desktop-plan-label {
        font-weight: 700;
      }

      .bc-custom-bundle-mvp__desktop-offer-prices {
        display: grid;
        grid-template-columns: minmax(0, 1fr) auto;
        align-items: baseline;
        gap: 4px 12px;
        width: calc(100% - var(--bc-mvp-desktop-plan-row-rail));
        margin: 1px 0 0 var(--bc-mvp-desktop-plan-row-rail);
        color: var(--bc-mvp-ink);
        font-size: 12px;
        line-height: 1.2;
      }

      .bc-custom-bundle-mvp__desktop-offer-prices strong {
        font-size: 15px;
        font-weight: 700;
        white-space: nowrap;
      }

      .bc-custom-bundle-mvp__desktop-offer-prices small {
        grid-column: 1 / -1;
        color: var(--bc-mvp-muted);
        font-size: 11.5px;
        font-weight: 400;
      }

      .bc-custom-bundle-mvp__welcome-offer {
        display: block;
        width: auto;
        margin: 0;
        padding: 10px 14px;
        border-radius: 0;
        background: var(--bc-mvp-ink);
        color: #fff;
        font-size: 12px;
        font-weight: 700;
        line-height: 1.25;
        text-align: center;
      }

      .bc-custom-bundle-mvp__welcome-offer strong {
        color: inherit;
        font: inherit;
      }

      .bc-custom-bundle-mvp__desktop-subscription > .bc-custom-bundle-mvp__welcome-offer {
        margin: -15px calc(0px - var(--bc-mvp-desktop-plan-content-x)) 1px;
        border-radius: 17px 17px 0 0;
      }

      .bc-custom-bundle-mvp__desktop-benefits {
        display: grid;
        grid-template-columns: minmax(0, 1fr);
        gap: 5px;
        margin: 0;
        padding: 0;
        list-style: none;
        color: var(--bc-mvp-ink);
        font-size: 12px;
        line-height: 1.25;
        font-weight: 500;
      }

      .bc-custom-bundle-mvp__desktop-benefits li {
        display: grid;
        grid-template-columns: 18px minmax(0, 1fr);
        align-items: flex-start;
        gap: 14px;
        min-width: 0;
        white-space: nowrap;
      }

      .bc-custom-bundle-mvp__desktop-benefits li::before {
        content: "✓";
        display: block;
        width: 18px;
        color: var(--bc-mvp-green);
        font-size: 13px;
        line-height: 1;
        font-weight: 700;
        text-align: center;
        transform: translateX(5px);
      }

      .bc-custom-bundle-mvp__desktop-frequency {
        display: grid;
        gap: 6px;
        width: calc(100% - var(--bc-mvp-desktop-plan-row-rail));
        margin: 1px 0 0 var(--bc-mvp-desktop-plan-row-rail);
        color: var(--bc-mvp-ink);
        font-size: 12.5px;
        line-height: 1.2;
        font-weight: 500;
      }

      .bc-custom-bundle-mvp__desktop-frequency > span {
        padding-left: 0;
      }

      .bc-custom-bundle-mvp__desktop-frequency select {
        appearance: none;
        -webkit-appearance: none;
        min-height: 46px;
        width: 100%;
        padding: 8px 48px 8px 16px;
        border: 1px solid var(--bc-mvp-ink);
        border-radius: 999px;
        background-color: #fff;
        background-image: url("data:image/svg+xml,%3Csvg width='18' height='18' viewBox='0 0 18 18' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.5 7L9 11.5L13.5 7' fill='none' stroke='%23101010' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 22px center;
        background-size: 18px 18px;
        color: var(--bc-mvp-ink);
        font: inherit;
        font-size: 14px;
        cursor: pointer;
      }

      @media (min-width: 769px) {
        .bc-custom-bundle-mvp__variant-wrap.is-empty {
          display: block;
          min-height: var(--bc-mvp-variant-row-height, 0px);
          margin-top: var(--bc-mvp-variant-row-gap, 0px);
          visibility: hidden;
          pointer-events: none;
        }
      }

      .bc-custom-bundle-mvp__sheet {
        position: fixed;
        inset: 0;
        bottom: var(--bc-mvp-bottom-offset, 0px);
        z-index: 2147483000;
        display: flex;
        align-items: flex-end;
        justify-content: center;
      }

      .bc-custom-bundle-mvp__sheet--plan {
        align-items: center;
        padding: 20px;
      }

      .bc-custom-bundle-mvp__sheet-scrim {
        position: absolute;
        inset: 0;
        background: rgba(16, 16, 16, 0.42);
      }

      .bc-custom-bundle-mvp__sheet-card {
        position: relative;
        width: 100%;
        max-width: 460px;
        max-height: calc(100dvh - 40px);
        overflow: auto;
        padding: 20px 18px calc(22px + env(safe-area-inset-bottom));
        background: #fff;
        border-top: 1px solid var(--bc-mvp-border);
        border-radius: 18px 18px 0 0;
      }

      .bc-custom-bundle-mvp__sheet--plan .bc-custom-bundle-mvp__sheet-card {
        width: min(430px, calc(100vw - 32px));
        max-height: min(640px, calc(100dvh - 48px));
        padding: 24px 18px 20px;
        border: 2px solid var(--bc-mvp-ink);
        border-radius: 24px;
        background: #f8f3ee;
      }

      .bc-custom-bundle-mvp__sheet-close {
        position: absolute;
        top: 12px;
        right: 13px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 30px;
        padding: 0 0 2px;
        border: 0;
        border-radius: 50%;
        background: transparent;
        color: var(--bc-mvp-muted);
        cursor: pointer;
        font-size: 23px;
        line-height: 1;
      }

      .bc-custom-bundle-mvp .bc-custom-bundle-mvp__sheet-title {
        margin: 0 0 24px;
        padding: 0 30px;
        text-align: center;
        font-size: 17px;
        font-weight: 600;
        color: var(--bc-mvp-ink);
      }

      .bc-custom-bundle-mvp__cart-sheet-header {
        position: relative;
        min-height: 24px;
        margin-bottom: 24px;
      }

      .bc-custom-bundle-mvp__cart-sheet-header .bc-custom-bundle-mvp__sheet-title {
        margin-bottom: 0;
      }

      .bc-custom-bundle-mvp__cart-clear:not(.bc-custom-bundle-mvp__cart-clear--desktop) {
        position: absolute;
        top: 1px;
        left: 0;
        padding: 2px 0;
        border: 0;
        border-bottom: 1px solid currentColor;
        background: transparent;
        color: #9b4236;
        font: inherit;
        font-size: 12.5px;
        line-height: 1.2;
        cursor: pointer;
      }

      .bc-custom-bundle-mvp__cart-clear:hover,
      .bc-custom-bundle-mvp__cart-clear:focus-visible {
        color: #713027;
      }

      .bc-custom-bundle-mvp__cart-empty {
        margin: 8px 0 2px;
        color: var(--bc-mvp-muted);
        font-size: 14px;
        text-align: center;
      }

      .bc-custom-bundle-mvp__sheet-benefits {
        display: grid;
        gap: 7px;
        margin: 10px 0 0;
        padding: 0;
        list-style: none;
      }

      .bc-custom-bundle-mvp__sheet-benefits li {
        position: relative;
        padding-left: 22px;
        color: var(--bc-mvp-ink);
        font-size: 13px;
        line-height: 1.3;
      }

      .bc-custom-bundle-mvp__sheet-benefits li::before {
        content: "✓";
        position: absolute;
        left: 0;
        top: 0;
        color: var(--bc-mvp-green);
        font-size: 12px;
      }

      .bc-custom-bundle-mvp__sheet--frequency-only .bc-custom-bundle-mvp__sheet-card {
        padding: 24px 18px 18px;
      }

      .bc-custom-bundle-mvp .bc-custom-bundle-mvp__sheet--frequency-only .bc-custom-bundle-mvp__sheet-title {
        margin-bottom: 18px;
      }

      .bc-custom-bundle-mvp__sheet-freq--primary {
        margin-top: 0;
      }

      .bc-custom-bundle-mvp__sheet-freq-row--frequency-only {
        width: min(100%, 254px);
        margin: 0 auto;
        grid-template-columns: repeat(auto-fit, minmax(106px, 1fr));
        gap: 7px;
      }

      .bc-custom-bundle-mvp__sheet--frequency-only .bc-custom-bundle-mvp__sheet-chip {
        min-height: 42px;
        padding: 0 12px;
        font-size: 13px;
      }

      .bc-custom-bundle-mvp__sheet--frequency-only .bc-custom-bundle-mvp__sheet-confirm {
        margin-top: 18px;
      }

      .bc-custom-bundle-mvp__sheet--frequency-only .bc-custom-bundle-mvp__sheet-reassure {
        margin: 9px 0 0;
        color: var(--bc-mvp-muted);
        font-size: 12px;
        line-height: 1.25;
      }

      .bc-custom-bundle-mvp__sheet-opt {
        display: grid;
        grid-template-columns: 17px minmax(0, 1fr);
        column-gap: 12px;
        row-gap: 0;
        align-items: start;
        width: 100%;
        margin-bottom: 12px;
        padding: 15px;
        border: 1px solid var(--bc-mvp-border);
        border-radius: 12px;
        background: #fff;
        text-align: left;
        cursor: pointer;
        color: var(--bc-mvp-ink);
        font: inherit;
        overflow: hidden;
      }

      .bc-custom-bundle-mvp__sheet-opt.sel {
        padding: 14px;
        border: 2px solid var(--bc-mvp-ink);
        background: var(--bc-mvp-sand);
      }

      .bc-custom-bundle-mvp__sheet-radio {
        flex: 0 0 auto;
        position: relative;
        width: 17px;
        height: 17px;
        margin-top: 2px;
        border: 1px solid var(--bc-mvp-muted);
        border-radius: 50%;
      }

      .bc-custom-bundle-mvp__sheet-opt.sel .bc-custom-bundle-mvp__sheet-radio {
        border-color: var(--bc-mvp-ink);
      }

      .bc-custom-bundle-mvp__sheet-opt.sel .bc-custom-bundle-mvp__sheet-radio::after {
        content: "";
        position: absolute;
        inset: 3px;
        border-radius: 50%;
        background: var(--bc-mvp-ink);
      }

      .bc-custom-bundle-mvp__sheet-opt-body {
        min-width: 0;
      }

      .bc-custom-bundle-mvp__sheet-opt-head {
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        gap: 10px;
        color: var(--bc-mvp-ink);
        font-size: 15px;
        font-weight: 500;
      }

      .bc-custom-bundle-mvp__sheet-opt-head s {
        color: #a39a8f;
        font-size: 12px;
        font-weight: 400;
      }

      .bc-custom-bundle-mvp__sheet-plan-title {
        display: inline-flex;
        align-items: center;
        min-width: 0;
        font-weight: 700;
        white-space: nowrap;
      }

      .bc-custom-bundle-mvp__sheet-offer-price {
        display: grid;
        justify-items: end;
        gap: 2px;
        text-align: right;
      }

      .bc-custom-bundle-mvp__sheet-offer-price strong {
        font-size: 16px;
        font-weight: 700;
        white-space: nowrap;
      }

      .bc-custom-bundle-mvp__sheet-offer-price small {
        color: var(--bc-mvp-muted);
        font-size: 13px;
        font-weight: 400;
        line-height: 1.2;
        white-space: nowrap;
      }

      .bc-custom-bundle-mvp__sheet-opt .bc-custom-bundle-mvp__welcome-offer {
        grid-column: 1 / -1;
        width: auto;
        margin: -15px -15px 9px;
        padding: 10px 14px;
        border-radius: 11px 11px 0 0;
        background: var(--bc-mvp-ink);
        color: #fff;
      }

      .bc-custom-bundle-mvp__sheet-opt.sel .bc-custom-bundle-mvp__welcome-offer {
        margin: -14px -14px 9px;
        border-radius: 10px 10px 0 0;
      }

      .bc-custom-bundle-mvp__sheet-offer-compare {
        margin-left: 5px;
      }

      .bc-custom-bundle-mvp__sheet-opt-sub {
        display: block;
        margin-top: 3px;
        color: var(--bc-mvp-muted);
        font-size: 12.5px;
        line-height: 1.3;
      }

      .bc-custom-bundle-mvp__gift-loss-stack {
        position: relative;
        z-index: 1;
        display: grid;
        place-items: center;
        width: min(430px, calc(100vw - 32px));
        max-height: calc(100dvh - 32px);
      }

      .bc-custom-bundle-mvp__gift-loss-warning {
        position: relative;
        z-index: 2;
        display: grid;
        grid-area: 1 / 1;
        grid-template-columns: 20px minmax(0, 1fr);
        gap: 9px 11px;
        width: calc(100% - 24px);
        margin: 0;
        padding: 14px;
        border: 1px solid #d9b9b2;
        border-radius: 10px;
        background: #f8efed;
        color: #69463f;
        box-shadow: 0 8px 22px rgba(48, 29, 24, 0.12);
        animation: bc-custom-bundle-mvp-gift-warning-in 180ms ease-out;
      }

      .bc-custom-bundle-mvp__gift-loss-icon {
        display: grid;
        place-items: center;
        width: 18px;
        height: 18px;
        margin-top: 2px;
        border: 1px solid #96665d;
        border-radius: 50%;
        font-family: Arial, sans-serif;
        font-size: 11px;
        font-weight: 700;
        line-height: 1;
      }

      .bc-custom-bundle-mvp__gift-loss-copy {
        display: grid;
        gap: 5px;
        min-width: 0;
        padding-right: 28px;
        font-size: 13.5px;
        line-height: 1.4;
      }

      .bc-custom-bundle-mvp__gift-loss-title {
        margin: 0;
        color: #5f3e37;
        font-size: 16px;
        font-weight: 600;
        line-height: 1.25;
      }

      .bc-custom-bundle-mvp__gift-loss-actions {
        grid-column: 1 / -1;
        display: grid;
        gap: 8px;
        margin-top: 3px;
      }

      .bc-custom-bundle-mvp__gift-loss-keep,
      .bc-custom-bundle-mvp__gift-loss-continue {
        width: 100%;
        min-height: 46px;
        padding: 0 14px;
        border-radius: 999px;
        cursor: pointer;
        font: inherit;
        font-size: 13.5px;
        font-weight: 600;
      }

      .bc-custom-bundle-mvp__gift-loss-keep {
        min-height: 48px;
        border: 1px solid var(--bc-mvp-ink);
        background: var(--bc-mvp-ink);
        color: #fff;
      }

      .bc-custom-bundle-mvp__gift-loss-continue {
        border: 1px solid #b98e85;
        background: #fffaf8;
        color: #69463f;
      }

      .bc-custom-bundle-mvp__gift-loss-close {
        position: absolute;
        top: 6px;
        right: 6px;
        display: grid;
        place-items: center;
        width: 44px;
        height: 44px;
        padding: 0 0 2px;
        border: 0;
        border-radius: 50%;
        background: transparent;
        color: #80635d;
        cursor: pointer;
        font-size: 22px;
        line-height: 1;
      }

      .bc-custom-bundle-mvp__gift-loss-context {
        grid-area: 1 / 1;
        position: relative;
        z-index: 1;
        width: 100% !important;
        max-height: calc(100dvh - 48px) !important;
      }

      .bc-custom-bundle-mvp__gift-loss-context::after {
        content: "";
        position: absolute;
        inset: 0;
        z-index: 3;
        border-radius: inherit;
        background: rgba(248, 243, 238, 0.58);
        pointer-events: none;
      }

      @keyframes bc-custom-bundle-mvp-gift-warning-in {
        from { opacity: 0; transform: translateY(8px); }
        to { opacity: 1; transform: translateY(0); }
      }

      @media (prefers-reduced-motion: reduce) {
        .bc-custom-bundle-mvp__gift-loss-warning { animation: none; }
      }

      .bc-custom-bundle-mvp__discount-notice--sheet {
        display: grid;
        grid-template-columns: 17px minmax(0, 1fr);
        align-items: center;
        justify-self: stretch;
        column-gap: 12px;
        margin: -3px 0 0;
        padding: 9px 15px;
      }

      .bc-custom-bundle-mvp__sheet-freq {
        margin-top: 14px;
      }

      .bc-custom-bundle-mvp__sheet-freq-label {
        display: block;
        margin-bottom: 8px;
        color: var(--bc-mvp-ink);
        font-size: 13px;
        font-weight: 500;
      }

      .bc-custom-bundle-mvp__sheet-freq-row {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 6px;
      }

      .bc-custom-bundle-mvp__sheet-chip {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-width: 0;
        min-height: 43px;
        border: 1px solid var(--bc-mvp-border);
        border-radius: 999px;
        background: #fff;
        color: var(--bc-mvp-ink);
        padding: 7px 4px;
        font-size: 12.5px;
        line-height: 1.1;
        text-align: center;
        cursor: pointer;
      }

      .bc-custom-bundle-mvp__sheet-chip.on {
        background: var(--bc-mvp-ink);
        color: #fff;
        border-color: var(--bc-mvp-ink);
      }

      .bc-custom-bundle-mvp__sheet-chip-label {
        display: block;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .bc-custom-bundle-mvp__sheet-reassure {
        margin: 14px 0;
        text-align: center;
        color: var(--bc-mvp-faint);
        font-size: 12.5px;
        line-height: 1.35;
      }

      .bc-custom-bundle-mvp__reward-row {
        display: flex;
        gap: 12px;
        align-items: center;
        padding: 13px 0;
        border-bottom: 1px solid var(--bc-mvp-border);
        text-align: left;
      }

      .bc-custom-bundle-mvp__reward-row-img {
        flex: 0 0 auto;
        width: 52px;
        height: 52px;
        border-radius: 8px;
        object-fit: cover;
        background: var(--bc-mvp-sand);
      }

      .bc-custom-bundle-mvp__reward-row-body {
        flex: 1 1 auto;
        min-width: 0;
      }

      .bc-custom-bundle-mvp__reward-row-title {
        display: flex;
        justify-content: space-between;
        gap: 10px;
        color: var(--bc-mvp-ink);
        font-size: 14px;
        font-weight: 500;
      }

      .bc-custom-bundle-mvp__reward-row-title s {
        color: var(--bc-mvp-faint);
        font-weight: 400;
      }

      .bc-custom-bundle-mvp__reward-row-sub {
        display: block;
        margin-top: 3px;
        color: var(--bc-mvp-muted);
        font-size: 12.5px;
        line-height: 1.3;
      }

      .bc-custom-bundle-mvp__reward-row-img--mystery {
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid var(--bc-mvp-border);
        color: var(--bc-mvp-ink);
        font-family: Arial, sans-serif;
        font-size: 25px;
        font-weight: 600;
      }

      .bc-custom-bundle-mvp__gift-picker-card {
        display: flex;
        flex-direction: column;
        width: min(900px, calc(100vw - 32px));
        max-width: 900px;
        max-height: min(720px, calc(100dvh - 32px));
        overflow: hidden;
        padding: 22px;
        border: 2px solid var(--bc-mvp-ink);
        border-radius: 18px;
        background: #f8f3ee;
      }

      .bc-custom-bundle-mvp .bc-custom-bundle-mvp__gift-picker-title {
        flex: 0 0 auto;
        margin: 0;
        padding: 0 42px 0 0;
        color: var(--bc-mvp-ink);
        font-size: 26px;
        line-height: 1.08;
        text-align: left;
      }

      .bc-custom-bundle-mvp .bc-custom-bundle-mvp__gift-picker-card .bc-custom-bundle-mvp__gift-picker-note {
        flex: 0 0 auto;
        margin: 9px 42px 0 0;
        color: var(--bc-mvp-muted);
        font-size: 12.5px;
        font-style: italic;
        line-height: 1.35;
      }

      .bc-custom-bundle-mvp .bc-custom-bundle-mvp__gift-picker-card .bc-custom-bundle-mvp__gift-picker-options {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        grid-auto-rows: max-content;
        flex: 1 1 auto;
        min-height: 0;
        margin-top: 16px;
        padding: 2px;
        gap: 8px;
        overflow-y: auto;
        overscroll-behavior: contain;
      }

      .bc-custom-bundle-mvp__gift-picker-option-wrap {
        position: relative;
        display: grid;
        align-content: start;
        width: 100%;
        border: 1.5px solid var(--bc-mvp-border);
        border-radius: 8px;
        background: #fff;
        overflow: hidden;
      }

      .bc-custom-bundle-mvp__gift-picker-option-wrap.is-selected {
        border-color: var(--bc-mvp-ink);
        box-shadow: 0 0 0 1px var(--bc-mvp-ink);
      }

      .bc-custom-bundle-mvp__gift-picker-option {
        appearance: none;
        display: grid;
        grid-template-columns: 54px minmax(0, 1fr) 22px;
        gap: 10px;
        align-items: center;
        width: 100%;
        min-height: 72px;
        padding: 8px 34px 8px 8px;
        border: 0;
        background: transparent;
        color: var(--bc-mvp-ink);
        cursor: pointer;
        font-family: inherit;
        text-align: left;
      }

      .bc-custom-bundle-mvp__gift-picker-option.is-selected {
        background: #fff;
      }

      .bc-custom-bundle-mvp__gift-picker-option:disabled {
        opacity: 0.48;
        cursor: not-allowed;
      }

      .bc-custom-bundle-mvp__gift-picker-image {
        width: 54px;
        height: 54px;
        border-radius: 6px;
        object-fit: cover;
        background: var(--bc-mvp-sand);
      }

      .bc-custom-bundle-mvp__gift-picker-body {
        min-width: 0;
      }

      .bc-custom-bundle-mvp__gift-picker-name {
        display: block;
        font-size: 15px;
        font-weight: 500;
        line-height: 1.18;
      }

      .bc-custom-bundle-mvp__gift-picker-price {
        display: block;
        margin-top: 4px;
        color: var(--bc-mvp-ink);
        font-size: 13px;
      }

      .bc-custom-bundle-mvp__gift-picker-price s {
        color: var(--bc-mvp-faint);
        margin-right: 5px;
      }

      .bc-custom-bundle-mvp__gift-picker-details {
        margin: 0;
      }

      .bc-custom-bundle-mvp__gift-picker-details summary {
        position: absolute;
        top: 8px;
        right: 10px;
        z-index: 1;
        display: grid;
        place-items: center;
        width: 18px;
        height: 22px;
        padding: 0;
        border: 0;
        border-radius: 0;
        background: transparent;
        color: var(--bc-mvp-muted);
        font-family: Georgia, 'Times New Roman', serif;
        font-size: 16px;
        font-style: italic;
        line-height: 1;
        list-style: none;
        outline: none;
        cursor: pointer;
      }

      .bc-custom-bundle-mvp__gift-picker-details summary::-webkit-details-marker {
        display: none;
      }

      .bc-custom-bundle-mvp__gift-picker-details summary:hover,
      .bc-custom-bundle-mvp__gift-picker-details summary:focus-visible,
      .bc-custom-bundle-mvp__gift-picker-details[open] summary {
        color: var(--bc-mvp-ink);
        text-decoration: underline;
        text-underline-offset: 2px;
      }

      .bc-custom-bundle-mvp__gift-picker-description {
        margin: 0;
        padding: 9px 11px 11px;
        border-top: 1px solid var(--bc-mvp-border);
        color: var(--bc-mvp-muted);
        font-size: 12px;
        line-height: 1.35;
      }

      .bc-custom-bundle-mvp__gift-picker-radio {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 22px;
        height: 22px;
        border: 1.5px solid var(--bc-mvp-muted);
        border-radius: 50%;
      }

      .bc-custom-bundle-mvp__gift-picker-option.is-selected .bc-custom-bundle-mvp__gift-picker-radio {
        border-color: var(--bc-mvp-ink);
        background: var(--bc-mvp-ink);
      }

      .bc-custom-bundle-mvp__gift-picker-option.is-selected .bc-custom-bundle-mvp__gift-picker-radio::after {
        width: 6px;
        height: 10px;
        border: solid #fff;
        border-width: 0 2px 2px 0;
        content: '';
        transform: rotate(45deg) translate(-1px, -1px);
      }

      .bc-custom-bundle-mvp__gift-picker-footer {
        flex: 0 0 auto;
        margin: 10px -2px -2px;
        padding: 10px 2px 2px;
        border-top: 1px solid var(--bc-mvp-border);
        background: #f8f3ee;
      }

      .bc-custom-bundle-mvp__gift-picker-confirm {
        margin-top: 0;
      }

      .bc-custom-bundle-mvp__gift-picker-confirm:disabled {
        background: #969491;
        cursor: not-allowed;
      }

      .bc-custom-bundle-mvp__gift-picker-skip {
        display: block;
        width: fit-content;
        margin: 8px auto 0;
        padding: 4px 6px;
        border: 0;
        background: transparent;
        color: var(--bc-mvp-muted);
        font: inherit;
        font-size: 13px;
        text-decoration: underline;
        text-underline-offset: 3px;
        cursor: pointer;
      }

      .bc-custom-bundle-mvp__gift-picker-skip:hover,
      .bc-custom-bundle-mvp__gift-picker-skip:focus-visible {
        color: var(--bc-mvp-ink);
      }

      @media (max-width: 600px) {
        .bc-custom-bundle-mvp__preset-intro-content {
          padding: 38px 22px 24px;
        }

        .bc-custom-bundle-mvp__preset-intro h2 {
          padding-right: 34px;
          font-size: 25px;
        }

        .bc-custom-bundle-mvp__preset-intro p {
          margin-top: 14px;
          font-size: 16px;
        }

        .bc-custom-bundle-mvp__preset-intro-cta {
          margin-top: 22px;
        }

        .bc-custom-bundle-mvp__gift-picker-card {
          width: 100%;
          max-height: calc(100dvh - 32px - var(--bc-mvp-bottom-offset, 0px));
          overflow: hidden;
          padding: 16px 14px calc(12px + env(safe-area-inset-bottom));
          border-width: 1px 0 0;
          border-radius: 18px 18px 0 0;
        }

        .bc-custom-bundle-mvp .bc-custom-bundle-mvp__gift-picker-title {
          font-size: 22px;
        }

        .bc-custom-bundle-mvp .bc-custom-bundle-mvp__gift-picker-card .bc-custom-bundle-mvp__gift-picker-note {
          margin: 8px 0 0;
          font-size: 12px;
        }

        .bc-custom-bundle-mvp .bc-custom-bundle-mvp__gift-picker-card .bc-custom-bundle-mvp__gift-picker-options {
          grid-template-columns: minmax(0, 1fr);
          margin-top: 12px;
          padding-right: 3px;
          gap: 6px;
        }

        .bc-custom-bundle-mvp__gift-picker-option {
          grid-template-columns: 50px minmax(0, 1fr) 20px;
          gap: 9px;
          min-height: 62px;
          padding: 6px 32px 6px 6px;
        }

        .bc-custom-bundle-mvp__gift-picker-image {
          width: 50px;
          height: 50px;
        }

        .bc-custom-bundle-mvp__gift-picker-name {
          font-size: 13px;
        }

        .bc-custom-bundle-mvp__gift-picker-footer {
          margin-top: 8px;
          padding-top: 8px;
        }
      }

      .bc-custom-bundle-mvp .bc-custom-bundle-mvp__rates-title {
        margin: 16px 0 8px;
        color: var(--bc-mvp-ink);
        font-size: 12px;
        font-weight: 600;
        letter-spacing: 0.03em;
        text-transform: uppercase;
        text-align: left;
      }

      .bc-custom-bundle-mvp__rates {
        margin: 0;
        padding: 0;
        list-style: none;
      }

      .bc-custom-bundle-mvp__rates li {
        display: flex;
        justify-content: space-between;
        padding: 5px 0;
        color: var(--bc-mvp-muted);
        font-size: 13px;
      }

      .bc-custom-bundle-mvp__rates li strong {
        color: var(--bc-mvp-ink);
        font-weight: 500;
      }

      .bc-custom-bundle-mvp .bc-custom-bundle-mvp__rates-note {
        margin: 12px 0 0;
        color: var(--bc-mvp-faint);
        font-size: 12px;
        text-align: center;
      }

      .bc-custom-bundle-mvp__sheet-confirm {
        width: 100%;
        min-height: 52px;
        margin-top: 8px;
        border: 0;
        border-radius: 999px;
        background: var(--bc-mvp-ink);
        color: #fff;
        cursor: pointer;
        font-size: 16px;
        font-weight: 500;
      }

      .bc-custom-bundle-mvp__cart {
        position: fixed;
        top: var(--bc-mvp-cart-top, 16px);
        right: 14px;
        z-index: 2147482000;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        width: 128px;
        min-width: 128px;
        height: 42px;
        padding: 0 16px 0 14px;
        border: 1px solid var(--bc-mvp-ink);
        border-radius: 999px;
        background: var(--bc-mvp-soft);
        color: var(--bc-mvp-ink);
        cursor: pointer;
        font-size: 14px;
        font-weight: 600;
        line-height: 1;
        transition: top 160ms ease;
        will-change: top;
      }

      .bc-custom-bundle-mvp__cart[aria-hidden="true"] {
        display: none !important;
      }

      .bc-custom-bundle-mvp--embedded .bc-custom-bundle-mvp__cart {
        visibility: hidden;
        opacity: 0;
        pointer-events: none;
        transition: opacity 120ms ease, visibility 0s linear 120ms;
        will-change: opacity;
      }

      .bc-custom-bundle-mvp--embedded.is-mobile-cart-docked .bc-custom-bundle-mvp__cart[data-bc-mvp-has-items="true"][data-bc-mvp-cart-ready="true"][aria-hidden="false"]:not(:disabled) {
        visibility: visible;
        opacity: 1;
        pointer-events: auto;
        transition-delay: 0s;
      }

      .bc-custom-bundle-mvp__cart-label {
        min-width: 0;
        white-space: nowrap;
      }

      .bc-custom-bundle-mvp__cart-count {
        position: absolute;
        top: -8px;
        right: -10px;
        display: grid;
        place-items: center;
        min-width: 22px;
        height: 22px;
        padding: 0 5px;
        border-radius: 999px;
        background: var(--bc-mvp-ink);
        box-shadow: 0 0 0 2px var(--bc-mvp-soft);
        color: #fff;
        font-size: 12px;
        font-weight: 600;
        font-variant-numeric: tabular-nums;
        line-height: 1;
      }

      .bc-custom-bundle-mvp__cart-chevron {
        flex: 0 0 7px;
        width: 7px;
        height: 7px;
        margin: -3px 2px 0 1px;
        border-right: 1.5px solid currentColor;
        border-bottom: 1.5px solid currentColor;
        transform: rotate(45deg);
      }

      .bc-custom-bundle-mvp__cart-list {
        margin-top: 2px;
      }

      .bc-custom-bundle-mvp__cart-row {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 12px 0;
        border-bottom: 1px solid var(--bc-mvp-border);
        text-align: left;
      }

      .bc-custom-bundle-mvp__sheet-card > .bc-custom-bundle-mvp__cart-list .bc-custom-bundle-mvp__cart-row:last-child {
        border-bottom: 0;
      }

      .bc-custom-bundle-mvp__cart-info {
        flex: 1 1 auto;
        min-width: 0;
      }

      .bc-custom-bundle-mvp__cart-name {
        display: block;
        color: var(--bc-mvp-ink);
        font-size: 14px;
        font-weight: 500;
        line-height: 1.2;
      }

      .bc-custom-bundle-mvp__cart-variant {
        display: block;
        margin-top: 2px;
        color: var(--bc-mvp-muted);
        font-size: 12px;
      }

      .bc-custom-bundle-mvp__cart-qty {
        display: flex;
        align-items: center;
        gap: 10px;
        flex: 0 0 auto;
        padding: 5px 11px;
        border: 1px solid var(--bc-mvp-border);
        border-radius: 999px;
      }

      .bc-custom-bundle-mvp__cart-qty button {
        width: 16px;
        padding: 0;
        border: 0;
        background: transparent;
        color: var(--bc-mvp-ink);
        font-size: 16px;
        line-height: 1;
        cursor: pointer;
      }

      .bc-custom-bundle-mvp__cart-qty span {
        min-width: 14px;
        text-align: center;
        font-size: 13px;
      }

      .bc-custom-bundle-mvp__cart-price {
        flex: 0 0 auto;
        min-width: 50px;
        color: var(--bc-mvp-ink);
        font-size: 14px;
        font-weight: 500;
        text-align: right;
      }

      .bc-custom-bundle-mvp__cart-total {
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        margin-top: 16px;
        padding-top: 14px;
        border-top: 1px solid var(--bc-mvp-border);
        font-size: 15px;
      }

      .bc-custom-bundle-mvp__cart-total strong {
        font-size: 18px;
        font-weight: 600;
      }

      .bc-custom-bundle-mvp__sheet-card .bc-custom-bundle-mvp__savings-row {
        margin-top: 10px;
        padding-top: 10px;
      }

      @media (prefers-reduced-motion: reduce) {
        .bc-custom-bundle-mvp__cart,
        .bc-custom-bundle-mvp--embedded .bc-custom-bundle-mvp__cart {
          transition: none;
        }
      }

      @media (min-width: 901px) {
        .bc-custom-bundle-mvp__desktop-items,
        .bc-custom-bundle-mvp__desktop-plan {
          display: block;
        }

        .bc-custom-bundle-mvp__cart {
          display: none !important;
        }

        .bc-custom-bundle-mvp__summary-panel {
          border-top: 0;
          padding-top: 14px;
          padding-bottom: 16px;
          text-align: center;
        }

        .bc-custom-bundle-mvp__desktop-intro {
          display: block;
          width: 100%;
          max-width: 500px;
          margin: 24px auto 28px;
        }

        .bc-custom-bundle-mvp__rewards {
          margin-top: 0;
          margin-bottom: 11px;
        }

        .bc-custom-bundle-mvp__del-title {
          max-width: none;
          margin: 0;
          padding: 0 38px 0 0;
          font-size: clamp(14px, 1.05vw, 15px);
          line-height: 1.12;
          text-align: left;
          white-space: nowrap;
        }

        .bc-custom-bundle-mvp__del-label strong {
          font-size: 14px;
          margin-bottom: 4px;
        }

        .bc-custom-bundle-mvp__summary-panel .bc-custom-bundle-mvp__cta {
          margin-top: 12px;
        }

        .bc-custom-bundle-mvp__sheet {
          align-items: center;
        }

        .bc-custom-bundle-mvp__sheet-card {
          border-radius: 14px;
          max-height: calc(100vh - 80px);
        }
      }

      @media (max-width: 900px) {
        .bc-custom-bundle-mvp__details-backdrop {
          padding: 28px;
        }

        .bc-custom-bundle-mvp__details-body {
          padding: 18px 18px 20px;
        }

        .bc-custom-bundle-mvp__details-title-row {
          display: block;
        }

        .bc-custom-bundle-mvp__details-close {
          position: absolute;
          top: 12px;
          right: 12px;
          z-index: 2;
          border-color: var(--bc-mvp-border);
          background: #fff;
          color: var(--bc-mvp-ink);
          box-shadow: 0 2px 10px rgba(16, 16, 16, 0.16);
        }

        .bc-custom-bundle-mvp__details h2 {
          font-size: 26px;
        }

        .bc-custom-bundle-mvp__details-copy {
          margin-top: 8px;
          font-size: 14px;
          line-height: 1.38;
        }

        html.bc-custom-bundle-mvp-active:not(.bc-custom-bundle-mvp-embedded) body {
          padding-bottom: calc(190px + var(--bc-mvp-bottom-offset, 0px));
        }

        .bc-custom-bundle-mvp__desktop-items,
        .bc-custom-bundle-mvp__desktop-plan {
          display: none !important;
        }

        .bc-custom-bundle-mvp__summary-panel {
          background: var(--bc-mvp-sand);
        }

        .bc-custom-bundle-mvp__cta-label--desktop {
          display: none;
        }

        .bc-custom-bundle-mvp__cta-label--mobile {
          display: inline;
        }

        .bc-custom-bundle-mvp__section-head {
          display: block;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function loadRechargeSdk() {
    if (isRechargeBundleSdkReady()) {
      return Promise.resolve();
    }

    const existing = document.querySelector(`script[src="${SDK_URL}"]`);
    if (existing) {
      return new Promise((resolve, reject) => {
        let settled = false;
        const resolveWhenReady = () => {
          if (settled) return;
          waitForRechargeBundleSdk().then(() => {
            settled = true;
            resolve();
          }).catch((error) => {
            settled = true;
            reject(error);
          });
        };

        existing.addEventListener('load', () => {
          existing.dataset.bcMvpLoaded = 'true';
          resolveWhenReady();
        }, { once: true });
        existing.addEventListener('error', () => {
          if (settled) return;
          settled = true;
          reject(new Error('Recharge Storefront SDK failed to load'));
        }, { once: true });
        resolveWhenReady();
      });
    }

    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = SDK_URL;
      script.async = true;
      script.onload = () => {
        script.dataset.bcMvpLoaded = 'true';
        waitForRechargeBundleSdk().then(resolve).catch(reject);
      };
      script.onerror = () => reject(new Error('Recharge Storefront SDK failed to load'));
      document.head.appendChild(script);
    });
  }

  function isRechargeBundleSdkReady() {
    return Boolean(window.recharge && window.recharge.bundle && window.recharge.bundle.getDynamicBundleItems);
  }

  function waitForRechargeBundleSdk(timeoutMs = SDK_READY_TIMEOUT_MS) {
    if (isRechargeBundleSdkReady()) return Promise.resolve();

    const startedAt = Date.now();
    return new Promise((resolve, reject) => {
      const check = () => {
        if (isRechargeBundleSdkReady()) {
          resolve();
          return;
        }

        if (Date.now() - startedAt >= timeoutMs) {
          reject(new Error('Recharge bundle tools did not finish loading. Please try again.'));
          return;
        }

        window.setTimeout(check, 100);
      };

      check();
    });
  }

  function warmRechargeSdk() {
    if (!rechargeSdkWarmupPromise) {
      rechargeSdkWarmupPromise = loadRechargeSdk().catch((error) => {
        rechargeSdkWarmupPromise = null;
        throw error;
      });
    }

    return rechargeSdkWarmupPromise;
  }

  function scheduleRechargeSdkWarmup() {
    const warm = () => {
      void warmRechargeSdk().catch(() => {});
    };

    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(warm, { timeout: 1000 });
      return;
    }

    window.setTimeout(warm, 450);
  }

  function dispatchBundlePendingAdd(selections) {
    const selectedGifts = getEligibleRewardChoiceSlots()
      .map((slot) => REWARD_PREVIEW_CHOICES.find((choice) => choice.id === state.rewardPreviewChoices[slot]))
      .filter(Boolean);
    const purchaseMode = getActivePurchaseMode();
    const subtotalPence = getSubtotalPence();
    const oneTimeSubtotalPence = getModeSubtotalPence('onetime');
    const subscriptionSubtotalPence = getModeSubtotalPence('subscription');
    const preservedCartTotalPence = getOptimisticPreservedCartTotalPence(latestBuilderCartSnapshot);
    const subscriptionSavingsPence = purchaseMode === 'subscription'
      ? Math.max(0, oneTimeSubtotalPence - subscriptionSubtotalPence)
      : 0;
    const firstOrderOfferPence = purchaseMode === 'subscription' && FIRST_ORDER_OFFER_ENABLED
      ? getFirstOrderOfferPence()
      : 0;

    document.dispatchEvent(new CustomEvent(BUNDLE_PENDING_ADD_EVENT, {
      bubbles: true,
      detail: {
        source: 'custom-bundle-mvp',
        purchaseMode,
        itemCount: selections.reduce((total, item) => total + Math.max(0, Number(item.quantity) || 0), 0),
        subtotalPence,
        oneTimeSubtotalPence,
        subscriptionSubtotalPence,
        subscriptionSavingsPence,
        firstOrderOfferPence,
        discountCode: getCookieValue('discount_code') || getBuilderCartDiscountCode(latestBuilderCartSnapshot),
        optimisticPriceEligible: preservedCartTotalPence !== null,
        preservedCartTotalPence,
        giftCount: selectedGifts.length,
        giftValuePence: selectedGifts.reduce((total, gift) => total + parseMoneyPence(gift.price), 0),
      },
    }));
  }

  function getOptimisticPreservedCartTotalPence(cart) {
    if (!Array.isArray(cart?.items)) return null;

    let preservedTotalPence = 0;

    for (const item of cart.items) {
      const properties = item?.properties || {};
      const bundleParent = String(properties._rc_bundle_parent || '');
      const isTrackedBundleLine = Boolean(properties._rc_bundle) && bundleParent === BUNDLE_PRODUCT.shopifyHandle;
      const isManagedGiftLine = String(properties._bc_free_gift || '').trim() !== '';

      if (properties._rc_bundle && !isTrackedBundleLine) return null;
      if (isTrackedBundleLine || isManagedGiftLine) continue;
      if (item?.selling_plan_allocation) return null;
      if ((item?.line_level_discount_allocations || []).some((allocation) => (
        Number(allocation?.amount) > 0 && allocation?.discount_application?.type === 'discount_code'
      ))) return null;

      const linePricePence = Number(item?.final_line_price);
      if (!Number.isFinite(linePricePence) || linePricePence < 0) return null;
      preservedTotalPence += linePricePence;
    }

    return preservedTotalPence;
  }

  function getBuilderCartDiscountCode(cart) {
    const cartDiscount = (cart?.cart_level_discount_applications || []).find((discount) => {
      const application = discount?.discount_application || discount;
      return application?.type === 'discount_code' && String(application?.title || '').trim();
    });
    const cartApplication = cartDiscount?.discount_application || cartDiscount;
    if (cartApplication?.title) return String(cartApplication.title).trim();

    for (const item of cart?.items || []) {
      const allocation = (item?.line_level_discount_allocations || []).find((entry) => (
        entry?.discount_application?.type === 'discount_code' &&
        String(entry.discount_application.title || '').trim()
      ));
      if (allocation) return String(allocation.discount_application.title).trim();
    }

    return '';
  }

  function dispatchBundleAddFailed(error) {
    document.dispatchEvent(new CustomEvent(BUNDLE_ADD_FAILED_EVENT, {
      bubbles: true,
      detail: {
        source: 'custom-bundle-mvp',
        message: String(error && error.message ? error.message : error || ''),
      },
    }));
  }

  function dispatchBundleAddSucceeded({ dynamicBundleId, selections, expectedItems, cart, addResponsePayload }) {
    const detail = {
      source: 'custom-bundle-mvp',
      dynamicBundleId,
      purchaseMode: getActivePurchaseMode(),
      itemCount: Array.isArray(selections) ? selections.length : 0,
      cartItemCount: Number(cart && cart.item_count) || 0,
      expectedItems: Array.isArray(expectedItems) ? expectedItems : [],
      verifiedCart: cart || null,
      addResponsePayload: addResponsePayload || null,
      completion: null,
    };

    document.dispatchEvent(new CustomEvent(BUNDLE_ADD_SUCCEEDED_EVENT, {
      bubbles: true,
      detail,
    }));

    if (!detail.completion || typeof detail.completion.then !== 'function') {
      throw new Error('The cart service did not accept this bundle. Please refresh this page and try again.');
    }

    return detail.completion;
  }

  function initRecharge() {
    if (!window.recharge || !window.recharge.init) {
      throw new Error('Recharge SDK was not available after load');
    }
    window.recharge.init({
      storeIdentifier: 'butterandcrust.myshopify.com',
      appName: 'bc-custom-bundle-mvp',
      appVersion: '0.0.2',
    });
  }

  function logCartDiagnostic(stage, details = {}) {
    try {
      window.bcCartDebugLog?.(`builder:${stage}`, details);
    } catch (error) {}
  }

  function getCookieValue(name) {
    try {
      const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`));
      return match ? decodeURIComponent(match[1]) : null;
    } catch (error) {
      return null;
    }
  }

  function getBundleAnalyticsName() {
    return BUNDLE_PRODUCT.shopifyHandle === 'weekend-bundle'
      ? 'Weekend Bundle'
      : 'Morning Bundle';
  }

  function buildVerifiedBundleAnalyticsProperties() {
    const analyticsMeta = window.ShopifyAnalytics?.meta || {};
    const pageMeta = analyticsMeta.page || {};

    return {
      cartToken: getCookieValue('cart'),
      variantId: String(BUNDLE_PRODUCT.externalVariantId),
      productId: Number(BUNDLE_PRODUCT.externalProductId),
      currency: analyticsMeta.currency || window.Shopify?.currency?.active || 'GBP',
      quantity: '1',
      price: getSubtotalPence() / 100,
      name: getBundleAnalyticsName(),
      brand: 'Butter & Crust',
      variant: getActivePurchaseMode() === 'subscription' ? 'Subscription' : 'One-time',
      category: 'Bundle',
      remote: null,
      ...(pageMeta.pageType ? { pageType: pageMeta.pageType } : {}),
      ...(pageMeta.resourceType ? { resourceType: pageMeta.resourceType } : {}),
      ...(pageMeta.resourceId ? { resourceId: pageMeta.resourceId } : {}),
    };
  }

  function trackVerifiedBundleAdd(dynamicBundleId) {
    const analyticsId = String(dynamicBundleId || '');
    if (!analyticsId || trackedBundleAnalyticsIds.has(analyticsId)) return;

    const startedAt = Date.now();
    const attempt = () => {
      if (trackedBundleAnalyticsIds.has(analyticsId)) return;

      const analytics = window.ShopifyAnalytics?.lib;
      if (typeof analytics?.track !== 'function') {
        if (Date.now() - startedAt < BUNDLE_ADD_ANALYTICS_TIMEOUT_MS) {
          window.setTimeout(attempt, BUNDLE_ADD_ANALYTICS_RETRY_MS);
        } else {
          logCartDiagnostic('analytics-unavailable', { analyticsId: analyticsId.slice(0, 12) });
        }
        return;
      }

      try {
        analytics.track(
          'Added Product',
          buildVerifiedBundleAnalyticsProperties(),
          undefined,
          undefined,
          { addApiSource: 'bc-custom-bundle-verified', shopifyEmitted: true }
        );
        trackedBundleAnalyticsIds.add(analyticsId);
        document.documentElement.dataset.bcBundleAnalyticsCount = String(trackedBundleAnalyticsIds.size);
        logCartDiagnostic('analytics-added-product', { analyticsId: analyticsId.slice(0, 12) });
      } catch (error) {
        logCartDiagnostic('analytics-error', {
          message: String(error && error.message ? error.message : error || ''),
        });
      }
    };

    attempt();
  }

  function getTopLevelNativeCartFetch() {
    const nativeFetch = window.BC_CART_TOP_LEVEL_NATIVE_FETCH;
    return typeof nativeFetch === 'function' ? nativeFetch : null;
  }

  async function getCartTransportFetch() {
    const topLevelFetch = getTopLevelNativeCartFetch();
    if (!topLevelFetch) {
      throw new Error('The secure cart connection was not available. Please refresh this page and try again.');
    }

    logCartDiagnostic('transport-ready', { context: 'top-level-native' });
    return topLevelFetch;
  }

  function getCartRequestTimeoutError(label) {
    const error = new Error(`${label} timed out. Please check your connection and try again.`);
    error.name = 'TimeoutError';
    error.code = 'cart-timeout-error';
    return error;
  }

  async function cartRequestText(url, options = {}, label = 'Cart request') {
    const transportFetch = await getCartTransportFetch();
    const controller = new AbortController();
    const timeoutId = window.setTimeout(() => controller.abort(), CART_REQUEST_TIMEOUT_MS);

    try {
      const response = await transportFetch(url, {
        ...options,
        signal: controller.signal,
      });
      const text = await response.text();
      return { response, text };
    } catch (error) {
      if (controller.signal.aborted) {
        throw getCartRequestTimeoutError(label);
      }
      const message = String(error && error.message ? error.message : error || '');
      if (/failed to fetch|networkerror|load failed|internet disconnected/i.test(message)) {
        const connectionError = new Error('We could not connect to your cart. Check your internet connection and try again.');
        connectionError.code = 'cart-network-error';
        throw connectionError;
      }
      throw error;
    } finally {
      window.clearTimeout(timeoutId);
    }
  }

  async function fetchCart() {
    const topLevelFetch = getTopLevelNativeCartFetch() || window.fetch.bind(window);
    const controller = new AbortController();
    const timeoutId = window.setTimeout(() => controller.abort(), CART_VERIFICATION_REQUEST_TIMEOUT_MS);

    try {
      const response = await topLevelFetch('/cart.js', {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' },
        signal: controller.signal,
      });
      if (!response.ok) {
        const error = new Error(`Cart fetch failed: ${response.status}`);
        error.status = response.status;
        throw error;
      }
      const cart = await response.json();
      latestBuilderCartSnapshot = cart;
      return cart;
    } catch (error) {
      if (controller.signal.aborted) {
        throw getCartRequestTimeoutError('Cart verification');
      }
      throw error;
    } finally {
      window.clearTimeout(timeoutId);
    }
  }

  function sleep(ms) {
    return new Promise((resolve) => {
      window.setTimeout(resolve, ms);
    });
  }

  function isTransientCartVerificationError(error) {
    if (error && error.code === 'cart-network-error') return true;
    const status = Number(error && error.status) || 0;
    if (status === 429 || status === 408 || status >= 500) return true;

    return /failed to fetch|network|timeout|timed out|abort/i.test(String(error && error.message ? error.message : error || ''));
  }

  function canTrustCartMarkerAbsenceAfterAddError(error) {
    return Boolean(Number(error && error.status));
  }

  async function fetchCartWithRetry() {
    const delays = [0, 650, 1450];
    let lastError = null;

    for (const delay of delays) {
      if (delay) await sleep(delay);

      try {
        return await fetchCart();
      } catch (error) {
        lastError = error;
        if (!isTransientCartVerificationError(error)) break;
      }
    }

    throw lastError || new Error('Cart fetch failed');
  }

  function getCartItemSellingPlanId(item) {
    return String(getCartLineSellingPlanId(item) || '');
  }

  function buildCartItemQuantityMap(items, { cartItems = false } = {}) {
    return (Array.isArray(items) ? items : []).reduce((map, item) => {
      const variantId = String(cartItems ? item?.variant_id ?? item?.id ?? '' : item?.id ?? item?.variant_id ?? '');
      const quantity = Math.max(0, Number(item?.quantity) || 0);
      if (!variantId || !quantity) return map;

      const key = `${variantId}:${getCartItemSellingPlanId(item)}`;
      map.set(key, (map.get(key) || 0) + quantity);
      return map;
    }, new Map());
  }

  function verifyDynamicBundleCart(cart, dynamicBundleId, generatedItems) {
    if (!Array.isArray(cart?.items) || Number(cart?.item_count) <= 0) {
      return { ok: false, reason: 'empty-cart', matchingLines: [] };
    }

    const matchingLines = cart.items.filter((item) => (
      item?.properties?._rc_bundle === dynamicBundleId
    ));
    if (!matchingLines.length) {
      return { ok: false, reason: 'bundle-marker-missing', matchingLines };
    }

    const expected = buildCartItemQuantityMap(generatedItems);
    const actual = buildCartItemQuantityMap(matchingLines, { cartItems: true });
    const quantitiesMatch = expected.size === actual.size && [...expected.entries()].every(([key, quantity]) => (
      actual.get(key) === quantity
    ));

    return {
      ok: expected.size > 0 && quantitiesMatch,
      reason: quantitiesMatch ? 'verified' : 'bundle-contents-mismatch',
      matchingLines,
    };
  }

  async function fetchVerifiedCartWithRetry(dynamicBundleId, generatedItems) {
    const delays = [0, 400, 900];
    let lastError = null;

    for (const delay of delays) {
      if (delay) await sleep(delay);

      try {
        const cart = await fetchCart();
        const verification = verifyDynamicBundleCart(cart, dynamicBundleId, generatedItems);
        if (verification.ok) {
          return { cart, verification };
        }

        const error = new Error(
          verification.reason === 'bundle-contents-mismatch'
            ? 'The bundle in your cart was incomplete. Please try again.'
            : 'We could not confirm this bundle in your cart. Please try again.'
        );
        error.code = verification.reason;
        lastError = error;
      } catch (error) {
        lastError = error;
        if (!isTransientCartVerificationError(error)) break;
      }
    }

    throw lastError || new Error('We could not confirm this bundle in your cart. Please try again.');
  }

  async function resolveAmbiguousBundleAdd(dynamicBundleId, generatedItems, allowConfirmedAbsence = true) {
    try {
      return await fetchVerifiedCartWithRetry(dynamicBundleId, generatedItems);
    } catch (error) {
      if (allowConfirmedAbsence && error && (error.code === 'bundle-marker-missing' || error.code === 'empty-cart')) {
        return null;
      }
      const uncertaintyError = new Error(
        'We could not confirm whether your bundle was added. Check your connection, then refresh this page before trying again.'
      );
      uncertaintyError.code = 'cart-state-unknown';
      throw uncertaintyError;
    }
  }

  function extractAddedBundleItems(addResponsePayload, dynamicBundleId) {
    const items = Array.isArray(addResponsePayload?.items)
      ? addResponsePayload.items
      : addResponsePayload?.id
      ? [addResponsePayload]
      : [];

    return items.filter((item) => item?.properties?._rc_bundle === dynamicBundleId);
  }

  async function rollbackAddedBundleGroup(addResponsePayload, dynamicBundleId) {
    let rollbackItems = extractAddedBundleItems(addResponsePayload, dynamicBundleId);
    try {
      const cart = await fetchCart();
      rollbackItems = (cart.items || []).filter((item) => item?.properties?._rc_bundle === dynamicBundleId);
    } catch (error) {
      if (!rollbackItems.length) throw error;
    }

    const updates = rollbackItems.reduce((nextUpdates, item) => {
      if (item?.key) nextUpdates[item.key] = 0;
      return nextUpdates;
    }, {});
    if (!Object.keys(updates).length) return false;

    const { response } = await cartRequestText('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates }),
    }, 'Cart cleanup');

    if (!response.ok) {
      throw new Error(`Cart cleanup failed: ${response.status}`);
    }
    return true;
  }

  async function rollbackAndConfirmAddedBundleGroup(addResponsePayload, dynamicBundleId) {
    for (let attempt = 0; attempt < 2; attempt += 1) {
      try {
        await rollbackAddedBundleGroup(addResponsePayload, dynamicBundleId);
      } catch (error) {
        logCartDiagnostic('rollback-attempt-error', {
          attempt: attempt + 1,
          message: String(error && error.message ? error.message : error || ''),
        });
      }

      try {
        const cart = await fetchCartWithRetry();
        const markerStillPresent = (cart.items || []).some((item) => (
          item?.properties?._rc_bundle === dynamicBundleId
        ));
        if (!markerStillPresent) return true;
      } catch (error) {
        logCartDiagnostic('rollback-confirm-error', {
          attempt: attempt + 1,
          message: String(error && error.message ? error.message : error || ''),
        });
      }

      if (attempt === 0) await sleep(500);
    }

    return false;
  }

  function getCartAddErrorMessage(status, responseText) {
    const detail = String(responseText || '');
    if (Number(status) === 422 && /cannot apply selling plan to variant/i.test(detail)) {
      return 'One of these items is not available for this subscription frequency yet. Please remove it or choose another item.';
    }
    if (Number(status) === 422) {
      return 'We could not add this bundle yet. Please review your items and try again.';
    }
    return 'We could not add this bundle to your cart. Please try again.';
  }

  async function addBundleToCart(panel) {
    if (state.busy) return;
    const invalidRewardSlot = getMissingRewardChoiceSlot();
    if (invalidRewardSlot) {
      state.rewardPreviewChoices[invalidRewardSlot] = '';
      openGiftPicker(panel, invalidRewardSlot, true, 'cart');
      return;
    }
    const unavailable = getUnavailableSubscriptionSelections();
    if (unavailable.length) {
      const unavailableMessage = isSubscriptionOnlyBundle()
        ? `${formatProductList(unavailable)} ${unavailable.length === 1 ? 'is' : 'are'} not available for this subscription bundle yet.`
        : `${formatProductList(unavailable)} ${unavailable.length === 1 ? 'is' : 'are'} not available for subscription yet. Switch to one-time or remove ${unavailable.length === 1 ? 'it' : 'them'}.`;
      setStatus(
        panel,
        unavailableMessage,
        'error'
      );
      return;
    }
    const selections = readSelections();
    if (!selections.length) {
      setStatus(panel, 'Choose at least one item first.', 'error');
      return;
    }

    logCartDiagnostic('add-start', {
      mode: getActivePurchaseMode(),
      itemCount: getItemCount(),
      subtotalPence: getSubtotalPence(),
      selectionCount: selections.length,
    });

    captureAndPersistCustomBundleDraft('add-to-cart', {
      force: true,
      ttlMs: CUSTOM_BUNDLE_DRAFT_CHECKOUT_TTL_MS,
    });
    setBusy(panel, true);
    setStatus(panel, 'Adding your bundle...', 'info');
    let addResponsePayload = null;
    let dynamicBundleId = '';
    let addRequestSucceeded = false;
    let pipelineStarted = false;
    let keepBusyOnFailure = false;
    let recoveredVerifiedCart = null;

    try {
      await ensureBundleCartFlowScriptLoaded();
      await warmBuilderCartSnapshot();
      dispatchBundlePendingAdd(selections);
      await warmRechargeSdk();
      initRecharge();

      const bundle = buildRechargeBundle();
      if (!window.recharge.bundle.getDynamicBundleItems) {
        throw new Error('Recharge SDK did not expose dynamic bundle item generation');
      }

      const validation = window.recharge.bundle.validateDynamicBundle
        ? window.recharge.bundle.validateDynamicBundle(bundle)
        : true;
      if (validation !== true) {
        throw new Error(`Recharge dynamic bundle validation failed: ${validation}`);
      }

      const generatedItems = window.recharge.bundle.getDynamicBundleItems(bundle, BUNDLE_PRODUCT.shopifyHandle);
      dynamicBundleId = generatedItems[0] &&
        generatedItems[0].properties &&
        generatedItems[0].properties._rc_bundle;
      if (!dynamicBundleId) {
        throw new Error('Recharge dynamic bundle item generation did not return a bundle marker');
      }
      const selectedRewardChoices = REWARD_PREVIEW_CONCEPT === 'choice'
        ? REWARD_CHOICE_SLOTS.reduce((choices, slot) => {
          const choice = REWARD_PREVIEW_CHOICES.find((item) => item.id === state.rewardPreviewChoices[slot]);
          if (choice) choices[slot] = choice;
          return choices;
        }, {})
        : {};
      const firstRewardChoice = selectedRewardChoices[3000];
      const secondRewardChoice = selectedRewardChoices[4000];
      const thirdRewardChoice = selectedRewardChoices[5000];
      const legacyFinalRewardChoice = thirdRewardChoice || secondRewardChoice;
      const payload = {
        items: generatedItems.map((item) => {
          const properties = {
            ...(item.properties || {}),
          };
          delete properties['Box Contents'];
          delete properties.box_contents;
          delete properties.boxContents;

          return {
            ...item,
            properties: {
              ...properties,
              _bc_box_contents: buildBoxContents(),
              _bc_custom_builder_mvp: 'true',
              ...(firstRewardChoice ? {
                _bc_reward_choice_3000: firstRewardChoice.id,
                _bc_reward_variant_id_3000: String(firstRewardChoice.variantId),
                _bc_reward_product_handle_3000: firstRewardChoice.productHandle,
              } : {}),
              ...(isRewardChoiceSkipped(state.rewardPreviewChoices[3000]) ? {
                _bc_reward_skipped_3000: 'true',
              } : {}),
              ...(secondRewardChoice ? {
                _bc_reward_choice_4000: secondRewardChoice.id,
                _bc_reward_variant_id_4000: String(secondRewardChoice.variantId),
                _bc_reward_product_handle_4000: secondRewardChoice.productHandle,
              } : {}),
              ...(isRewardChoiceSkipped(state.rewardPreviewChoices[4000]) ? {
                _bc_reward_skipped_4000: 'true',
              } : {}),
              ...(thirdRewardChoice ? {
                _bc_reward_choice_5000: thirdRewardChoice.id,
                _bc_reward_variant_id_5000: String(thirdRewardChoice.variantId),
                _bc_reward_product_handle_5000: thirdRewardChoice.productHandle,
              } : {}),
              ...(isRewardChoiceSkipped(state.rewardPreviewChoices[5000]) ? {
                _bc_reward_skipped_5000: 'true',
              } : {}),
              ...(legacyFinalRewardChoice ? {
                _bc_final_reward_choice: legacyFinalRewardChoice.id,
                _bc_final_reward_variant_id: String(legacyFinalRewardChoice.variantId),
                _bc_final_reward_product_handle: legacyFinalRewardChoice.productHandle,
              } : {}),
            },
          };
        }),
      };

      setStatus(panel, 'Adding your bundle...', 'info');
      try {
        const { response: addResponse, text: addText } = await cartRequestText('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        }, 'Adding your bundle');
        logCartDiagnostic('add-response', { status: addResponse.status, ok: addResponse.ok });
        if (!addResponse.ok) {
          const addError = new Error(getCartAddErrorMessage(addResponse.status, addText));
          addError.status = Number(addResponse.status) || 0;
          throw addError;
        }
        addRequestSucceeded = true;
        try {
          addResponsePayload = addText ? JSON.parse(addText) : null;
        } catch (error) {
          throw new Error('The cart returned an invalid response. Please try again.');
        }
        if (!addResponsePayload) {
          throw new Error('The cart returned an empty response. Please try again.');
        }
      } catch (addError) {
        if (!isTransientCartVerificationError(addError)) throw addError;
        recoveredVerifiedCart = await resolveAmbiguousBundleAdd(
          dynamicBundleId,
          payload.items,
          canTrustCartMarkerAbsenceAfterAddError(addError)
        );
        if (!recoveredVerifiedCart) throw addError;
        addRequestSucceeded = true;
        addResponsePayload = { items: recoveredVerifiedCart.verification.matchingLines };
        logCartDiagnostic('add-response-recovered', {
          matchingLines: recoveredVerifiedCart.verification.matchingLines.length,
        });
      }

      try {
        const { cart, verification } = recoveredVerifiedCart ||
          await fetchVerifiedCartWithRetry(dynamicBundleId, payload.items);
        logCartDiagnostic('top-cart-verified', {
          itemCount: Number(cart.item_count) || 0,
          matchingLines: verification.matchingLines.length,
          reason: verification.reason,
        });

        const completion = dispatchBundleAddSucceeded({
          dynamicBundleId,
          selections,
          expectedItems: payload.items,
          cart,
          addResponsePayload,
        });
        pipelineStarted = true;
        logCartDiagnostic('success-dispatched', {
          dynamicBundleId: String(dynamicBundleId).slice(0, 12),
        });
        await completion;
        logCartDiagnostic('pipeline-complete', {
          dynamicBundleId: String(dynamicBundleId).slice(0, 12),
        });
        trackVerifiedBundleAdd(dynamicBundleId);
      } catch (cartError) {
        logCartDiagnostic('top-cart-error', {
          message: String(cartError && cartError.message ? cartError.message : cartError || ''),
        });
        throw cartError;
      }
      window.setTimeout(() => {
        const drawer = document.querySelector('.cart-drawer__dialog[open]');
        const drawerText = String(drawer?.textContent || '').replace(/\s+/g, ' ');
        logCartDiagnostic('drawer-state', {
          open: Boolean(drawer),
          hasTotal: /(?:Cart total|Your cart)\s*£[0-9.]+/.test(drawerText),
        });
      }, 4500);
      captureAndPersistCustomBundleDraft('add-to-cart-succeeded', {
        force: true,
        ttlMs: CUSTOM_BUNDLE_DRAFT_CHECKOUT_TTL_MS,
      });
      setStatus(panel, '', 'info');
    } catch (error) {
      let customerError = error;
      keepBusyOnFailure = Boolean(error && error.code === 'cart-state-unknown');
      if (addRequestSucceeded && dynamicBundleId && !pipelineStarted) {
        const rollbackConfirmed = await rollbackAndConfirmAddedBundleGroup(addResponsePayload, dynamicBundleId);
        logCartDiagnostic('rollback', { confirmedAbsent: rollbackConfirmed });
        if (!rollbackConfirmed) {
          keepBusyOnFailure = true;
          customerError = new Error(
            'We could not confirm your cart state. Please refresh this page before trying again.'
          );
          customerError.code = 'cart-state-unknown';
        }
      } else if (pipelineStarted) {
        keepBusyOnFailure = true;
        customerError = new Error(
          'Your bundle was added, but the cart could not finish loading. Please refresh this page before trying again.'
        );
      }
      logCartDiagnostic('add-error', {
        message: String(customerError && customerError.message ? customerError.message : customerError || ''),
      });
      dispatchBundleAddFailed(customerError);
      setStatus(panel, String(customerError && customerError.message ? customerError.message : customerError), 'error');
    } finally {
      if (!keepBusyOnFailure) setBusy(panel, false);
    }
  }

  function formatRewardDelta(pence) {
    const amount = Math.max(0, Number(pence) || 0) / 100;
    return Number.isInteger(amount) ? `£${amount.toFixed(0)}` : `£${amount.toFixed(2)}`;
  }

  const REWARD_MILESTONE_ICON_SVGS = {
    delivery: {
      viewBox: '0 0 72 30',
      shape: 'wide',
      path: 'M32 0h1v1h-1zM32 1h5v1h-5zM31 2h7v1h-7zM35 3h2v1h-2zM19 4h8v1h-8zM35 4h2v1h-2zM19 5h1v1h-1zM22 5h5v1h-5zM35 5h2v1h-2zM20 6h4v1h-4zM36 6h1v1h-1zM3 7h7v1h-7zM22 7h2v1h-2zM36 7h6v1h-6zM22 8h2v1h-2zM36 8h17v1h-17zM23 9h1v1h-1zM35 9h3v1h-3zM49 9h12v1h-12zM23 10h1v1h-1zM34 10h4v1h-4zM59 10h2v1h-2zM14 11h3v1h-3zM22 11h3v1h-3zM33 11h1v1h-1zM36 11h2v1h-2zM59 11h2v1h-2zM62 11h2v1h-2zM11 12h9v1h-9zM21 12h4v1h-4zM32 12h1v1h-1zM36 12h2v1h-2zM59 12h5v1h-5zM1 13h6v1h-6zM10 13h12v1h-12zM24 13h1v1h-1zM31 13h1v1h-1zM36 13h2v1h-2zM42 13h2v1h-2zM59 13h3v1h-3zM63 13h1v1h-1zM8 14h7v1h-7zM17 14h5v1h-5zM24 14h2v1h-2zM30 14h2v1h-2zM36 14h2v1h-2zM42 14h3v1h-3zM46 14h7v1h-7zM59 14h1v1h-1zM61 14h3v1h-3zM8 15h4v1h-4zM15 15h1v1h-1zM19 15h4v1h-4zM24 15h2v1h-2zM29 15h2v1h-2zM36 15h2v1h-2zM42 15h11v1h-11zM58 15h2v1h-2zM61 15h5v1h-5zM7 16h4v1h-4zM12 16h1v1h-1zM15 16h1v1h-1zM18 16h2v1h-2zM21 16h3v1h-3zM25 16h4v1h-4zM37 16h1v1h-1zM42 16h1v1h-1zM45 16h2v1h-2zM58 16h2v1h-2zM61 16h6v1h-6zM7 17h3v1h-3zM13 17h1v1h-1zM15 17h1v1h-1zM17 17h2v1h-2zM21 17h3v1h-3zM25 17h2v1h-2zM37 17h2v1h-2zM42 17h1v1h-1zM44 17h1v1h-1zM58 17h11v1h-11zM7 18h5v1h-5zM13 18h2v1h-2zM16 18h2v1h-2zM22 18h3v1h-3zM26 18h1v1h-1zM37 18h2v1h-2zM41 18h4v1h-4zM47 18h7v1h-7zM57 18h13v1h-13zM7 19h2v1h-2zM11 19h18v1h-18zM37 19h2v1h-2zM41 19h3v1h-3zM45 19h1v1h-1zM47 19h1v1h-1zM49 19h5v1h-5zM57 19h8v1h-8zM68 19h3v1h-3zM7 20h2v1h-2zM12 20h9v1h-9zM22 20h8v1h-8zM37 20h2v1h-2zM57 20h5v1h-5zM63 20h2v1h-2zM67 20h1v1h-1zM69 20h2v1h-2zM7 21h2v1h-2zM10 21h20v1h-20zM37 21h2v1h-2zM57 21h4v1h-4zM64 21h3v1h-3zM70 21h2v1h-2zM7 22h2v1h-2zM13 22h7v1h-7zM22 22h17v1h-17zM56 22h5v1h-5zM62 22h5v1h-5zM68 22h4v1h-4zM7 23h3v1h-3zM12 23h2v1h-2zM15 23h1v1h-1zM17 23h1v1h-1zM19 23h42v1h-42zM62 23h10v1h-10zM7 24h3v1h-3zM12 24h1v1h-1zM15 24h1v1h-1zM17 24h2v1h-2zM21 24h3v1h-3zM25 24h4v1h-4zM35 24h26v1h-26zM64 24h3v1h-3zM69 24h2v1h-2zM8 25h4v1h-4zM15 25h1v1h-1zM18 25h1v1h-1zM20 25h3v1h-3zM26 25h3v1h-3zM36 25h1v1h-1zM40 25h17v1h-17zM58 25h4v1h-4zM63 25h1v1h-1zM65 25h3v1h-3zM69 25h2v1h-2zM9 26h3v1h-3zM15 26h1v1h-1zM19 26h3v1h-3zM60 26h3v1h-3zM65 26h1v1h-1zM67 26h4v1h-4zM10 27h11v1h-11zM61 27h9v1h-9zM11 28h9v1h-9zM62 28h7v1h-7zM14 29h2v1h-2z',
    },
    gift: {
      viewBox: '0 0 72 48',
      shape: 'cakes',
      path: 'M49 0h6v1h-6zM41 1h20v1h-20zM37 2h8v1h-8zM57 2h7v1h-7zM35 3h5v1h-5zM62 3h4v1h-4zM33 4h4v1h-4zM42 4h1v1h-1zM46 4h1v1h-1zM51 4h1v1h-1zM54 4h2v1h-2zM65 4h3v1h-3zM32 5h3v1h-3zM42 5h1v1h-1zM46 5h1v1h-1zM51 5h1v1h-1zM54 5h1v1h-1zM59 5h2v1h-2zM67 5h2v1h-2zM31 6h2v1h-2zM38 6h2v1h-2zM48 6h2v1h-2zM62 6h2v1h-2zM68 6h2v1h-2zM31 7h1v1h-1zM38 7h2v1h-2zM44 7h1v1h-1zM53 7h1v1h-1zM62 7h2v1h-2zM69 7h2v1h-2zM30 8h2v1h-2zM53 8h1v1h-1zM69 8h2v1h-2zM30 9h2v1h-2zM33 9h1v1h-1zM42 9h2v1h-2zM57 9h2v1h-2zM70 9h1v1h-1zM30 10h2v1h-2zM33 10h2v1h-2zM42 10h2v1h-2zM50 10h2v1h-2zM65 10h1v1h-1zM70 10h1v1h-1zM14 11h18v1h-18zM34 11h2v1h-2zM37 11h2v1h-2zM63 11h3v1h-3zM70 11h1v1h-1zM9 12h11v1h-11zM27 12h7v1h-7zM38 12h5v1h-5zM59 12h6v1h-6zM70 12h1v1h-1zM7 13h6v1h-6zM15 13h1v1h-1zM32 13h5v1h-5zM40 13h3v1h-3zM47 13h5v1h-5zM58 13h4v1h-4zM70 13h1v1h-1zM5 14h4v1h-4zM15 14h1v1h-1zM23 14h2v1h-2zM27 14h2v1h-2zM36 14h3v1h-3zM70 14h1v1h-1zM3 15h4v1h-4zM13 15h2v1h-2zM18 15h2v1h-2zM23 15h2v1h-2zM26 15h2v1h-2zM32 15h1v1h-1zM38 15h3v1h-3zM70 15h1v1h-1zM2 16h3v1h-3zM10 16h1v1h-1zM13 16h2v1h-2zM32 16h1v1h-1zM40 16h2v1h-2zM70 16h1v1h-1zM2 17h2v1h-2zM9 17h3v1h-3zM17 17h1v1h-1zM21 17h1v1h-1zM34 17h2v1h-2zM41 17h2v1h-2zM70 17h2v1h-2zM1 18h2v1h-2zM26 18h1v1h-1zM35 18h1v1h-1zM41 18h2v1h-2zM70 18h2v1h-2zM1 19h2v1h-2zM14 19h1v1h-1zM30 19h1v1h-1zM42 19h2v1h-2zM66 19h3v1h-3zM70 19h2v1h-2zM1 20h1v1h-1zM4 20h1v1h-1zM13 20h2v1h-2zM23 20h1v1h-1zM30 20h1v1h-1zM42 20h2v1h-2zM65 20h6v1h-6zM1 21h1v1h-1zM4 21h2v1h-2zM37 21h2v1h-2zM42 21h2v1h-2zM56 21h3v1h-3zM65 21h6v1h-6zM1 22h1v1h-1zM8 22h4v1h-4zM34 22h4v1h-4zM42 22h2v1h-2zM56 22h4v1h-4zM64 22h7v1h-7zM1 23h2v1h-2zM9 23h6v1h-6zM20 23h4v1h-4zM30 23h6v1h-6zM42 23h2v1h-2zM48 23h3v1h-3zM55 23h7v1h-7zM63 23h8v1h-8zM1 24h1v1h-1zM14 24h1v1h-1zM20 24h5v1h-5zM30 24h2v1h-2zM42 24h4v1h-4zM47 24h6v1h-6zM54 24h17v1h-17zM0 25h2v1h-2zM42 25h29v1h-29zM0 26h2v1h-2zM42 26h29v1h-29zM0 27h2v1h-2zM42 27h29v1h-29zM0 28h2v1h-2zM42 28h29v1h-29zM0 29h2v1h-2zM38 29h3v1h-3zM42 29h29v1h-29zM0 30h2v1h-2zM5 30h2v1h-2zM38 30h33v1h-33zM1 31h2v1h-2zM4 31h4v1h-4zM29 31h2v1h-2zM37 31h29v1h-29zM67 31h3v1h-3zM1 32h7v1h-7zM14 32h1v1h-1zM28 32h4v1h-4zM37 32h7v1h-7zM46 32h12v1h-12zM59 32h2v1h-2zM65 32h4v1h-4zM1 33h7v1h-7zM12 33h4v1h-4zM21 33h3v1h-3zM28 33h5v1h-5zM36 33h8v1h-8zM47 33h2v1h-2zM53 33h2v1h-2zM61 33h6v1h-6zM1 34h8v1h-8zM11 34h6v1h-6zM20 34h5v1h-5zM27 34h19v1h-19zM55 34h9v1h-9zM1 35h59v1h-59zM1 36h43v1h-43zM48 36h2v1h-2zM1 37h43v1h-43zM1 38h43v1h-43zM1 39h43v1h-43zM1 40h43v1h-43zM2 41h2v1h-2zM5 41h38v1h-38zM2 42h3v1h-3zM8 42h2v1h-2zM12 42h26v1h-26zM39 42h3v1h-3zM3 43h4v1h-4zM13 43h5v1h-5zM19 43h12v1h-12zM37 43h4v1h-4zM5 44h6v1h-6zM20 44h2v1h-2zM34 44h5v1h-5zM7 45h11v1h-11zM27 45h10v1h-10zM11 46h22v1h-22zM19 47h6v1h-6z',
    },
    mystery: {
      viewBox: '0 0 72 58',
      shape: 'mystery',
      stroke: true,
      path: 'M10 21l8-6h37l8 6-7 7H17l-7-7Zm0 0v26l7 6h39l7-6V21M17 28v25M56 28v25M31 28v25M40 28v25M35 15c-5-7-13-11-16-7-3 5 5 10 16 10M37 15c5-7 13-11 16-7 3 5-5 10-16 10M32 14c2-3 7-3 9 0l-2 5h-7v-5ZM39 18c4 2 6 5 6 9M45 27l10 3 3 13-12 4-5-12 4-8ZM49 34c1-4 7-4 7 0 0 3-4 3-4 6M52 44h.1',
    },
    bag: {
      viewBox: '0 0 72 31',
      shape: 'wide',
      path: 'M24 0h5v1h-5zM2 1h31v1h-31zM61 1h5v1h-5zM67 1h1v1h-1zM1 2h2v1h-2zM9 2h2v1h-2zM15 2h6v1h-6zM32 2h10v1h-10zM59 2h3v1h-3zM65 2h6v1h-6zM1 3h1v1h-1zM4 3h2v1h-2zM34 3h3v1h-3zM40 3h5v1h-5zM58 3h2v1h-2zM62 3h5v1h-5zM68 3h3v1h-3zM1 4h1v1h-1zM3 4h2v1h-2zM44 4h3v1h-3zM57 4h2v1h-2zM60 4h9v1h-9zM70 4h1v1h-1zM1 5h1v1h-1zM46 5h3v1h-3zM56 5h2v1h-2zM59 5h2v1h-2zM66 5h5v1h-5zM1 6h1v1h-1zM48 6h2v1h-2zM56 6h1v1h-1zM58 6h2v1h-2zM1 7h2v1h-2zM45 7h2v1h-2zM49 7h2v1h-2zM55 7h2v1h-2zM58 7h1v1h-1zM1 8h2v1h-2zM46 8h2v1h-2zM50 8h3v1h-3zM54 8h2v1h-2zM58 8h1v1h-1zM1 9h2v1h-2zM47 9h2v1h-2zM50 9h5v1h-5zM57 9h2v1h-2zM1 10h1v1h-1zM41 10h5v1h-5zM49 10h5v1h-5zM56 10h2v1h-2zM1 11h1v1h-1zM15 11h4v1h-4zM45 11h3v1h-3zM50 11h7v1h-7zM1 12h1v1h-1zM15 12h4v1h-4zM23 12h1v1h-1zM25 12h1v1h-1zM47 12h8v1h-8zM1 13h1v1h-1zM15 13h3v1h-3zM19 13h1v1h-1zM21 13h3v1h-3zM25 13h1v1h-1zM27 13h5v1h-5zM49 13h3v1h-3zM53 13h1v1h-1zM1 14h1v1h-1zM15 14h2v1h-2zM18 14h2v1h-2zM21 14h3v1h-3zM25 14h1v1h-1zM27 14h1v1h-1zM30 14h1v1h-1zM50 14h2v1h-2zM53 14h2v1h-2zM1 15h1v1h-1zM15 15h9v1h-9zM25 15h4v1h-4zM30 15h1v1h-1zM46 15h5v1h-5zM53 15h2v1h-2zM1 16h1v1h-1zM21 16h3v1h-3zM47 16h5v1h-5zM53 16h2v1h-2zM1 17h1v1h-1zM15 17h3v1h-3zM20 17h2v1h-2zM23 17h1v1h-1zM44 17h7v1h-7zM52 17h3v1h-3zM1 18h2v1h-2zM16 18h1v1h-1zM20 18h1v1h-1zM25 18h3v1h-3zM29 18h2v1h-2zM34 18h1v1h-1zM44 18h3v1h-3zM50 18h4v1h-4zM1 19h2v1h-2zM15 19h3v1h-3zM20 19h1v1h-1zM25 19h1v1h-1zM27 19h6v1h-6zM34 19h1v1h-1zM50 19h4v1h-4zM1 20h2v1h-2zM15 20h1v1h-1zM17 20h2v1h-2zM20 20h2v1h-2zM23 20h3v1h-3zM27 20h4v1h-4zM32 20h3v1h-3zM46 20h1v1h-1zM49 20h7v1h-7zM1 21h2v1h-2zM16 21h1v1h-1zM18 21h1v1h-1zM42 21h4v1h-4zM48 21h6v1h-6zM55 21h2v1h-2zM1 22h1v1h-1zM42 22h1v1h-1zM47 22h2v1h-2zM50 22h5v1h-5zM56 22h2v1h-2zM1 23h1v1h-1zM46 23h2v1h-2zM50 23h3v1h-3zM54 23h2v1h-2zM57 23h1v1h-1zM0 24h2v1h-2zM3 24h1v1h-1zM49 24h1v1h-1zM55 24h1v1h-1zM57 24h1v1h-1zM0 25h2v1h-2zM3 25h1v1h-1zM47 25h3v1h-3zM55 25h1v1h-1zM57 25h2v1h-2zM67 25h1v1h-1zM0 26h2v1h-2zM4 26h1v1h-1zM46 26h2v1h-2zM55 26h2v1h-2zM58 26h13v1h-13zM1 27h1v1h-1zM10 27h2v1h-2zM43 27h4v1h-4zM56 27h2v1h-2zM60 27h3v1h-3zM65 27h2v1h-2zM68 27h1v1h-1zM70 27h1v1h-1zM1 28h2v1h-2zM7 28h11v1h-11zM37 28h7v1h-7zM57 28h3v1h-3zM62 28h9v1h-9zM2 29h8v1h-8zM14 29h26v1h-26zM58 29h6v1h-6zM66 29h5v1h-5zM22 30h4v1h-4z',
    },
  };

  function renderRewardMilestoneIcon(icon) {
    if (icon === 'mystery' && window.BC_MYSTERY_GIFT_ICON_URL) {
      const iconUrl = escapeHtml(String(window.BC_MYSTERY_GIFT_ICON_URL));
      return `<span class="bc-custom-bundle-mvp__del-icon bc-custom-bundle-mvp__del-icon--mystery" style="--bc-mystery-gift-icon: url('${iconUrl}')" aria-hidden="true"></span>`;
    }

    const data = REWARD_MILESTONE_ICON_SVGS[icon] || REWARD_MILESTONE_ICON_SVGS.gift;
    const shapeClass = data.shape ? ` bc-custom-bundle-mvp__del-icon--${data.shape}` : '';
    const pathAttributes = data.stroke
      ? 'fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"'
      : 'fill="currentColor" fill-rule="evenodd"';
    return `
      <svg class="bc-custom-bundle-mvp__del-icon${shapeClass}" viewBox="${data.viewBox}" aria-hidden="true" focusable="false">
        <path ${pathAttributes} d="${data.path}"></path>
      </svg>
    `;
  }

  function renderRewardLockIcon() {
    return `
      <span class="bc-custom-bundle-mvp__del-lock" aria-hidden="true">
        <svg viewBox="0 0 16 16" focusable="false">
          <path fill="currentColor" fill-rule="evenodd" d="M5 7V5a3 3 0 0 1 6 0v2h1a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1Zm1.4 0h3.2V5a1.6 1.6 0 1 0-3.2 0v2Z"></path>
        </svg>
      </span>
    `;
  }

  function renderMeter() {
    const p = getRewardDisplaySubtotalPence();
    const isSub = getActivePurchaseMode() === 'subscription';
    const finalReward = getFinalRewardPresentation();
    let title;
    if (!isSub && p >= 2500) {
      title = 'Subscribe to unlock rewards';
    } else if (p < 2500) {
      title = 'Add ' + formatRewardDelta(2500 - p) + ' for 99p shipping';
    } else if (p < 3000) {
      title = 'Add ' + formatRewardDelta(3000 - p) + ' to choose your first free gift';
    } else if (p < 4000) {
      title = REWARD_PREVIEW_CONCEPT === 'choice'
        ? 'Add ' + formatRewardDelta(4000 - p) + ' to choose another free gift'
        : 'Add ' + formatRewardDelta(4000 - p) + ' for ' + finalReward.name;
    } else if (p < 5000) {
      title = REWARD_PREVIEW_CONCEPT === 'choice'
        ? 'Add ' + formatRewardDelta(5000 - p) + ' to choose another free gift'
        : 'Add ' + formatRewardDelta(5000 - p) + ' for another free gift';
    } else {
      title = REWARD_PREVIEW_CONCEPT === 'choice'
        ? (getMissingRewardChoiceSlot()
          ? 'Choose your three free gifts'
          : REWARD_CHOICE_SLOTS.every((slot) => isRewardChoiceSkipped(state.rewardPreviewChoices[slot]))
            ? 'Free gifts skipped'
            : REWARD_CHOICE_SLOTS.some((slot) => isRewardChoiceSkipped(state.rewardPreviewChoices[slot]))
              ? 'Gift choices saved'
              : 'All three free gifts selected')
        : 'All gifts unlocked';
    }
    let fill;
    if (p <= 0) fill = 0;
    else if (p < 2500) fill = (p / 2500) * 22;
    else if (!isSub) fill = 22;
    else if (p < 3000) fill = 22 + ((p - 2500) / 500) * 24;
    else if (p < 4000) fill = 46 + ((p - 3000) / 1000) * 24;
    else if (p < 5000) fill = 70 + ((p - 4000) / 1000) * 24;
    else fill = 100;
    const stops = [
      { at: 2500, pos: 22, labelPos: 22, label: '99p Shipping', icon: 'delivery', gift: false },
      {
        at: 3000,
        pos: 46,
        labelPos: 46,
        label: '1 Free Gift',
        icon: 'mystery',
        gift: true,
      },
      {
        at: 4000,
        pos: 70,
        labelPos: 70,
        label: REWARD_PREVIEW_CONCEPT === 'choice' ? '2 Free Gifts' : finalReward.short,
        icon: finalReward.icon,
        gift: true,
      },
      {
        at: 5000,
        pos: 94,
        labelPos: 94,
        label: '3 Free Gifts',
        icon: 'mystery',
        gift: true,
      },
    ];
    const unlockedGiftCount = getEligibleRewardChoiceSlots().length;
    const markers = stops.map((s) => {
      const locked = !isSub && s.gift;
      const reached = p >= s.at && !locked;
      const markClass = [
        'bc-custom-bundle-mvp__del-mark',
        reached ? 'is-reached' : '',
        locked ? 'is-locked' : '',
      ].filter(Boolean).join(' ');
      const labelClass = [
        'bc-custom-bundle-mvp__del-label',
        locked ? 'is-locked' : '',
      ].filter(Boolean).join(' ');
      const lockCopy = locked ? ' - subscription only' : '';
      const opensGiftPicker = REWARD_PREVIEW_CONCEPT === 'choice' && s.gift && isSub;
      const actionAttribute = opensGiftPicker ? `data-bc-mvp-gift-picker-open="${s.at}"` : 'data-bc-mvp-rewards-info';
      const giftPickerLabel = unlockedGiftCount === 3
        ? 'Choose your three free gifts'
        : unlockedGiftCount === 2 ? 'Choose your two free gifts' : 'Choose your free gift';
      const actionLabel = opensGiftPicker ? giftPickerLabel : `Reward details: ${s.label}${lockCopy}`;
      return `<button type="button" class="${markClass}" style="left: ${s.pos}%" ${actionAttribute} aria-label="${escapeHtml(actionLabel)}">${renderRewardMilestoneIcon(s.icon)}${locked ? renderRewardLockIcon() : ''}</button>` +
        `<span class="${labelClass}" style="left: ${s.labelPos}%" aria-label="${formatThreshold(s.at)} ${escapeHtml(s.label)}${lockCopy}"><strong>${formatThreshold(s.at)}</strong><span>${escapeHtml(s.label)}</span></span>`;
    }).join('');
    return `
      <div class="bc-custom-bundle-mvp__rewards">
        <button type="button" class="bc-custom-bundle-mvp__del-info" data-bc-mvp-rewards-info aria-label="Reward details">i</button>
        <span class="bc-custom-bundle-mvp__del-title">${escapeHtml(title)}</span>
        <div class="bc-custom-bundle-mvp__del-track">
          <span class="bc-custom-bundle-mvp__del-line"><span class="bc-custom-bundle-mvp__del-fill" style="width: ${fill.toFixed(1)}%"></span></span>
          ${markers}
        </div>
      </div>
    `;
  }

  function renderCategoryNav() {
    const categories = getVisibleCategories();
    if (categories.length <= 1) return '';
    return `
      <nav class="bc-custom-bundle-mvp__category-nav" aria-label="Bundle categories">
        ${categories.map((category) => `
          <button type="button" data-bc-mvp-scroll-category="${escapeHtml(getCategoryId(category))}">
            ${escapeHtml(category)}
          </button>
        `).join('')}
      </nav>
    `;
  }

  function renderProduct(product, index) {
    const quantity = Math.max(0, Number(state.quantities[index]) || 0);
    const variant = getVariant(product, index);
    const unitPrice = getUnitPricePence(variant);
    const displayTitle = product.sourceTitle || product.label;
    const imageMarkup = renderProductImageMarkup(product, displayTitle, index);
    const variantControl = product.variants.length > 1
      ? `<select class="bc-custom-bundle-mvp__variant" data-bc-mvp-variant="${index}" aria-label="${escapeHtml(product.label)} size">
          ${product.variants.map((item, variantIndex) => `
            <option value="${variantIndex}" ${variantIndex === state.variantIndexes[index] ? 'selected' : ''}>
              ${escapeHtml(item.label)}
            </option>
          `).join('')}
        </select>`
      : '';

    return `
      <article class="bc-custom-bundle-mvp__card ${quantity > 0 ? 'is-selected' : ''}" data-bc-mvp-card="${index}" data-bc-mvp-quantity="${quantity}">
        <div class="bc-custom-bundle-mvp__image">
          <button type="button" class="bc-custom-bundle-mvp__image-button" data-bc-mvp-product-info="${index}" aria-label="More about ${escapeHtml(displayTitle)}">
            ${imageMarkup}
          </button>
          <button type="button" class="bc-custom-bundle-mvp__info" data-bc-mvp-product-info="${index}" aria-label="More about ${escapeHtml(displayTitle)}">i</button>
        </div>
        <h2>${escapeHtml(displayTitle)}</h2>
        <p class="bc-custom-bundle-mvp__price">
          <span class="bc-custom-bundle-mvp__price-now">${formatMoney(unitPrice)}</span>
        </p>
        ${variantControl
          ? `<div class="bc-custom-bundle-mvp__variant-wrap">${variantControl}</div>`
          : '<div class="bc-custom-bundle-mvp__variant-wrap is-empty" aria-hidden="true"></div>'}
        ${quantity > 0 ? `
          <div class="bc-custom-bundle-mvp__qty bc-custom-bundle-mvp__card-control" aria-label="${escapeHtml(product.label)} quantity">
            <button type="button" data-bc-mvp-minus="${index}" aria-label="Remove one ${escapeHtml(product.label)}">−</button>
            <span class="bc-custom-bundle-mvp__qty-value">${quantity}</span>
            <button type="button" data-bc-mvp-plus="${index}" aria-label="Add one ${escapeHtml(product.label)}">+</button>
          </div>
        ` : `
	          <button type="button" class="bc-custom-bundle-mvp__add bc-custom-bundle-mvp__card-control" data-bc-mvp-plus="${index}">Add</button>
        `}
      </article>
    `;
  }

  function closeProductDetailsFallback() {
    const modal = document.querySelector('[data-bc-mvp-details-modal]');
    if (modal && modal.parentNode) modal.parentNode.removeChild(modal);
  }

  function renderProductDetailsFallback(product, panel) {
    closeProductDetailsFallback();
    const displayTitle = product.sourceTitle || product.label;
    const imageMarkup = renderProductDetailsImageMarkup(product, displayTitle);
    const detailsCopy = product.description ||
      'Choose this item as part of your bundle. Prices update with your purchase option.';
    const detailsMarkup = product.descriptionHtml || `<p>${escapeHtml(detailsCopy)}</p>`;
    const modal = document.createElement('div');
    modal.className = 'bc-custom-bundle-mvp__details-backdrop';
    modal.dataset.bcMvpDetailsModal = 'true';
    modal.innerHTML = `
      <section class="bc-custom-bundle-mvp__details" role="dialog" aria-modal="true" aria-label="${escapeHtml(displayTitle)} details">
        <div class="bc-custom-bundle-mvp__details-media">${imageMarkup}</div>
        <div class="bc-custom-bundle-mvp__details-body">
          <div class="bc-custom-bundle-mvp__details-title-row">
            <h2>${escapeHtml(displayTitle)}</h2>
            <button type="button" class="bc-custom-bundle-mvp__details-close" data-bc-mvp-close-details aria-label="Close">×</button>
          </div>
          <div class="bc-custom-bundle-mvp__details-copy">${detailsMarkup}</div>
        </div>
      </section>
    `;
    modal.addEventListener('click', (event) => {
      if (event.target === modal || event.target.closest('[data-bc-mvp-close-details]')) {
        closeProductDetailsFallback();
      }
    });
    document.addEventListener('keydown', function onEscape(event) {
      if (event.key !== 'Escape') return;
      closeProductDetailsFallback();
      document.removeEventListener('keydown', onEscape);
    });
    document.body.appendChild(modal);
    const closeButton = modal.querySelector('[data-bc-mvp-close-details]');
    if (closeButton) closeButton.focus();
    setStatus(panel, '', 'info');
  }

  function openProductDetails(product, panel) {
    renderProductDetailsFallback(product, panel);
  }

  function renderProductSections() {
    if (!PRODUCTS.length) {
      const isWaiting = state.catalogStatus === 'waiting';
      return `
        <section class="bc-custom-bundle-mvp__loading" aria-live="polite" aria-busy="true">
          <span class="bc-custom-bundle-mvp__spinner" aria-hidden="true"></span>
          <p class="bc-custom-bundle-mvp__loading-text">${isWaiting ? 'Still loading…' : 'Loading'}</p>
        </section>
      `;
    }

    const categories = getVisibleCategories();
    return categories.map((category) => {
      const categoryProducts = PRODUCTS
        .map((product, index) => ({ product, index }))
        .filter((item) => item.product.category === category && isProductAvailableForCurrentMode(item.product));
      if (!categoryProducts.length) return '';
      const cards = categoryProducts
        .map((item) => renderProduct(item.product, item.index))
        .join('');
      return `
        <section class="bc-custom-bundle-mvp__product-section" id="${escapeHtml(getCategoryId(category))}" aria-label="${escapeHtml(category)}">
          <div class="bc-custom-bundle-mvp__section-head">
            <h2>${escapeHtml(category)}</h2>
          </div>
          <div class="bc-custom-bundle-mvp__grid">
            ${cards}
          </div>
        </section>
      `;
    }).join('');
  }

  function renderSelectedCartRows(selections) {
    return selections.map((item) => `
        <div class="bc-custom-bundle-mvp__cart-row">
          <span class="bc-custom-bundle-mvp__cart-info">
            <span class="bc-custom-bundle-mvp__cart-name">${escapeHtml(item.label)}</span>
            ${item.variantLabel && item.variantLabel !== 'Default Title' ? `<span class="bc-custom-bundle-mvp__cart-variant">${escapeHtml(item.variantLabel)}</span>` : ''}
          </span>
          <span class="bc-custom-bundle-mvp__cart-qty">
            <button type="button" data-bc-mvp-minus="${item.index}" aria-label="Remove one ${escapeHtml(item.label)}">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-bc-mvp-plus="${item.index}" aria-label="Add one ${escapeHtml(item.label)}">+</button>
          </span>
          <span class="bc-custom-bundle-mvp__cart-price">${formatMoney(item.unitPricePence * item.quantity)}</span>
        </div>
      `).join('');
  }

  function getFirstOrderOfferPence() {
    const subscriptionPence = getModeSubtotalPence('subscription');
    if (!FIRST_ORDER_OFFER_ENABLED || subscriptionPence <= 0) return 0;
    return Math.round((subscriptionPence * 4) / 5);
  }

  function getFirstOrderSavingPence() {
    if (!FIRST_ORDER_OFFER_ENABLED) return 0;
    const oneTimePence = getModeSubtotalPence('onetime');
    const firstOrderPence = getFirstOrderOfferPence();
    return Math.max(0, oneTimePence - firstOrderPence);
  }

  function renderWelcomeOfferMessage() {
    if (!FIRST_ORDER_OFFER_ENABLED) return '';
    return `
      <div class="bc-custom-bundle-mvp__welcome-offer" role="status">
        <strong>28% off your first order · Welcome offer</strong>
      </div>
    `;
  }

  function renderDesktopFirstOrderPrices() {
    if (!FIRST_ORDER_OFFER_ENABLED) return '';
    const firstOrderPence = getFirstOrderOfferPence();
    const subscriptionPence = getModeSubtotalPence('subscription');
    if (!firstOrderPence || !subscriptionPence) {
      return `
        <div class="bc-custom-bundle-mvp__desktop-offer-prices">
          <span>28% off your first subscription order</span>
          <small>Then save 10% on future deliveries</small>
        </div>
      `;
    }
    return `
      <div class="bc-custom-bundle-mvp__desktop-offer-prices" aria-label="First delivery ${formatMoney(firstOrderPence)}. Then ${formatMoney(subscriptionPence)} per delivery.">
        <span>First delivery</span>
        <strong>${formatMoney(firstOrderPence)}</strong>
        <small>Then ${formatMoney(subscriptionPence)} per delivery</small>
      </div>
    `;
  }

  function renderMobileSubscriptionPrice(onePence, subPence) {
    if (!FIRST_ORDER_OFFER_ENABLED) {
      const compare = !isSubscriptionOnlyBundle() && onePence > subPence ? `<s>${formatMoney(onePence)}</s>` : '';
      return `<span>${formatMoney(subPence)} ${compare}</span>`;
    }
    const firstOrderPence = getFirstOrderOfferPence();
    return `
      <span class="bc-custom-bundle-mvp__sheet-offer-price" aria-label="First delivery ${formatMoney(firstOrderPence)}. Then ${formatMoney(subPence)} per delivery.">
        <strong>First ${formatMoney(firstOrderPence)}</strong>
        <small>Then ${formatMoney(subPence)}</small>
      </span>
    `;
  }

  function renderMobileSubscriptionBenefits() {
    const benefits = FIRST_ORDER_OFFER_ENABLED
      ? ['10% off every order', 'Up to 3 free gifts in your first delivery', 'Pause, skip or cancel anytime']
      : ['10% off every order', 'Free gifts with qualifying subscription bundles', 'Pause, skip or cancel anytime'];
    return `
      <ul class="bc-custom-bundle-mvp__sheet-benefits">
        ${benefits.map((item) => `<li>${escapeHtml(item)}</li>`).join('')}
      </ul>
    `;
  }

  function renderSubscriptionSavingsRow() {
    if (isSubscriptionOnlyBundle() || getActivePurchaseMode() !== 'subscription') return '';
    const onePence = getModeSubtotalPence('onetime');
    const subPence = getModeSubtotalPence('subscription');
    if (!onePence || onePence <= subPence) return '';
    if (FIRST_ORDER_OFFER_ENABLED) {
      const firstOrderPence = getFirstOrderOfferPence();
      return `
        <div class="bc-custom-bundle-mvp__savings-row bc-custom-bundle-mvp__savings-row--first-order">
          <span class="bc-custom-bundle-mvp__savings-prices bc-custom-bundle-mvp__savings-prices--first-order" aria-label="One-time price ${formatMoney(onePence)}. First subscription delivery ${formatMoney(firstOrderPence)}. Then ${formatMoney(subPence)} per delivery.">
            <span class="bc-custom-bundle-mvp__savings-price-main"><s>${formatMoney(onePence)}</s><strong>${formatMoney(firstOrderPence)}</strong></span>
            <span class="bc-custom-bundle-mvp__savings-price-next">Then ${formatMoney(subPence)} per delivery</span>
          </span>
        </div>
      `;
    }
    return `
      <div class="bc-custom-bundle-mvp__savings-row">
        <span class="bc-custom-bundle-mvp__savings-label">Subscribe &amp; <span class="bc-custom-bundle-mvp__savings-pill">Save 10%</span></span>
        <span class="bc-custom-bundle-mvp__savings-prices"><s>${formatMoney(onePence)}</s><strong>${formatMoney(subPence)}</strong></span>
      </div>
    `;
  }

  function renderDiscountOneTimeNotice(context) {
    if (FIRST_ORDER_OFFER_ENABLED || getActivePurchaseMode() !== 'onetime') return '';
    return `
      <div class="bc-custom-bundle-mvp__discount-notice bc-custom-bundle-mvp__discount-notice--${context}" data-bc-mvp-discount-notice="${context}" role="status" aria-live="polite" aria-atomic="true">
        <span class="bc-custom-bundle-mvp__discount-notice-icon" aria-hidden="true">i</span>
        <span>Discount codes can only be applied to subscribe &amp; save orders</span>
      </div>
    `;
  }

  function renderGiftLossWarning() {
    if (!state.oneTimeGiftWarningOpen) return '';
    const selectedGiftCount = getSelectedRewardGiftCount();
    const giftCopy = selectedGiftCount === 1
      ? 'Your free gift will be removed.'
      : `Your ${selectedGiftCount} free gifts will be removed.`;
    return `
      <section class="bc-custom-bundle-mvp__gift-loss-warning" data-bc-mvp-gift-loss-warning>
        <button type="button" class="bc-custom-bundle-mvp__gift-loss-close" data-bc-mvp-gift-loss-keep aria-label="Close one-time order warning">×</button>
        <span class="bc-custom-bundle-mvp__gift-loss-icon" aria-hidden="true">!</span>
        <span class="bc-custom-bundle-mvp__gift-loss-copy">
          <h2 class="bc-custom-bundle-mvp__gift-loss-title" id="bc-gift-loss-title" data-bc-mvp-gift-loss-heading tabindex="-1">Switch to a one-time order?</h2>
          <span>${giftCopy}</span>
        </span>
        <span class="bc-custom-bundle-mvp__gift-loss-actions">
          <button type="button" class="bc-custom-bundle-mvp__gift-loss-keep" data-bc-mvp-gift-loss-keep>Keep Subscribe &amp; Save</button>
          <button type="button" class="bc-custom-bundle-mvp__gift-loss-continue" data-bc-mvp-gift-loss-continue>Continue with one-time</button>
        </span>
      </section>
    `;
  }

  function renderDesktopSelectedItems(selections, count) {
    const body = count
      ? `<div class="bc-custom-bundle-mvp__cart-list">${renderSelectedCartRows(selections)}</div>`
      : '<p class="bc-custom-bundle-mvp__empty">Choose items to start your bundle.</p>';
    return `
      <div class="bc-custom-bundle-mvp__desktop-items" aria-label="Your selected bundle items">
        <div class="bc-custom-bundle-mvp__desktop-items-title">
          <h2>Your Bundle</h2>
          <span class="bc-custom-bundle-mvp__desktop-items-actions">
            <span class="bc-custom-bundle-mvp__desktop-items-count">${count} item${count === 1 ? '' : 's'}</span>
            ${count ? '<button type="button" class="bc-custom-bundle-mvp__cart-clear bc-custom-bundle-mvp__cart-clear--desktop" data-bc-mvp-cart-clear>Clear all</button>' : ''}
          </span>
        </div>
        ${body}
        ${count ? renderSubscriptionSavingsRow() : ''}
      </div>
    `;
  }

  function renderDesktopSubscriptionBenefits() {
    const benefits = isSubscriptionOnlyBundle()
      ? ['Free gifts with qualifying subscription bundles', 'Pause, skip or cancel anytime']
      : FIRST_ORDER_OFFER_ENABLED
        ? ['10% off every order', 'Up to 3 free gifts in your first delivery', 'Pause, skip or cancel anytime']
        : ['10% off every order', 'Free gifts with qualifying subscription bundles', 'Pause, skip or cancel anytime'];
    return `
      <ul class="bc-custom-bundle-mvp__desktop-benefits" aria-label="Subscription benefits">
        ${benefits.map((item) => `<li>${escapeHtml(item)}</li>`).join('')}
      </ul>
    `;
  }

  function renderDesktopPlanControls() {
    const isSub = getActivePurchaseMode() === 'subscription';
    const frequencySelect = isSub && frequencyOptions.length
      ? `
        <label class="bc-custom-bundle-mvp__desktop-frequency">
          <span>Delivery frequency</span>
          <select data-bc-mvp-desktop-frequency aria-label="Delivery frequency">
            ${frequencyOptions.map((item, index) => `
              <option value="${index}" ${index === state.frequencyIndex ? 'selected' : ''}>${escapeHtml(item.label)}</option>
            `).join('')}
          </select>
        </label>
      `
      : '';
    if (isSubscriptionOnlyBundle()) {
      return `
        <div class="bc-custom-bundle-mvp__desktop-plan is-subscription-only" aria-label="Subscription options">
          <div class="bc-custom-bundle-mvp__desktop-plan-options">
            <div class="bc-custom-bundle-mvp__desktop-subscription is-active">
              <div class="bc-custom-bundle-mvp__desktop-plan-option is-active" aria-label="Subscribe and save">
                <span class="bc-custom-bundle-mvp__desktop-plan-radio" aria-hidden="true"></span>
                <span>Subscribe &amp; Save</span>
              </div>
              ${renderDesktopSubscriptionBenefits()}
              ${frequencySelect}
            </div>
          </div>
        </div>
      `;
    }
    return `
      <div class="bc-custom-bundle-mvp__desktop-plan" aria-label="Purchase options">
        <div class="bc-custom-bundle-mvp__desktop-plan-options">
          <div class="bc-custom-bundle-mvp__desktop-subscription ${isSub ? 'is-active' : 'is-expanded'}">
            ${renderWelcomeOfferMessage()}
            <button type="button" class="bc-custom-bundle-mvp__desktop-plan-option ${isSub ? 'is-active' : ''}" data-bc-mvp-desktop-plan="subscription" aria-pressed="${isSub ? 'true' : 'false'}">
              <span class="bc-custom-bundle-mvp__desktop-plan-radio" aria-hidden="true"></span>
              <span class="bc-custom-bundle-mvp__desktop-plan-label">Subscribe &amp; Save 10%</span>
            </button>
            ${renderDesktopSubscriptionBenefits()}
            ${frequencySelect}
          </div>
          <button type="button" class="bc-custom-bundle-mvp__desktop-plan-option bc-custom-bundle-mvp__desktop-plan-option--onetime ${isSub ? '' : 'is-active'}" data-bc-mvp-desktop-plan="onetime" aria-pressed="${isSub ? 'false' : 'true'}">
            <span class="bc-custom-bundle-mvp__desktop-plan-radio" aria-hidden="true"></span>
            <span class="bc-custom-bundle-mvp__desktop-plan-copy">
              <span>One-time purchase</span>
              <span class="bc-custom-bundle-mvp__desktop-plan-sub">${formatMoney(getModeSubtotalPence('onetime'))} · Gifts not included</span>
            </span>
          </button>
          ${renderDiscountOneTimeNotice('desktop')}
        </div>
      </div>
    `;
  }

  function renderSummary() {
    const count = getItemCount();
    const selections = readSelections();
    const subtotal = getSubtotalPence();
    const hasItems = count > 0;
    const displayedCtaPrice = FIRST_ORDER_OFFER_ENABLED && getActivePurchaseMode() === 'subscription'
      ? getFirstOrderOfferPence()
      : subtotal;
    const desktopCtaLabel = !hasItems
      ? 'Add items to start your box'
      : `Add to cart  ·  ${formatMoney(displayedCtaPrice)}`;
    const mobileCtaLabel = hasItems ? 'Continue' : 'Choose items to continue';
    return `
      <aside class="bc-custom-bundle-mvp__summary" data-bc-mvp-summary>
        <section class="bc-custom-bundle-mvp__summary-panel ${hasItems ? 'has-selections' : 'is-empty'}">
          ${renderMeter()}
          ${renderDesktopPlanControls()}
          <button type="button" class="bc-custom-bundle-mvp__cta" data-bc-mvp-add ${hasItems ? '' : 'disabled'}>
            <span class="bc-custom-bundle-mvp__cta-label--desktop">${desktopCtaLabel}</span>
            <span class="bc-custom-bundle-mvp__cta-label--mobile">${mobileCtaLabel}</span>
          </button>
          ${renderDesktopSelectedItems(selections, count)}
          <div class="bc-custom-bundle-mvp__status" data-bc-mvp-status="${escapeHtml(state.statusKind)}" aria-live="polite">${escapeHtml(state.statusMessage)}</div>
        </section>
      </aside>
    `;
  }

  function renderSheet() {
    if (!state.sheetOpen) return '';
    const subPence = getModeSubtotalPence('subscription');
    const onePence = getModeSubtotalPence('onetime');
    const isSub = getActivePurchaseMode() === 'subscription';
    const freqChips = frequencyOptions.map((item, index) => {
      const accessibleLabel = normalizeFrequencyLabel(item.label);
      return `
            <button type="button" class="bc-custom-bundle-mvp__sheet-chip ${index === state.frequencyIndex ? 'on' : ''}" data-bc-mvp-sheet-freq="${index}" aria-label="${escapeHtml(accessibleLabel)}" aria-pressed="${index === state.frequencyIndex ? 'true' : 'false'}">
              <span class="bc-custom-bundle-mvp__sheet-chip-label">${escapeHtml(getSheetFrequencyLabel(item.label))}</span>
            </button>
          `;
    }).join('');
    if (isSubscriptionOnlyBundle()) {
      return `
        <div class="bc-custom-bundle-mvp__sheet bc-custom-bundle-mvp__sheet--plan bc-custom-bundle-mvp__sheet--frequency-only">
          <div class="bc-custom-bundle-mvp__sheet-scrim" data-bc-mvp-sheet-close></div>
          <div class="bc-custom-bundle-mvp__sheet-card" role="dialog" aria-modal="true" aria-label="Choose your delivery frequency">
            <button type="button" class="bc-custom-bundle-mvp__sheet-close" data-bc-mvp-sheet-close aria-label="Close">×</button>
            <h2 class="bc-custom-bundle-mvp__sheet-title">Delivery every</h2>
            ${frequencyOptions.length ? `<div class="bc-custom-bundle-mvp__sheet-freq bc-custom-bundle-mvp__sheet-freq--primary"><div class="bc-custom-bundle-mvp__sheet-freq-row bc-custom-bundle-mvp__sheet-freq-row--frequency-only">${freqChips}</div></div>` : ''}
            <button type="button" class="bc-custom-bundle-mvp__sheet-confirm" data-bc-mvp-sheet-confirm>Add to cart</button>
            <p class="bc-custom-bundle-mvp__sheet-reassure">Pause or cancel anytime</p>
          </div>
        </div>
      `;
    }
    if (state.oneTimeGiftWarningOpen) {
      return `
        <div class="bc-custom-bundle-mvp__sheet bc-custom-bundle-mvp__sheet--plan bc-custom-bundle-mvp__sheet--gift-loss">
          <div class="bc-custom-bundle-mvp__sheet-scrim" data-bc-mvp-sheet-close></div>
          <div class="bc-custom-bundle-mvp__gift-loss-stack" role="dialog" aria-modal="true" aria-labelledby="bc-gift-loss-title">
            ${renderGiftLossWarning()}
            <div class="bc-custom-bundle-mvp__sheet-card bc-custom-bundle-mvp__gift-loss-context" aria-hidden="true" inert>
              <h2 class="bc-custom-bundle-mvp__sheet-title">Choose how you'd like it</h2>
              <div class="bc-custom-bundle-mvp__sheet-opt ${isSub ? 'sel' : ''}">
                ${renderWelcomeOfferMessage()}
                <span class="bc-custom-bundle-mvp__sheet-radio" aria-hidden="true"></span>
                <span class="bc-custom-bundle-mvp__sheet-opt-body">
                  <span class="bc-custom-bundle-mvp__sheet-opt-head"><span class="bc-custom-bundle-mvp__sheet-plan-title">Subscribe &amp; ${FIRST_ORDER_OFFER_ENABLED ? 'Save 10%' : 'save'}</span>${renderMobileSubscriptionPrice(onePence, subPence)}</span>
                  ${renderMobileSubscriptionBenefits()}
                  ${isSub && frequencyOptions.length ? `<div class="bc-custom-bundle-mvp__sheet-freq"><span class="bc-custom-bundle-mvp__sheet-freq-label">Delivery every</span><div class="bc-custom-bundle-mvp__sheet-freq-row">${freqChips}</div></div>` : ''}
                </span>
              </div>
              <div class="bc-custom-bundle-mvp__sheet-opt ${isSub ? '' : 'sel'}">
                <span class="bc-custom-bundle-mvp__sheet-radio" aria-hidden="true"></span>
                <span class="bc-custom-bundle-mvp__sheet-opt-body">
                  <span class="bc-custom-bundle-mvp__sheet-opt-head"><span>One-time order</span><span>${formatMoney(onePence)}</span></span>
                  <span class="bc-custom-bundle-mvp__sheet-opt-sub">Full price · Gifts not included</span>
                </span>
              </div>
              <button type="button" class="bc-custom-bundle-mvp__sheet-confirm" disabled>Add to cart</button>
            </div>
          </div>
        </div>
      `;
    }
    return `
      <div class="bc-custom-bundle-mvp__sheet bc-custom-bundle-mvp__sheet--plan">
        <div class="bc-custom-bundle-mvp__sheet-scrim" data-bc-mvp-sheet-close></div>
        <div class="bc-custom-bundle-mvp__sheet-card" role="dialog" aria-modal="true" aria-label="Choose your plan">
          <button type="button" class="bc-custom-bundle-mvp__sheet-close" data-bc-mvp-sheet-close aria-label="Close">×</button>
          <h2 class="bc-custom-bundle-mvp__sheet-title">Choose how you'd like it</h2>
          <div class="bc-custom-bundle-mvp__sheet-options" role="radiogroup" aria-label="Purchase options">
          <div class="bc-custom-bundle-mvp__sheet-opt ${isSub ? 'sel' : ''}" role="radio" aria-checked="${isSub ? 'true' : 'false'}" tabindex="0" data-bc-mvp-sheet-plan="subscription">
            ${renderWelcomeOfferMessage()}
            <span class="bc-custom-bundle-mvp__sheet-radio" aria-hidden="true"></span>
            <span class="bc-custom-bundle-mvp__sheet-opt-body">
              <span class="bc-custom-bundle-mvp__sheet-opt-head"><span class="bc-custom-bundle-mvp__sheet-plan-title">Subscribe &amp; ${FIRST_ORDER_OFFER_ENABLED ? 'Save 10%' : 'save'}</span>${renderMobileSubscriptionPrice(onePence, subPence)}</span>
              ${renderMobileSubscriptionBenefits()}
              ${isSub && frequencyOptions.length ? `<div class="bc-custom-bundle-mvp__sheet-freq"><span class="bc-custom-bundle-mvp__sheet-freq-label">Delivery every</span><div class="bc-custom-bundle-mvp__sheet-freq-row">${freqChips}</div></div>` : ''}
            </span>
          </div>
          <div class="bc-custom-bundle-mvp__sheet-opt ${isSub ? '' : 'sel'}" role="radio" aria-checked="${isSub ? 'false' : 'true'}" tabindex="0" data-bc-mvp-sheet-plan="onetime">
            <span class="bc-custom-bundle-mvp__sheet-radio" aria-hidden="true"></span>
            <span class="bc-custom-bundle-mvp__sheet-opt-body">
              <span class="bc-custom-bundle-mvp__sheet-opt-head"><span>One-time order</span><span>${formatMoney(onePence)}</span></span>
              <span class="bc-custom-bundle-mvp__sheet-opt-sub">Full price · Gifts not included</span>
            </span>
          </div>
          </div>
          ${renderDiscountOneTimeNotice('sheet')}
          <button type="button" class="bc-custom-bundle-mvp__sheet-confirm" data-bc-mvp-sheet-confirm>${isSub ? `Add subscription · ${formatMoney(getFirstOrderOfferPence() || subPence)}` : `Add one-time · ${formatMoney(onePence)}`}</button>
        </div>
      </div>
    `;
  }

  function renderRewardsInfo() {
    if (!state.rewardsInfoOpen) return '';
    const ratesNote = FIRST_ORDER_OFFER_ENABLED
      ? 'Rewards use your subscription box value before the welcome discount.'
      : isSubscriptionOnlyBundle()
      ? 'Rewards apply to your bundle as you build.'
      : 'Gifts are free with a subscription.';
    const finalReward = getFinalRewardPresentation();
    const renderRewardRow = (reward) => {
      const imageMarkup = reward.image
        ? `<img class="bc-custom-bundle-mvp__reward-row-img" src="${escapeHtml(reward.image)}" alt="">`
        : '<span class="bc-custom-bundle-mvp__reward-row-img bc-custom-bundle-mvp__reward-row-img--mystery" aria-hidden="true">?</span>';
      return `
        <div class="bc-custom-bundle-mvp__reward-row">
          ${imageMarkup}
          <span class="bc-custom-bundle-mvp__reward-row-body">
            <span class="bc-custom-bundle-mvp__reward-row-title">${escapeHtml(reward.detailName || reward.name)} <span><s>${escapeHtml(reward.price)}</s> FREE</span></span>
            <span class="bc-custom-bundle-mvp__reward-row-sub">${escapeHtml(reward.description)}</span>
          </span>
        </div>`;
    };
    const finalRewardMarkup = renderRewardRow(finalReward);
    const choiceRewardsMarkup = REWARD_PREVIEW_CONCEPT === 'choice'
      ? [
        {
          detailName: 'Choose Your First Gift',
          price: 'Up to £7.20',
          description: 'Choose from three gifts when your subscription bundle reaches £30.',
        },
        {
          detailName: 'Choose Another Gift',
          price: 'Up to £7.20',
          description: 'Choose a second gift when your subscription bundle reaches £40.',
        },
        {
          detailName: 'Choose A Third Gift',
          price: 'Up to £7.20',
          description: 'Choose a third gift when your subscription bundle reaches £50.',
        },
      ].map(renderRewardRow).join('')
      : '';
    return `
      <div class="bc-custom-bundle-mvp__sheet">
        <div class="bc-custom-bundle-mvp__sheet-scrim" data-bc-mvp-rewards-close></div>
        <div class="bc-custom-bundle-mvp__sheet-card" role="dialog" aria-modal="true" aria-label="Your rewards">
          <button type="button" class="bc-custom-bundle-mvp__sheet-close" data-bc-mvp-rewards-close aria-label="Close">×</button>
          <h2 class="bc-custom-bundle-mvp__sheet-title">Your rewards</h2>
          ${choiceRewardsMarkup || finalRewardMarkup}
          <p class="bc-custom-bundle-mvp__rates-title">Delivery rates by order value</p>
          <ul class="bc-custom-bundle-mvp__rates">
            <li><span>£25+</span><strong>£0.99</strong></li>
            <li><span>£15–£25</span><strong>£2.49</strong></li>
            <li><span>£0–£15</span><strong>£3.99</strong></li>
          </ul>
          <p class="bc-custom-bundle-mvp__rates-note">${ratesNote}</p>
        </div>
      </div>
    `;
  }

  function renderGiftPicker() {
    if (REWARD_PREVIEW_CONCEPT !== 'choice' || !state.giftPickerOpen) return '';
    const isMultiSlotPicker = state.giftPickerMultiSlot;
    const selectedChoiceCount = state.giftPickerDraftChoices.length;
    const eligibleSlots = getEligibleRewardChoiceSlots();
    const requiredChoiceCount = eligibleSlots.length;
    const nextMissingSlot = eligibleSlots.find((slot) => (
      slot !== state.giftPickerSlot && !state.rewardPreviewChoices[slot]
    ));
    const confirmReady = isMultiSlotPicker ? selectedChoiceCount === requiredChoiceCount : Boolean(state.giftPickerDraftChoice);
    const confirmLabel = isMultiSlotPicker
      ? (selectedChoiceCount < requiredChoiceCount
        ? selectedChoiceCount === 0
          ? `Choose ${requiredChoiceCount === 3 ? 'three' : 'two'} gifts to continue`
          : `Choose ${requiredChoiceCount - selectedChoiceCount === 1 ? 'one' : 'two'} more gift${requiredChoiceCount - selectedChoiceCount === 1 ? '' : 's'}`
        : state.giftPickerTriggeredByAdd ? (isMobileViewport() ? 'Continue' : 'Continue to cart') : 'Save gifts')
      : state.giftPickerTriggeredByAdd
        ? (nextMissingSlot ? 'Choose next gift' : isMobileViewport() ? 'Continue' : 'Continue to cart')
        : 'Save gift';
    const pickerTitle = isMultiSlotPicker
      ? `Choose your ${requiredChoiceCount === 3 ? 'three' : 'two'} free gifts`
      : 'Choose your free gift';
    const skipLabel = isMultiSlotPicker ? 'No thanks, skip free gifts' : 'No thanks, skip this gift';
    const optionMarkup = REWARD_PREVIEW_CHOICES.map((choice) => {
      const selected = isMultiSlotPicker
        ? state.giftPickerDraftChoices.includes(choice.id)
        : state.giftPickerDraftChoice === choice.id;
      const unavailable = isMultiSlotPicker
        ? selectedChoiceCount >= requiredChoiceCount && !selected
        : isRewardChoiceUsedInOtherSlot(choice.id, state.giftPickerSlot);
      return `
        <div class="bc-custom-bundle-mvp__gift-picker-option-wrap${selected ? ' is-selected' : ''}">
          <button type="button" class="bc-custom-bundle-mvp__gift-picker-option${selected ? ' is-selected' : ''}" data-bc-mvp-gift-picker-choice="${escapeHtml(choice.id)}" role="${isMultiSlotPicker ? 'checkbox' : 'radio'}" aria-checked="${selected}" ${unavailable ? 'disabled aria-disabled="true"' : ''}>
            <img class="bc-custom-bundle-mvp__gift-picker-image" src="${escapeHtml(choice.image)}" alt="">
            <span class="bc-custom-bundle-mvp__gift-picker-body">
              <span class="bc-custom-bundle-mvp__gift-picker-name">${escapeHtml(choice.name)}</span>
              <span class="bc-custom-bundle-mvp__gift-picker-price"><s>${escapeHtml(choice.price)}</s> FREE</span>
            </span>
            <span class="bc-custom-bundle-mvp__gift-picker-radio" aria-hidden="true"></span>
          </button>
          <details class="bc-custom-bundle-mvp__gift-picker-details">
            <summary aria-label="More about ${escapeHtml(choice.name)}">i</summary>
            <p class="bc-custom-bundle-mvp__gift-picker-description">${escapeHtml(choice.description)}</p>
          </details>
        </div>`;
    }).join('');
    return `
      <div class="bc-custom-bundle-mvp__sheet">
        <div class="bc-custom-bundle-mvp__sheet-scrim" data-bc-mvp-gift-picker-close></div>
        <div class="bc-custom-bundle-mvp__sheet-card bc-custom-bundle-mvp__gift-picker-card" role="dialog" aria-modal="true" aria-label="${escapeHtml(pickerTitle)}">
          <button type="button" class="bc-custom-bundle-mvp__sheet-close" data-bc-mvp-gift-picker-close aria-label="Close">×</button>
          <h2 class="bc-custom-bundle-mvp__gift-picker-title">${escapeHtml(pickerTitle)}</h2>
          <p class="bc-custom-bundle-mvp__gift-picker-note">Gifts are delivered in your first order only</p>
          <div class="bc-custom-bundle-mvp__gift-picker-options" role="${isMultiSlotPicker ? 'group' : 'radiogroup'}" aria-label="Gift options">
            ${optionMarkup}
          </div>
          <div class="bc-custom-bundle-mvp__gift-picker-footer">
            <button type="button" class="bc-custom-bundle-mvp__sheet-confirm bc-custom-bundle-mvp__gift-picker-confirm" data-bc-mvp-gift-picker-confirm ${confirmReady ? '' : 'disabled'}>${confirmLabel}</button>
            <button type="button" class="bc-custom-bundle-mvp__gift-picker-skip" data-bc-mvp-gift-picker-skip>${skipLabel}</button>
          </div>
        </div>
      </div>
    `;
  }

  function renderCartFabShell() {
    return `
      <button type="button" class="bc-custom-bundle-mvp__cart" data-bc-mvp-cart-toggle data-bc-mvp-has-items="false" data-bc-mvp-cart-ready="false" aria-label="View your bundle" aria-haspopup="dialog" aria-expanded="false" aria-controls="bc-mvp-cart-sheet" aria-hidden="true" tabindex="-1" disabled>
        <span class="bc-custom-bundle-mvp__cart-label">Your Bundle</span>
        <span class="bc-custom-bundle-mvp__cart-chevron" aria-hidden="true"></span>
        <span class="bc-custom-bundle-mvp__cart-count" aria-hidden="true">0</span>
      </button>
    `;
  }

  function syncCartFab(panel) {
    const button = panel.querySelector('[data-bc-mvp-cart-toggle]');
    if (!(button instanceof HTMLButtonElement)) return;

    const count = getItemCount();
    const hasItems = count > 0;
    const isAvailable = hasItems && initialBuilderHydrationComplete && (!IS_EMBEDDED || panel.classList.contains('is-mobile-cart-docked'));
    button.dataset.bcMvpHasItems = hasItems ? 'true' : 'false';
    button.dataset.bcMvpCartReady = isAvailable ? 'true' : 'false';
    button.disabled = !isAvailable;
    button.tabIndex = isAvailable ? 0 : -1;
    button.setAttribute('aria-hidden', isAvailable ? 'false' : 'true');
    button.setAttribute('aria-label', count
      ? `View your bundle, ${count} item${count === 1 ? '' : 's'}`
      : 'View your bundle');
    button.setAttribute('aria-expanded', String(Boolean(state.cartOpen && count)));

    const countNode = button.querySelector('.bc-custom-bundle-mvp__cart-count');
    if (countNode) countNode.textContent = String(count);
  }

  function completeInitialBuilderHydration(panel) {
    if (!IS_EMBEDDED || initialBuilderHydrationComplete || !(panel instanceof HTMLElement)) return;
    initialBuilderHydrationComplete = true;
    EMBED_MOUNT.setAttribute('aria-busy', 'false');
    syncEmbeddedMobileSurface(panel);
    requestCartFabTopSync(panel);
  }

  function renderCartSheet() {
    if (!state.cartOpen) return '';
    const selections = readSelections();
    const subtotal = getSubtotalPence();
    const subscriptionSavings = renderSubscriptionSavingsRow();
    const priceSummary = getActivePurchaseMode() === 'subscription' && subscriptionSavings
      ? subscriptionSavings
      : `<div class="bc-custom-bundle-mvp__cart-total"><span>Subtotal</span><strong>${formatMoney(subtotal)}</strong></div>`;
    return `
      <div class="bc-custom-bundle-mvp__sheet" id="bc-mvp-cart-sheet">
        <div class="bc-custom-bundle-mvp__sheet-scrim" data-bc-mvp-cart-close></div>
        <div class="bc-custom-bundle-mvp__sheet-card" role="dialog" aria-modal="true" aria-label="Your Bundle">
          <button type="button" class="bc-custom-bundle-mvp__sheet-close" data-bc-mvp-cart-close aria-label="Close">×</button>
          <div class="bc-custom-bundle-mvp__cart-sheet-header">
            <h2 class="bc-custom-bundle-mvp__sheet-title">Your Bundle</h2>
            ${selections.length ? '<button type="button" class="bc-custom-bundle-mvp__cart-clear" data-bc-mvp-cart-clear>Clear all</button>' : ''}
          </div>
          ${selections.length
            ? `<div class="bc-custom-bundle-mvp__cart-list">${renderSelectedCartRows(selections)}</div>${priceSummary}`
            : '<p class="bc-custom-bundle-mvp__cart-empty">Your bundle is empty.</p>'}
        </div>
      </div>
    `;
  }

  function clearBuilderSelection(panel) {
    const previousItemCount = getItemCount();
    const previousSubtotalPence = getSubtotalPence();
    state.quantities = PRODUCTS.map(() => 0);
    state.variantIndexes = PRODUCTS.map(() => 0);
    REWARD_CHOICE_SLOTS.forEach((slot) => {
      state.rewardPreviewChoices[slot] = '';
    });
    state.giftPickerDraftChoice = '';
    state.giftPickerDraftChoices = [];
    state.giftPickerMultiSlot = false;
    state.giftPickerSlot = 0;
    state.giftPickerOpen = false;
    state.giftPickerTriggeredByAdd = false;
    state.giftPickerContinueTarget = '';
    state.oneTimeGiftWarningOpen = false;
    state.sheetOpen = false;
    state.cartOpen = true;
    state.cartEmptyStateOpen = true;
    state.statusMessage = '';
    state.statusKind = 'info';
    customBundleDraftUserInteracted = true;
    customBundleDraftRestoreCompleted = true;
    clearCustomBundleDraft();
    renderState(panel);
    window.requestAnimationFrame(() => {
      panel.querySelector('.bc-custom-bundle-mvp__sheet-close')?.focus();
    });
    publishBundleFunnelEvent('bc_bundle_cleared', {
      item_count: previousItemCount,
      subtotal_pence: previousSubtotalPence,
      purchase_mode: getActivePurchaseMode(),
    });
  }

  function clearCardRowSizing(panel) {
    panel.querySelectorAll('.bc-custom-bundle-mvp__card').forEach((card) => {
      card.style.removeProperty('--bc-mvp-title-row-height');
      card.style.removeProperty('--bc-mvp-variant-row-height');
      card.style.removeProperty('--bc-mvp-variant-row-gap');
    });
  }

  function syncCardRows(panel) {
    if (!(panel instanceof HTMLElement)) return;

    clearCardRowSizing(panel);

    const cards = Array.from(panel.querySelectorAll('.bc-custom-bundle-mvp__card'));
    if (!cards.length) return;

    const shouldAlignTitleRows = window.innerWidth <= MOBILE_CARD_ALIGNMENT_MAX_WIDTH;
    const variantGap = shouldAlignTitleRows ? 5 : 10;
    const rows = [];
    cards.forEach((card) => {
      const rect = card.getBoundingClientRect();
      if (!rect.width || !rect.height) return;

      let row = rows.find((candidate) => Math.abs(candidate.top - rect.top) <= 4);
      if (!row) {
        row = {
          top: rect.top,
          cards: [],
          titleHeight: 0,
          variantHeight: 0,
        };
        rows.push(row);
      }

      const title = card.querySelector('h2');
      const variantWrap = card.querySelector('.bc-custom-bundle-mvp__variant-wrap');
      const titleRect = shouldAlignTitleRows && title ? title.getBoundingClientRect() : null;
      const variantRect = variantWrap && !variantWrap.classList.contains('is-empty')
        ? variantWrap.getBoundingClientRect()
        : null;

      row.cards.push(card);
      row.titleHeight = Math.max(row.titleHeight, titleRect ? Math.ceil(titleRect.height) : 0);
      row.variantHeight = Math.max(row.variantHeight, variantRect ? Math.ceil(variantRect.height) : 0);
    });

    rows.forEach((row) => {
      const titleHeight = Math.max(0, row.titleHeight);
      const variantHeight = Math.max(0, row.variantHeight);
      const rowVariantGap = variantHeight > 0 ? variantGap : 0;

      row.cards.forEach((card) => {
        card.style.setProperty('--bc-mvp-title-row-height', `${titleHeight}px`);
        card.style.setProperty('--bc-mvp-variant-row-height', `${variantHeight}px`);
        card.style.setProperty('--bc-mvp-variant-row-gap', `${rowVariantGap}px`);
      });
    });
  }

  function requestCardRowSync(panel) {
    if (cardRowSyncFrame) {
      window.cancelAnimationFrame(cardRowSyncFrame);
    }

    cardRowSyncFrame = window.requestAnimationFrame(() => {
      cardRowSyncFrame = 0;
      syncCardRows(panel);
    });
  }

  function updatePanelMeta(panel) {
    const activeMode = getActivePurchaseMode();
    panel.dataset.bcMvpPurchaseMode = activeMode;
    panel.dataset.bcMvpPurchaseModel = BUNDLE_PRODUCT.purchaseModel;
    panel.dataset.bcMvpSelectedCount = String(getItemCount());
    panel.dataset.bcMvpSubtotalPence = String(getSubtotalPence());
    panel.dataset.bcMvpProductCount = String(PRODUCTS.length);
    panel.dataset.bcMvpCatalogStatus = state.catalogStatus;
    if (FIRST_ORDER_OFFER_ENABLED) {
      panel.dataset.bcMvpFirstOrderOffer = 'true';
      panel.dataset.bcMvpOneTimePence = String(getModeSubtotalPence('onetime'));
      panel.dataset.bcMvpOngoingSubscriptionPence = String(getModeSubtotalPence('subscription'));
      panel.dataset.bcMvpFirstOrderPence = String(getFirstOrderOfferPence());
    } else {
      delete panel.dataset.bcMvpFirstOrderOffer;
      delete panel.dataset.bcMvpOneTimePence;
      delete panel.dataset.bcMvpOngoingSubscriptionPence;
      delete panel.dataset.bcMvpFirstOrderPence;
    }
    delete panel.dataset.bcMvpFrequency;
    panel.dataset.bcMvpFrequencyId = activeMode === 'subscription' ? String(getFrequencyOption().sellingPlanId) : 'one-time';
  }

  function updatePurchaseMode(panel, mode, { fromSheet = false, confirmGiftLoss = false } = {}) {
    if (isSubscriptionOnlyBundle()) {
      if (state.purchaseMode !== 'subscription') {
        state.purchaseMode = 'subscription';
        renderState(panel);
      }
      return;
    }
    const nextMode = mode === 'onetime' ? 'onetime' : 'subscription';
    const returningToSubscriptionAfterGiftLoss = Boolean(
      nextMode === 'subscription' &&
      state.purchaseMode === 'onetime' &&
      state.giftPickerRequiredOnSubscriptionReturn
    );
    const shouldReopenGiftPicker = Boolean(
      returningToSubscriptionAfterGiftLoss &&
      fromSheet &&
      isMobileViewport()
    );
    if (
      fromSheet &&
      isMobileViewport() &&
      nextMode === 'onetime' &&
      state.purchaseMode === 'subscription' &&
      hasSelectedRewardGift() &&
      !confirmGiftLoss
    ) {
      state.oneTimeGiftWarningOpen = true;
      renderState(panel, { productGrid: 'skip' });
      focusGiftLossWarning(panel);
      return;
    }
    if (
      confirmGiftLoss &&
      nextMode === 'onetime' &&
      state.purchaseMode === 'subscription' &&
      hasSelectedRewardGift()
    ) {
      state.giftPickerRequiredOnSubscriptionReturn = true;
    }
    if (state.purchaseMode === nextMode) {
      if (state.oneTimeGiftWarningOpen) {
        state.oneTimeGiftWarningOpen = false;
        renderState(panel, { productGrid: 'skip' });
      }
      return;
    }

    state.oneTimeGiftWarningOpen = false;
    state.purchaseMode = nextMode;
    const removed = removeUnavailableSubscriptionSelections();
    renderState(panel, { productGrid: 'defer' });

    if (removed.length) {
      setStatus(
        panel,
        `${formatProductList(removed)} ${removed.length === 1 ? 'is' : 'are'} one-time only, so ${removed.length === 1 ? 'it was' : 'they were'} removed.`,
        'info'
      );
    }
    rememberCustomBundleDraftInteraction('purchase-mode');

    if (returningToSubscriptionAfterGiftLoss) {
      state.giftPickerRequiredOnSubscriptionReturn = false;
    }
    if (shouldReopenGiftPicker) {
      const missingRewardSlot = shouldPromptForRewardChoice();
      if (missingRewardSlot) {
        openGiftPicker(panel, missingRewardSlot, true, 'plan');
      }
    }
  }

  function getElementFromMarkup(markup) {
    const template = document.createElement('template');
    template.innerHTML = String(markup || '').trim();
    return template.content.firstElementChild;
  }

  function bindGiftPickerKeyboardControls(panel, root) {
    const dialog = root.matches?.('.bc-custom-bundle-mvp__gift-picker-card[role="dialog"]')
      ? root
      : root.querySelector?.('.bc-custom-bundle-mvp__gift-picker-card[role="dialog"]');

    if (!dialog || dialog.dataset.bcGiftPickerKeyboardBound === 'true') return;
    dialog.dataset.bcGiftPickerKeyboardBound = 'true';
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        closeGiftPicker(panel);
        return;
      }

      if (event.key !== 'Tab') return;

      const focusable = Array.from(dialog.querySelectorAll('button:not(:disabled), [href], input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex]:not([tabindex="-1"])'))
        .filter((element) => element.getClientRects().length > 0);

      if (!focusable.length) {
        event.preventDefault();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function bindGiftLossKeyboardControls(panel, root) {
    const dialog = root.matches?.('.bc-custom-bundle-mvp__gift-loss-stack[role="dialog"]')
      ? root
      : root.querySelector?.('.bc-custom-bundle-mvp__gift-loss-stack[role="dialog"]');
    if (!dialog || dialog.dataset.bcGiftLossKeyboardBound === 'true') return;
    dialog.dataset.bcGiftLossKeyboardBound = 'true';
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        state.oneTimeGiftWarningOpen = false;
        renderState(panel);
        focusOneTimePlanOption(panel);
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = Array.from(dialog.querySelectorAll('button:not(:disabled)'))
        .filter((element) => element.getClientRects().length > 0);
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first?.focus();
      }
    });
  }

  function bindSelectionRefreshControls(panel, root) {
    if (!(root instanceof Element)) return;

    bindGiftPickerKeyboardControls(panel, root);
    bindGiftLossKeyboardControls(panel, root);

    root.querySelectorAll('[data-bc-mvp-plus]').forEach((button) => {
      if (boundProductSelectionControls.has(button)) return;
      boundProductSelectionControls.add(button);
      button.addEventListener('click', () => {
        const index = Number(button.getAttribute('data-bc-mvp-plus'));
        state.quantities[index] = Math.max(0, Number(state.quantities[index]) || 0) + 1;
        renderSelectionState(panel, index);
        rememberCustomBundleDraftInteraction('selection-plus');
        warmBundleCartFlowScript();
      });
    });

    root.querySelectorAll('[data-bc-mvp-minus]').forEach((button) => {
      if (boundProductSelectionControls.has(button)) return;
      boundProductSelectionControls.add(button);
      button.addEventListener('click', () => {
        const index = Number(button.getAttribute('data-bc-mvp-minus'));
        state.quantities[index] = Math.max(0, (Number(state.quantities[index]) || 0) - 1);
        renderSelectionState(panel, index);
        rememberCustomBundleDraftInteraction('selection-minus');
        warmBundleCartFlowScript();
      });
    });

    root.querySelectorAll('[data-bc-mvp-variant]').forEach((select) => {
      if (boundProductSelectionControls.has(select)) return;
      boundProductSelectionControls.add(select);
      select.addEventListener('change', () => {
        const index = Number(select.getAttribute('data-bc-mvp-variant'));
        state.variantIndexes[index] = Math.max(0, Number(select.value) || 0);
        renderSelectionState(panel, index);
        rememberCustomBundleDraftInteraction('variant');
        warmBundleCartFlowScript();
      });
    });

    root.querySelectorAll('[data-bc-mvp-add]').forEach((button) => {
      button.addEventListener('click', () => {
        if (isMobileViewport()) {
          if (promptForRewardChoiceBeforeAdd(panel, 'plan')) return;
          state.oneTimeGiftWarningOpen = false;
          state.sheetOpen = true;
          renderState(panel);
          return;
        }

        if (promptForRewardChoiceBeforeAdd(panel, 'cart')) return;
        addBundleToCart(panel);
      });
    });

    root.querySelectorAll('[data-bc-mvp-product-info]').forEach((button) => {
      if (boundProductSelectionControls.has(button)) return;
      boundProductSelectionControls.add(button);
      button.addEventListener('click', () => {
        const index = Number(button.getAttribute('data-bc-mvp-product-info'));
        const product = PRODUCTS[index];
        if (product) openProductDetails(product, panel);
      });
    });

    root.querySelectorAll('[data-bc-mvp-rewards-info]').forEach((button) => {
      button.addEventListener('click', () => {
        state.rewardsInfoOpen = true;
        renderState(panel);
      });
    });

    root.querySelectorAll('[data-bc-mvp-rewards-close]').forEach((node) => {
      node.addEventListener('click', () => {
        state.rewardsInfoOpen = false;
        renderState(panel);
      });
    });

    root.querySelectorAll('[data-bc-mvp-gift-picker-open]').forEach((button) => {
      button.addEventListener('click', () => {
        openGiftPicker(panel, Number(button.getAttribute('data-bc-mvp-gift-picker-open')), false);
      });
    });

    root.querySelectorAll('[data-bc-mvp-gift-picker-choice]').forEach((button) => {
      button.addEventListener('click', () => {
        const choiceId = String(button.getAttribute('data-bc-mvp-gift-picker-choice') || '');
        if (!REWARD_PREVIEW_CHOICES.some((choice) => choice.id === choiceId)) return;
        if (state.giftPickerMultiSlot) {
          const selectedIndex = state.giftPickerDraftChoices.indexOf(choiceId);
          if (selectedIndex >= 0) {
            state.giftPickerDraftChoices.splice(selectedIndex, 1);
          } else if (state.giftPickerDraftChoices.length < getEligibleRewardChoiceSlots().length) {
            state.giftPickerDraftChoices.push(choiceId);
          }
          renderState(panel);
          return;
        }
        if (isRewardChoiceUsedInOtherSlot(choiceId, state.giftPickerSlot)) return;
        state.giftPickerDraftChoice = choiceId;
        renderState(panel);
      });
    });

    root.querySelectorAll('[data-bc-mvp-gift-picker-close]').forEach((node) => {
      node.addEventListener('click', () => {
        closeGiftPicker(panel);
      });
    });

    root.querySelectorAll('[data-bc-mvp-gift-picker-confirm]').forEach((button) => {
      button.addEventListener('click', () => {
        if (state.giftPickerMultiSlot) {
          const choices = state.giftPickerDraftChoices.filter((choiceId) => (
            REWARD_PREVIEW_CHOICES.some((choice) => choice.id === choiceId)
          ));
          const eligibleSlots = getEligibleRewardChoiceSlots();
          if (choices.length !== eligibleSlots.length || new Set(choices).size !== choices.length) return;
          const shouldContinueToCart = state.giftPickerTriggeredByAdd;
          const continueTarget = state.giftPickerContinueTarget;
          eligibleSlots.forEach((slot, index) => {
            state.rewardPreviewChoices[slot] = choices[index];
          });
          state.giftPickerOpen = false;
          state.giftPickerSlot = 0;
          state.giftPickerDraftChoice = '';
          state.giftPickerDraftChoices = [];
          state.giftPickerMultiSlot = false;
          state.giftPickerTriggeredByAdd = false;
          state.giftPickerContinueTarget = '';
          rememberCustomBundleDraftInteraction('reward-choice-both', { force: true });
          renderState(panel);
          continueAfterGiftPicker(panel, shouldContinueToCart, continueTarget);
          return;
        }
        const choiceId = state.giftPickerDraftChoice;
        if (!REWARD_PREVIEW_CHOICES.some((choice) => choice.id === choiceId)) return;
        if (isRewardChoiceUsedInOtherSlot(choiceId, state.giftPickerSlot)) return;
        const shouldContinueToCart = state.giftPickerTriggeredByAdd;
        const continueTarget = state.giftPickerContinueTarget;
        const confirmedSlot = state.giftPickerSlot;
        state.rewardPreviewChoices[confirmedSlot] = choiceId;
        state.giftPickerOpen = false;
        state.giftPickerSlot = 0;
        state.giftPickerDraftChoices = [];
        state.giftPickerMultiSlot = false;
        state.giftPickerTriggeredByAdd = false;
        state.giftPickerContinueTarget = '';
        rememberCustomBundleDraftInteraction(`reward-choice-${confirmedSlot}`, { force: true });
        renderState(panel);
        if (shouldContinueToCart) {
          const nextMissingSlot = getMissingRewardChoiceSlot();
          if (nextMissingSlot) {
            openGiftPicker(panel, nextMissingSlot, true, continueTarget);
          } else {
            continueAfterGiftPicker(panel, true, continueTarget);
          }
        } else {
          restoreGiftPickerFocus(panel);
        }
      });
    });

    root.querySelectorAll('[data-bc-mvp-gift-picker-skip]').forEach((button) => {
      button.addEventListener('click', () => {
        const shouldContinueToCart = state.giftPickerTriggeredByAdd;
        const continueTarget = state.giftPickerContinueTarget;
        if (state.giftPickerMultiSlot) {
          getEligibleRewardChoiceSlots().forEach((slot) => {
            state.rewardPreviewChoices[slot] = REWARD_PREVIEW_SKIPPED;
          });
        } else if (REWARD_CHOICE_SLOTS.includes(state.giftPickerSlot)) {
          state.rewardPreviewChoices[state.giftPickerSlot] = REWARD_PREVIEW_SKIPPED;
        } else {
          return;
        }
        state.giftPickerOpen = false;
        state.giftPickerSlot = 0;
        state.giftPickerDraftChoice = '';
        state.giftPickerDraftChoices = [];
        state.giftPickerMultiSlot = false;
        state.giftPickerTriggeredByAdd = false;
        state.giftPickerContinueTarget = '';
        rememberCustomBundleDraftInteraction('reward-choice-skipped', { force: true });
        renderState(panel);
        if (shouldContinueToCart) {
          const nextMissingSlot = getMissingRewardChoiceSlot();
          if (nextMissingSlot) {
            openGiftPicker(panel, nextMissingSlot, true, continueTarget);
          } else {
            continueAfterGiftPicker(panel, true, continueTarget);
          }
        } else {
          restoreGiftPickerFocus(panel);
        }
      });
    });

    root.querySelectorAll('[data-bc-mvp-cart-close]').forEach((node) => {
      node.addEventListener('click', () => {
        state.cartOpen = false;
        state.cartEmptyStateOpen = false;
        renderState(panel, { productGrid: 'skip' });
      });
    });

    root.querySelectorAll('[data-bc-mvp-cart-clear]').forEach((button) => {
      button.addEventListener('click', () => {
        clearBuilderSelection(panel);
      });
    });

    root.querySelectorAll('[data-bc-mvp-desktop-plan]').forEach((button) => {
      button.addEventListener('click', () => {
        updatePurchaseMode(panel, button.getAttribute('data-bc-mvp-desktop-plan'));
      });
    });

    root.querySelectorAll('[data-bc-mvp-desktop-frequency]').forEach((select) => {
      select.addEventListener('change', () => {
        state.frequencyIndex = Math.max(0, Number(select.value) || 0);
        renderState(panel);
        rememberCustomBundleDraftInteraction('frequency');
      });
    });

    root.querySelectorAll('[data-bc-mvp-sheet-close]').forEach((node) => {
      node.addEventListener('click', () => {
        if (state.oneTimeGiftWarningOpen) {
          state.oneTimeGiftWarningOpen = false;
          renderState(panel);
          focusOneTimePlanOption(panel);
          return;
        }
        state.oneTimeGiftWarningOpen = false;
        state.sheetOpen = false;
        renderState(panel);
      });
    });

    root.querySelectorAll('[data-bc-mvp-sheet-plan]').forEach((node) => {
      node.addEventListener('click', () => {
        updatePurchaseMode(panel, node.getAttribute('data-bc-mvp-sheet-plan'), { fromSheet: true });
      });
      node.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        updatePurchaseMode(panel, node.getAttribute('data-bc-mvp-sheet-plan'), { fromSheet: true });
      });
    });

    root.querySelectorAll('[data-bc-mvp-gift-loss-keep]').forEach((button) => {
      button.addEventListener('click', () => {
        state.oneTimeGiftWarningOpen = false;
        renderState(panel, { productGrid: 'skip' });
        focusOneTimePlanOption(panel);
      });
    });

    root.querySelectorAll('[data-bc-mvp-gift-loss-continue]').forEach((button) => {
      button.addEventListener('click', () => {
        updatePurchaseMode(panel, 'onetime', { fromSheet: true, confirmGiftLoss: true });
        focusOneTimePlanOption(panel);
      });
    });

    root.querySelectorAll('[data-bc-mvp-sheet-freq]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.stopPropagation();
        state.frequencyIndex = Math.max(0, Number(button.getAttribute('data-bc-mvp-sheet-freq')) || 0);
        renderState(panel);
        rememberCustomBundleDraftInteraction('sheet-frequency');
      });
    });

    root.querySelectorAll('[data-bc-mvp-sheet-confirm]').forEach((button) => {
      button.addEventListener('click', () => {
        state.sheetOpen = false;
        rememberCustomBundleDraftInteraction('sheet-confirm', {
          force: true,
          ttlMs: CUSTOM_BUNDLE_DRAFT_CHECKOUT_TTL_MS,
        });
        const missingRewardSlot = shouldPromptForRewardChoice();
        if (missingRewardSlot) {
          openGiftPicker(panel, missingRewardSlot, true, 'cart');
          return;
        }
        renderState(panel);
        addBundleToCart(panel);
      });
    });
  }

  function replaceProductCard(panel, index) {
    const card = panel.querySelector(`[data-bc-mvp-card="${index}"]`);
    const product = PRODUCTS[index];
    if (!(card instanceof HTMLElement) || !product) return;

    const nextCard = getElementFromMarkup(renderProduct(product, index));
    if (!(nextCard instanceof HTMLElement)) return;

    bindSelectionRefreshControls(panel, nextCard);
    card.className = nextCard.className;
    card.dataset.bcMvpQuantity = nextCard.dataset.bcMvpQuantity || '0';
    [
      ':scope > h2',
      ':scope > .bc-custom-bundle-mvp__price',
      ':scope > .bc-custom-bundle-mvp__variant-wrap',
      ':scope > .bc-custom-bundle-mvp__card-control',
    ].forEach((selector) => replaceProductCardRegion(card, nextCard, selector));
    renderedProductGridMarkup = renderProductSections();
  }

  function replaceProductCardRegion(card, nextCard, selector) {
    const currentRegion = card.querySelector(selector);
    const nextRegion = nextCard.querySelector(selector);
    if (!(currentRegion instanceof HTMLElement) || !(nextRegion instanceof HTMLElement)) return;
    if (currentRegion.outerHTML === nextRegion.outerHTML) return;
    currentRegion.replaceWith(nextRegion);
  }

  function preserveProductCardImageNodes(currentCard, nextCard) {
    if (!(currentCard instanceof HTMLElement) || !(nextCard instanceof HTMLElement)) return;

    ['.bc-custom-bundle-mvp__image-primary', '.bc-custom-bundle-mvp__image-secondary'].forEach((selector) => {
      const currentImage = currentCard.querySelector(selector);
      const nextImage = nextCard.querySelector(selector);
      if (!(currentImage instanceof HTMLImageElement) || !(nextImage instanceof HTMLImageElement)) return;
      if (getProductImageIdentity(currentImage.getAttribute('src')) !== getProductImageIdentity(nextImage.getAttribute('src'))) return;
      nextImage.replaceWith(currentImage);
    });
  }

  function renderProductGrid(grid) {
    if (!(grid instanceof HTMLElement)) return false;

    const hasInitialSkeleton = grid.hasAttribute('data-bc-mvp-skeleton-grid');
    if (hasInitialSkeleton && !PRODUCTS.length && state.catalogStatus !== 'waiting') {
      return false;
    }

    const markup = renderProductSections();
    if (grid.childElementCount && markup === renderedProductGridMarkup) {
      return false;
    }

    const template = document.createElement('template');
    template.innerHTML = markup;
    grid.querySelectorAll('[data-bc-mvp-card]').forEach((card) => {
      const index = card.getAttribute('data-bc-mvp-card');
      const nextCard = index === null ? null : template.content.querySelector(`[data-bc-mvp-card="${index}"]`);
      if (nextCard instanceof HTMLElement) preserveProductCardImageNodes(card, nextCard);
    });
    grid.replaceChildren(template.content);
    grid.removeAttribute('data-bc-mvp-skeleton-grid');
    grid.removeAttribute('aria-hidden');
    renderedProductGridMarkup = markup;
    return true;
  }

  function cancelScheduledProductGridRefresh() {
    if (!productGridRefreshFrame) return;
    window.cancelAnimationFrame(productGridRefreshFrame);
    productGridRefreshFrame = 0;
  }

  function scheduleProductGridRefresh(panel) {
    cancelScheduledProductGridRefresh();
    productGridRefreshFrame = window.requestAnimationFrame(() => {
      productGridRefreshFrame = window.requestAnimationFrame(() => {
        productGridRefreshFrame = 0;
        const grid = panel.querySelector('[data-bc-mvp-grid]');
        if (renderProductGrid(grid)) bindSelectionRefreshControls(panel, grid);
        requestCardRowSync(panel);
      });
    });
  }

  function refreshRenderedRegion(panel, selector, markup) {
    const region = panel.querySelector(selector);
    if (!(region instanceof HTMLElement)) return;

    region.innerHTML = markup;
    bindSelectionRefreshControls(panel, region);
  }

  function renderSelectionState(panel, changedIndex) {
    enforcePurchaseModel();
    clearIneligibleRewardChoiceState();
    updateMobileBottomOffset();

    if (!getItemCount()) {
      state.mobileSummaryOpen = false;
      state.cartOpen = false;
    }

    updatePanelMeta(panel);
    replaceProductCard(panel, changedIndex);
    refreshRenderedRegion(panel, '[data-bc-mvp-summary-wrap]', renderSummary());
    refreshRenderedRegion(panel, '[data-bc-mvp-sheet]', renderSheet());
    refreshRenderedRegion(panel, '[data-bc-mvp-rewards-modal]', renderRewardsInfo());
    refreshRenderedRegion(panel, '[data-bc-mvp-gift-picker]', renderGiftPicker());
    if (IS_EMBEDDED) {
      syncEmbeddedMobileSurface(panel);
    } else {
      syncCartFab(panel);
    }
    refreshRenderedRegion(panel, '[data-bc-mvp-cart-sheet]', renderCartSheet());
    requestCartFabTopSync(panel);
    requestCardRowSync(panel);
    setBusy(panel, state.busy);
  }

  function renderState(panel, { productGrid = 'sync' } = {}) {
    enforcePurchaseModel();
    clearIneligibleRewardChoiceState();
    updateMobileBottomOffset();
    const grid = panel.querySelector('[data-bc-mvp-grid]');
    const nav = panel.querySelector('[data-bc-mvp-category-nav]');
    const summary = panel.querySelector('[data-bc-mvp-summary-wrap]');
    if (!getItemCount()) state.mobileSummaryOpen = false;
    updatePanelMeta(panel);
    if (nav) nav.innerHTML = renderCategoryNav();
    if (productGrid === 'defer') {
      scheduleProductGridRefresh(panel);
    } else if (productGrid !== 'skip') {
      cancelScheduledProductGridRefresh();
      renderProductGrid(grid);
    }
    if (summary) summary.innerHTML = renderSummary();
    const sheet = panel.querySelector('[data-bc-mvp-sheet]');
    if (sheet) sheet.innerHTML = renderSheet();
    const rewardsModal = panel.querySelector('[data-bc-mvp-rewards-modal]');
    if (rewardsModal) rewardsModal.innerHTML = renderRewardsInfo();
    const giftPicker = panel.querySelector('[data-bc-mvp-gift-picker]');
    if (giftPicker) giftPicker.innerHTML = renderGiftPicker();
    if (!getItemCount() && !state.cartEmptyStateOpen) state.cartOpen = false;
    if (IS_EMBEDDED) {
      syncEmbeddedMobileSurface(panel);
    } else {
      syncCartFab(panel);
    }
    const cartSheet = panel.querySelector('[data-bc-mvp-cart-sheet]');
    if (cartSheet) cartSheet.innerHTML = renderCartSheet();
    requestCartFabTopSync(panel);
    if (productGrid !== 'defer') requestCardRowSync(panel);

    bindSelectionRefreshControls(panel, panel);
    panel.querySelectorAll('[data-bc-mvp-scroll-category]').forEach((button) => {
      button.addEventListener('click', () => {
        const id = button.getAttribute('data-bc-mvp-scroll-category');
        const target = id && document.getElementById(id);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
    setBusy(panel, state.busy);
    scheduleGiftPickerFocus(panel);
  }

  function measurePreviewBottomOffset() {
    if (window.innerWidth > 900) return 0;
    const previewFrame = document.getElementById('PBarNextFrame');
    if (!(previewFrame instanceof HTMLIFrameElement)) return 0;

    const x = Math.round(window.innerWidth / 2);
    let intercepted = 0;
    const minY = Math.max(0, window.innerHeight - 180);
    for (let y = window.innerHeight - 1; y >= minY; y -= 4) {
      const element = document.elementFromPoint(x, y);
      if (element && element.id === 'PBarNextFrame') {
        intercepted = Math.max(intercepted, window.innerHeight - y);
        continue;
      }
      if (intercepted) break;
    }

    return intercepted ? Math.min(120, intercepted + 10) : 0;
  }

  function updateMobileBottomOffset() {
    const offset = measurePreviewBottomOffset();
    document.documentElement.style.setProperty('--bc-mvp-bottom-offset', `${offset}px`);
  }

  function updateCartFabTop(panel) {
    if (window.innerWidth > 900) {
      cartFabDockState = '';
      document.documentElement.style.removeProperty('--bc-mvp-cart-top');
      return;
    }

    const compactTop = 16;
    const gap = 8;

    if (IS_EMBEDDED) {
      document.documentElement.style.setProperty('--bc-mvp-cart-top', `${compactTop}px`);
      return;
    }

    const bar = panel.querySelector('.bc-custom-bundle-mvp__postcode-bar') ||
      document.querySelector('[data-bc-page-postcode-banner], .bc-page-postcode-banner, bc-page-postcode-banner');
    let top = compactTop;
    let dockState = 'compact';

    if (bar instanceof HTMLElement) {
      const rect = bar.getBoundingClientRect();
      if (rect.height > 0 && rect.top < window.innerHeight) {
        const headerTop = Math.max(compactTop, Math.ceil(rect.bottom + gap));
        if (cartFabDockState === 'header') {
          dockState = rect.bottom <= -8 ? 'compact' : 'header';
        } else {
          dockState = rect.bottom > 2 ? 'header' : 'compact';
        }
        top = dockState === 'header' ? headerTop : compactTop;
      }
    }

    cartFabDockState = dockState;
    document.documentElement.style.setProperty('--bc-mvp-cart-top', `${top}px`);
  }

  function requestCartFabTopSync(panel) {
    if (cartFabTopFrame) {
      window.cancelAnimationFrame(cartFabTopFrame);
    }

    cartFabTopFrame = window.requestAnimationFrame(() => {
      cartFabTopFrame = 0;
      updateCartFabTop(panel);
      syncEmbeddedMobileSurface(panel);
    });
  }

  function syncEmbeddedMobileSurface(panel) {
    if (!IS_EMBEDDED || !(panel instanceof HTMLElement)) return;

    const rect = panel.getBoundingClientRect();
    const topBoundary = 64;
    const bottomBoundary = Math.max(topBoundary + 1, window.innerHeight - 96);
    const active = window.innerWidth <= 900 && rect.bottom > topBoundary && rect.top < bottomBoundary;
    const wasCartDocked = panel.classList.contains('is-mobile-cart-docked');
    const cartEnterBoundary = 64;
    const cartExitBoundary = 176;
    const cartBottomBoundary = wasCartDocked ? 32 : topBoundary;
    const cartDocked = window.innerWidth <= 900 &&
      rect.bottom > cartBottomBoundary &&
      rect.top < (wasCartDocked ? cartExitBoundary : cartEnterBoundary);
    panel.classList.toggle('is-mobile-surface-active', active);
    panel.classList.toggle('is-mobile-cart-docked', cartDocked);
    document.documentElement.classList.toggle('bc-custom-bundle-mvp-embedded-surface-active', active);
    panel.dataset.bcMvpMobileSurfaceActive = active ? 'true' : 'false';
    panel.dataset.bcMvpMobileCartDocked = cartDocked ? 'true' : 'false';
    syncCartFab(panel);
  }

  function startEmbeddedSurfaceGeometrySampling(panel) {
    if (!IS_EMBEDDED || panel.__bcMvpSurfaceGeometrySampling) return;

    panel.__bcMvpSurfaceGeometrySampling = true;
    const startedAt = window.performance?.now?.() || Date.now();
    let previousTop = null;
    let previousBottom = null;

    const sample = () => {
      if (!panel.isConnected) {
        document.documentElement.classList.remove('bc-custom-bundle-mvp-embedded-surface-active');
        panel.__bcMvpSurfaceGeometrySampling = false;
        return;
      }

      const now = window.performance?.now?.() || Date.now();
      if (now - startedAt > 8000) {
        panel.__bcMvpSurfaceGeometrySampling = false;
        return;
      }

      const rect = panel.getBoundingClientRect();
      if (previousTop === null || Math.abs(rect.top - previousTop) > 0.5 || Math.abs(rect.bottom - previousBottom) > 0.5) {
        previousTop = rect.top;
        previousBottom = rect.bottom;
        requestCartFabTopSync(panel);
      }
      window.setTimeout(sample, 120);
    };

    sample();
  }

  function handleMvpResize(panel) {
    updateMobileBottomOffset();
    requestCartFabTopSync(panel);
    requestCardRowSync(panel);
  }

  function openPostcodeChecker(panel) {
    if (typeof window.bcDcOpenLightbox === 'function') {
      window.bcDcOpenLightbox('');
      return;
    }
    if (typeof window.openShippingChecker === 'function') {
      window.openShippingChecker();
      return;
    }

    const nativePill = document.querySelector('[data-bc-page-postcode-banner] [data-bc-pill], #recharge-bundles [data-bc-pill]');
    if (nativePill instanceof HTMLElement) {
      nativePill.click();
      return;
    }

    setStatus(panel, 'Delivery checker is still loading. Please try again in a moment.', 'error');
  }

  function isPostcodeCheckerOpen() {
    const lightbox = document.querySelector('.bc-dc-lightbox.is-open[aria-hidden="false"]');
    if (lightbox instanceof HTMLElement) return true;

    return Array.from(document.querySelectorAll('#input_postcode, #delivery-zip-code')).some((input) => {
      if (!(input instanceof HTMLElement)) return false;
      const rect = input.getBoundingClientRect();
      const styles = window.getComputedStyle(input);
      return rect.width > 0 && rect.height > 0 && styles.display !== 'none' && styles.visibility !== 'hidden';
    });
  }

  function schedulePostcodeCheckerAutoOpen(panel) {
    if (!shouldAutoOpenPostcodeChecker() || panel.dataset.bcMvpPostcodeAutoOpenScheduled === 'true') return;
    panel.dataset.bcMvpPostcodeAutoOpenScheduled = 'true';
    window.__bcDcPendingOpen = true;

    [250, 700, 1400, 2600, 4400].forEach((delay) => {
      window.setTimeout(() => {
        if (isPostcodeCheckerOpen()) {
          window.__bcDcPendingOpen = false;
          setStatus(panel, '', 'info');
          return;
        }

        openPostcodeChecker(panel);
        if (isPostcodeCheckerOpen()) {
          window.__bcDcPendingOpen = false;
          setStatus(panel, '', 'info');
        }
      }, delay);
    });
  }

  function bindShellControls(panel) {
    updateMobileBottomOffset();
    updateCartFabTop(panel);
    syncEmbeddedMobileSurface(panel);
    installCustomBundleDraftLifecycleHandlers(panel);
    scheduleProductSourceFallback(panel);

    const cartButton = panel.querySelector('[data-bc-mvp-cart-toggle]');
    if (cartButton instanceof HTMLButtonElement) {
      cartButton.addEventListener('click', () => {
        state.cartOpen = true;
        state.cartEmptyStateOpen = false;
        renderState(panel, { productGrid: 'skip' });
      });
    }
    syncCartFab(panel);

    panel.querySelectorAll('[data-bc-mvp-postcode]').forEach((postcodeButton) => {
      postcodeButton.addEventListener('click', () => openPostcodeChecker(panel));
    });

    schedulePostcodeCheckerAutoOpen(panel);

    [250, 1200, 2600].forEach((delay) => {
      window.setTimeout(() => removeDuplicatePostcodeBar(panel), delay);
    });

    [400, 1200, 2600].forEach((delay) => {
      window.setTimeout(() => syncNativeFrequencyOptions(panel), delay);
    });

    [400, 1200, 2600, 5000, 8000].forEach((delay) => {
      window.setTimeout(() => syncProductDisplayData(panel), delay);
    });

    [250, 1200, 2600].forEach((delay) => {
      window.setTimeout(() => {
        updateMobileBottomOffset();
        updateCartFabTop(panel);
      }, delay);
    });

    if (!panel.__bcMvpResizeBound) {
      panel.__bcMvpResizeBound = true;
      window.addEventListener('resize', () => handleMvpResize(panel), { passive: true });
      window.addEventListener('scroll', () => {
        requestCartFabTopSync(panel);
      }, { passive: true });
      if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
        document.fonts.ready.then(() => requestCardRowSync(panel)).catch(() => {});
      }
    }

    if (IS_EMBEDDED && typeof ResizeObserver === 'function' && !panel.__bcMvpSurfaceResizeObserver) {
      const surfaceResizeObserver = new ResizeObserver(() => requestCartFabTopSync(panel));
      surfaceResizeObserver.observe(panel);
      if (panel.parentElement) surfaceResizeObserver.observe(panel.parentElement);
      panel.__bcMvpSurfaceResizeObserver = surfaceResizeObserver;
      window.setTimeout(() => {
        surfaceResizeObserver.disconnect();
        if (panel.__bcMvpSurfaceResizeObserver === surfaceResizeObserver) {
          panel.__bcMvpSurfaceResizeObserver = null;
        }
      }, 8000);
    }
    startEmbeddedSurfaceGeometrySampling(panel);

    const sourceRoot = document.getElementById('recharge-bundles') || document.getElementById('bundling-app');
    if (sourceRoot && !panel.__bcMvpProductSourceObserver) {
      panel.__bcMvpProductSourceObserver = new MutationObserver(() => requestProductDisplaySync(panel));
      panel.__bcMvpProductSourceObserver.observe(sourceRoot, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['src', 'srcset', 'aria-label', 'data-recharge-product-id', 'data-recharge-variant-id'],
      });
      scheduleProductSourceObserverDisconnect(panel);
    }

    void requestCustomBundleDraftRestore(panel);
  }

  function hasNativePostcodeBanner() {
    const nativeBanner = document.querySelector('[data-bc-page-postcode-banner], .bc-page-postcode-banner, bc-page-postcode-banner');
    if (!(nativeBanner instanceof HTMLElement)) return false;
    const rect = nativeBanner.getBoundingClientRect();
    const styles = window.getComputedStyle(nativeBanner);
    return rect.width > 0 &&
      rect.height > 0 &&
      styles.display !== 'none' &&
      styles.visibility !== 'hidden' &&
      Number(styles.opacity || '1') > 0;
  }

  function removeDuplicatePostcodeBar(panel) {
    if (!hasNativePostcodeBanner()) return;
    const customBar = panel.querySelector('.bc-custom-bundle-mvp__postcode-bar');
    if (customBar) customBar.remove();
  }

  function renderPostcodeBar() {
    const logoSrc = getSizedProductImageUrl(LOGO_IMAGE_URL, 172);
    const logoSrcset = [
      `${getSizedProductImageUrl(LOGO_IMAGE_URL, 96)} 96w`,
      `${getSizedProductImageUrl(LOGO_IMAGE_URL, 172)} 172w`,
    ].join(', ');

    return `
      <div class="bc-custom-bundle-mvp__postcode-bar" aria-label="Delivery date checker">
        <div class="bc-custom-bundle-mvp__postcode-inner">
          <a href="/" aria-label="Butter and Crust home">
            <img class="bc-custom-bundle-mvp__postcode-logo" src="${escapeHtml(logoSrc)}" srcset="${escapeHtml(logoSrcset)}" sizes="(max-width: 900px) 62px, 86px" width="86" height="43" alt="Butter &amp; Crust" loading="eager" decoding="sync" fetchpriority="high">
          </a>
          <button type="button" class="bc-custom-bundle-mvp__postcode-button" data-bc-mvp-postcode>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
              <circle cx="12" cy="10" r="3"></circle>
            </svg>
            <span>Check Your Delivery Date</span>
          </button>
        </div>
      </div>
    `;
  }

  function renderDesktopIntro() {
    if (IS_EMBEDDED) {
      return '';
    }

    return `
      <div class="bc-custom-bundle-mvp__desktop-intro" aria-label="Bundle delivery checker">
        <h1>Build Your Bundle</h1>
        <button type="button" class="bc-custom-bundle-mvp__desktop-postcode" data-bc-mvp-postcode>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.65" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
            <circle cx="12" cy="10" r="3"></circle>
          </svg>
          <span class="bc-custom-bundle-mvp__desktop-postcode-placeholder">Enter your postcode</span>
          <span class="bc-custom-bundle-mvp__desktop-postcode-action">Check</span>
        </button>
      </div>
    `;
  }

  function renderPanel() {
    if (document.querySelector('[data-bc-custom-bundle-mvp]')) return;

    injectStyles();
    document.documentElement.classList.add('bc-custom-bundle-mvp-active');
    document.documentElement.classList.toggle('bc-custom-bundle-mvp-embedded', IS_EMBEDDED);
    document.documentElement.classList.remove('bc-custom-bundle-mvp-pending');

    const initialShell = document.querySelector('[data-bc-custom-bundle-mvp-shell]');
    const panel = initialShell instanceof HTMLElement ? initialShell : document.createElement('section');
    panel.className = `bc-custom-bundle-mvp${IS_EMBEDDED ? ' bc-custom-bundle-mvp--embedded' : ''}`;
    panel.dataset.bcCustomBundleMvp = 'true';
    panel.dataset.bcMvpEmbedded = IS_EMBEDDED ? 'true' : 'false';
    delete panel.dataset.bcCustomBundleMvpShell;
    panel.removeAttribute('aria-busy');
    panel.removeAttribute('aria-label');
    panel.removeAttribute('inert');
    const postcodeMarkup = IS_EMBEDDED || panel.querySelector('.bc-custom-bundle-mvp__postcode-bar') || hasNativePostcodeBanner() ? '' : renderPostcodeBar();
    const desktopIntroMarkup = isMobileViewport() ? '' : renderDesktopIntro();
    const catalogTag = IS_EMBEDDED ? 'div' : 'main';
    if (initialShell instanceof HTMLElement) {
      const introSlot = panel.querySelector('[data-bc-mvp-shell-intro]');
      if (introSlot instanceof HTMLElement) {
        introSlot.insertAdjacentHTML('beforebegin', `${postcodeMarkup}${desktopIntroMarkup}`);
        introSlot.remove();
      }
      const cartFabSlot = panel.querySelector('[data-bc-mvp-cart-fab]');
      if (cartFabSlot instanceof HTMLElement && !cartFabSlot.firstElementChild) {
        cartFabSlot.innerHTML = renderCartFabShell();
      }
    } else {
      panel.innerHTML = `
        ${postcodeMarkup}
        ${desktopIntroMarkup}
        <div class="bc-custom-bundle-mvp__layout">
          <${catalogTag} class="bc-custom-bundle-mvp__catalog">
            <div data-bc-mvp-category-nav></div>
            <div data-bc-mvp-grid></div>
          </${catalogTag}>
          <div data-bc-mvp-summary-wrap></div>
        </div>
        <div data-bc-mvp-sheet></div>
        <div data-bc-mvp-rewards-modal></div>
        <div data-bc-mvp-gift-picker></div>
        <div data-bc-mvp-cart-fab>${renderCartFabShell()}</div>
        <div data-bc-mvp-cart-sheet></div>
      `;
    }

    if (initialShell instanceof HTMLElement) {
      // The server-rendered first-paint shell already occupies the final layout slot.
    } else if (IS_EMBEDDED) {
      EMBED_MOUNT.replaceChildren(panel);
    } else {
      const target = document.getElementById('recharge-bundles') ||
        document.getElementById('bundling-app') ||
        document.querySelector('main');
      if (target && target.parentNode) {
        target.parentNode.insertBefore(panel, target);
      } else {
        document.body.insertBefore(panel, document.body.firstChild);
      }
    }
    bindShellControls(panel);
    // Native delivery owns the Add-to-cart drawer, so load its controller while the
    // customer is still building rather than making the first Add wait for the module.
    warmBundleCartFlowScript();
    void warmBuilderCartSnapshot();
    scheduleRechargeSdkWarmup();
    syncProductJsonFrequencyOptions(panel);
    void syncCollectionProductSource(panel);
    if (!syncProductDisplayData(panel)) {
      renderState(panel);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderPanel, { once: true });
  } else {
    renderPanel();
  }
})();
